var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagemoneyAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-248",
    d: "M77.66,200.09c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,145.14,77.66,200.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-248",
    points: "203.82 415.47 322.91 346.93 386.36 383.45 267.27 452 203.82 415.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M41,345.5l123.66,71.39a12.07,12.07,0,0,0,10.92,0L375.08,301.72c3-1.74,3-4.57,0-6.31L251.42,224a12.07,12.07,0,0,0-10.92,0L41,339.19C38,340.93,38,343.76,41,345.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M378.53,284.41a8.82,8.82,0,0,1-4.45-1.2L234.66,202.72a5.44,5.44,0,0,1,0-9.74l94.66-54.65a9.1,9.1,0,0,1,4.63-1.41,7,7,0,0,1,3.5.94l140.22,81a5.63,5.63,0,0,1,0,9.75L383,283.22a8.92,8.92,0,0,1-4.46,1.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M123.44,455.58a7.79,7.79,0,0,1-3.83-.95L53.66,416.55l-.06,0a3.81,3.81,0,0,1-2-3.27,3.93,3.93,0,0,1,2.15-3.31l43.51-25.12a8.27,8.27,0,0,1,7.66,0l65.91,38.05a3.91,3.91,0,0,1,2.15,3.31,3.82,3.82,0,0,1-1.92,3.2,2.46,2.46,0,0,1-.27.17l-32.92,19-10.56,6.1a7.79,7.79,0,0,1-3.83.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M340.16,338.53l62,35.73a6.91,6.91,0,0,0,6.26,0l70-40.4a15.86,15.86,0,0,0,4.93-4.92l2.26-3.91a3.63,3.63,0,0,0-1.32-4.94l-55.92-32.45a6.9,6.9,0,0,0-6.24,0l-81.91,47.29C338.43,335.92,338.43,337.53,340.16,338.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M84.8,372.27a10.8,10.8,0,0,1-1.72,4A19,19,0,0,1,76.65,382c-11.14,6.43-29.19,6.43-40.33,0a19,19,0,0,1-6.43-5.71,11,11,0,0,1-1.71-4h0c-1-4.83,1.73-9.87,8.15-13.58,11.14-6.43,29.19-6.43,40.33,0C83.07,362.4,85.79,367.44,84.8,372.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip-board--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.28,223l-96,55.47a4,4,0,0,1-3.59,0L235.93,197.15a4,4,0,0,1-1.79-3.11v-.42a4,4,0,0,1,1.8-3.11l96-55.44a4,4,0,0,1,3.6,0L476.3,216.32a4,4,0,0,1,1.79,3.11v.42A4,4,0,0,1,476.28,223Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.28,223l-96,55.47a4,4,0,0,1-3.59,0L235.93,197.15a4,4,0,0,1-1.79-3.11v-.42a4,4,0,0,1,1.8-3.11l96-55.44a4,4,0,0,1,3.6,0L476.3,216.32a4,4,0,0,1,1.79,3.11v.42A4,4,0,0,1,476.28,223Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.46,135c-1.36-.79-2.79-.34-4.16.46l-94.65,54.65c-1.37.79-1.38,2.07,0,2.87l139.41,80.49h0a5,5,0,0,0,4.94,0l94.68-54.65a1.65,1.65,0,0,0,0-2.87h0Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.46,135c-1.36-.79-2.79-.34-4.16.46l-94.65,54.65c-1.37.79-1.38,2.07,0,2.87l139.41,80.49h0a5,5,0,0,0,4.94,0l94.68-54.65a1.65,1.65,0,0,0,0-2.87h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.3,216.32l-.61-.36a1.66,1.66,0,0,1,0,2.87L381,273.48a4.91,4.91,0,0,1-2.46.66h-.07v4.74a3.67,3.67,0,0,0,1.83-.44l96-55.47a4,4,0,0,0,1.8-3.11v-.42A3.92,3.92,0,0,0,476.3,216.32Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.3,216.32l-.61-.36a1.66,1.66,0,0,1,0,2.87L381,273.48a4.91,4.91,0,0,1-2.46.66h-.07v4.74a3.67,3.67,0,0,0,1.83-.44l96-55.47a4,4,0,0,0,1.8-3.11v-.42A3.92,3.92,0,0,0,476.3,216.32Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M343.85,142.45c-1.41-.82-2.88-.35-4.29.47L250.1,194.58c-1.41.81-1.42,2.13,0,2.95l125.77,72.61h0a5.09,5.09,0,0,0,5.09,0l89.49-51.65a1.7,1.7,0,0,0,0-3l-1.64-.95Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papet--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,269.4l89.14-51.47a1.67,1.67,0,0,0,.76-1.32v-1a1.67,1.67,0,0,0-.76-1.32L341.38,141a1.72,1.72,0,0,0-1.53,0l-89.14,51.46a1.71,1.71,0,0,0-.76,1.33v1a1.67,1.67,0,0,0,.76,1.32L377.63,269.4A1.72,1.72,0,0,0,379.16,269.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,192.6a2.08,2.08,0,0,0-.21.21l-.08.11a2.1,2.1,0,0,0-.22.42,1.29,1.29,0,0,0-.08.28c0,.06,0,.13,0,.19v1a1.69,1.69,0,0,0,.76,1.32l126.92,73.27a1.48,1.48,0,0,0,.76.19v-2.76a1.58,1.58,0,0,1-.76-.18L250.71,193.37C250.35,193.16,250.3,192.84,250.55,192.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.48,214.44c.23.23.16.54-.18.74l-89.14,51.46a1.47,1.47,0,0,1-.76.18v2.76a1.49,1.49,0,0,0,.77-.19l89.14-51.46a1.67,1.67,0,0,0,.76-1.32v-1A1.64,1.64,0,0,0,468.48,214.44Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,225.32l-4,2.33c-.26.15-.29.37-.07.5l.06,0a.94.94,0,0,0,.86,0l4.05-2.34c.26-.14.28-.37.06-.49l-.06,0A.94.94,0,0,0,333.64,225.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42,220.24l-4,2.34c-.26.15-.28.37-.06.5l.06,0a1,1,0,0,0,.86,0l4-2.34c.26-.15.29-.37.07-.5l-.06,0A1,1,0,0,0,342.42,220.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.21,215.17l-4,2.34c-.25.15-.28.37-.06.5l.06,0a.94.94,0,0,0,.86,0l4.05-2.33c.25-.15.28-.37.06-.5l-.06,0A1,1,0,0,0,351.21,215.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,210.1l-4,2.34c-.26.14-.29.37-.07.49l.06,0a1,1,0,0,0,.87,0l4-2.33c.26-.15.28-.37.06-.5l-.06,0A.94.94,0,0,0,360,210.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,205l-4,2.33c-.26.15-.28.37-.06.5l.06,0a1,1,0,0,0,.86,0l4-2.33c.26-.15.29-.37.07-.5l-.06,0A1,1,0,0,0,368.78,205Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.56,200l-4.05,2.33c-.25.15-.28.37-.06.5l.06,0a1,1,0,0,0,.86,0l4.05-2.34c.25-.14.28-.37.06-.49l-.06,0A.94.94,0,0,0,377.56,200Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,194.89l-4,2.33c-.26.15-.29.37-.06.5l.05,0a1,1,0,0,0,.87,0l4-2.34c.26-.15.28-.37.06-.5l-.06,0A.94.94,0,0,0,386.34,194.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,189.81l-4.05,2.34c-.25.15-.28.37-.06.5l.06,0a1,1,0,0,0,.86,0l4.05-2.34c.25-.15.28-.37.06-.5l-.06,0A1,1,0,0,0,395.13,189.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.91,184.74l-4.05,2.34c-.25.15-.28.37-.06.5l.06,0a.94.94,0,0,0,.86,0l4-2.33c.25-.15.28-.37.06-.5l-.06,0A1,1,0,0,0,403.91,184.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.48 222.52 324.45 219.65 329.76 222.71 324.79 225.58 319.48 222.52",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.78 214.28 327.76 211.41 338.54 217.64 333.57 220.51 322.78 214.28",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.78 214.28 327.76 211.41 338.54 217.64 333.57 220.51 322.78 214.28",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.74 205.27 329.71 202.4 347.32 212.57 342.35 215.44 324.74 205.27",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.74 205.27 329.71 202.4 347.32 212.57 342.35 215.44 324.74 205.27",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.05 205.71 348.03 202.84 356.11 207.5 351.13 210.37 343.05 205.71",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.05 205.71 348.03 202.84 356.11 207.5 351.13 210.37 343.05 205.71",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.04 199.6 355.01 196.73 364.89 202.43 359.91 205.3 350.04 199.6",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.04 199.6 355.01 196.73 364.89 202.43 359.91 205.3 350.04 199.6",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.77 192.77 360.75 189.9 373.67 197.36 368.69 200.23 355.77 192.77",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.5 191.72 376.48 188.84 382.45 192.29 377.47 195.16 371.5 191.72",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.5 191.72 376.48 188.84 382.45 192.29 377.47 195.16 371.5 191.72",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.38 185.54 383.35 182.67 391.23 187.22 386.25 190.09 378.38 185.54",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.38 185.54 383.35 182.67 391.23 187.22 386.25 190.09 378.38 185.54",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.89 179.75 390.87 176.87 400.01 182.15 395.04 185.03 385.89 179.75",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.8,172.9c0,6.35-7.78,10.24-14.45,11.65-2.45.52-4.46.77-6.24,1-3.53.44-6.33.8-9.91,2.87a11.94,11.94,0,0,0-4.33,4.48c-1.29,2-2.51,3.92-6.47,4.81a35.05,35.05,0,0,1-8.25.56c-4.15-.06-8.44-.12-12.61,2.29-7,4-8,12.6-8.19,18.71h1c.18-6,1.2-14.44,7.89-18.3,3.85-2.23,7.74-2.17,11.86-2.12a36.15,36.15,0,0,0,8.65-.59c4.39-1,5.69-3,7.06-5.16a11.42,11.42,0,0,1,4.09-4.27c3.37-2,5.9-2.27,9.4-2.71,1.81-.23,3.86-.49,6.37-1,7-1.47,15.13-5.55,15.13-12.21Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.8,172.9c0,6.35-7.78,10.24-14.45,11.65-2.45.52-4.46.77-6.24,1-3.53.44-6.33.8-9.91,2.87a11.94,11.94,0,0,0-4.33,4.48c-1.29,2-2.51,3.92-6.47,4.81a35.05,35.05,0,0,1-8.25.56c-4.15-.06-8.44-.12-12.61,2.29-7,4-8,12.6-8.19,18.71h1c.18-6,1.2-14.44,7.89-18.3,3.85-2.23,7.74-2.17,11.86-2.12a36.15,36.15,0,0,0,8.65-.59c4.39-1,5.69-3,7.06-5.16a11.42,11.42,0,0,1,4.09-4.27c3.37-2,5.9-2.27,9.4-2.71,1.81-.23,3.86-.49,6.37-1,7-1.47,15.13-5.55,15.13-12.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12,233.07a2.34,2.34,0,0,1-.74.06c-.34,0-.42-.18-.19-.32l77.13-44.62a2,2,0,0,1,1-.17c.34,0,.42.18.19.31L334.41,233A1.58,1.58,0,0,1,334.12,233.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,234.76a2.28,2.28,0,0,1-.73.06c-.34,0-.42-.18-.19-.32l77.13-44.62a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-77.13,44.62A1,1,0,0,1,337,234.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,236.45a2.32,2.32,0,0,1-.74.06c-.33,0-.42-.18-.18-.32l77.13-44.62a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-77.13,44.62A1,1,0,0,1,340,236.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,195.34a2.08,2.08,0,0,1-.74.06c-.34,0-.42-.18-.19-.31l39.62-22.87a2,2,0,0,1,1-.18c.33,0,.42.18.18.32l-39.61,22.87A1.6,1.6,0,0,1,268.58,195.34Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.55,197.06a2.08,2.08,0,0,1-.74.06c-.34,0-.42-.18-.19-.31L330,162.5a2,2,0,0,1,1-.18c.34,0,.43.18.19.32L271.84,197A1.6,1.6,0,0,1,271.55,197.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,200.49a2.06,2.06,0,0,1-.74.06c-.34,0-.42-.18-.19-.31l35.66-20.59a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-35.66,20.59A1.36,1.36,0,0,1,277.49,200.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,202.2a2.06,2.06,0,0,1-.74.06c-.34,0-.42-.17-.19-.31l35.66-20.58a1.89,1.89,0,0,1,1-.18c.34,0,.42.18.19.32l-35.66,20.58A1,1,0,0,1,280.46,202.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.43,203.92a2.06,2.06,0,0,1-.74.06c-.33,0-.42-.18-.18-.31l35.65-20.59a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-35.66,20.59A1.18,1.18,0,0,1,283.43,203.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,205.63a2.33,2.33,0,0,1-.74.07c-.33,0-.42-.18-.18-.32l35.65-20.58a1.89,1.89,0,0,1,1-.18c.34,0,.42.18.19.32L286.7,205.52A1,1,0,0,1,286.4,205.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,207.35a2.06,2.06,0,0,1-.74.06c-.33,0-.42-.18-.18-.31l35.65-20.59a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-35.65,20.59A1.46,1.46,0,0,1,289.37,207.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,209.06a2,2,0,0,1-.73.07c-.34,0-.43-.18-.19-.32l35.65-20.58a1.91,1.91,0,0,1,1-.18c.34,0,.42.18.19.32L292.64,209A1,1,0,0,1,292.34,209.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,210.78a2,2,0,0,1-.73.06c-.34,0-.42-.18-.19-.31L330,189.94a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-35.65,20.59A1.46,1.46,0,0,1,295.31,210.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,176.64a2.06,2.06,0,0,1-.74.06c-.33,0-.42-.18-.18-.31l35.65-20.59a2,2,0,0,1,1-.17c.34,0,.42.18.19.31l-35.65,20.59A1.46,1.46,0,0,1,318.81,176.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.78,178.36a2.28,2.28,0,0,1-.73.06c-.34,0-.43-.18-.19-.32l35.65-20.58a1.91,1.91,0,0,1,1-.17c.34,0,.42.17.19.31l-35.65,20.58A1,1,0,0,1,321.78,178.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.75,180.07a2,2,0,0,1-.73.06c-.34,0-.42-.18-.19-.31l35.65-20.59a2,2,0,0,1,1-.17c.34,0,.42.18.19.31L325.05,180A1.46,1.46,0,0,1,324.75,180.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,181.79a2.34,2.34,0,0,1-.74.06c-.34,0-.42-.18-.19-.32L362.45,161a1.92,1.92,0,0,1,1-.17c.34,0,.43.17.19.31L328,181.67A1.1,1.1,0,0,1,327.73,181.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,183.5a2.08,2.08,0,0,1-.74.06c-.34,0-.42-.18-.19-.31l35.65-20.59a2,2,0,0,1,1-.17c.34,0,.43.18.19.32L331,183.39A1.6,1.6,0,0,1,330.7,183.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.67,185.22a2.34,2.34,0,0,1-.74.06c-.34,0-.42-.18-.19-.32l35.65-20.58a2,2,0,0,1,1-.17c.33,0,.42.18.18.31L334,185.1A1.1,1.1,0,0,1,333.67,185.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,186.93a2.08,2.08,0,0,1-.74.06c-.34,0-.42-.18-.19-.31l35.66-20.59a2,2,0,0,1,1-.17c.33,0,.42.18.18.32l-35.65,20.58A1.6,1.6,0,0,1,336.64,186.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,213.81a.26.26,0,0,1,.14,0,.25.25,0,0,1,.13,0l.34.2a.24.24,0,0,1,.09.08l.08.12,1.56,2.36a.11.11,0,0,1,0,.08s0,0-.05.08l-.43.25a.23.23,0,0,1-.14,0,.21.21,0,0,1-.14,0l-.05,0-1.56-2.37-1.62,1a.29.29,0,0,1-.14,0,.32.32,0,0,1-.14,0l-.36-.22a.08.08,0,0,1,0-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.14,212.62l.22.12.24.15.25.14.21.13a2.67,2.67,0,0,1,.46.39.74.74,0,0,1,.21.4.61.61,0,0,1-.13.43,1.64,1.64,0,0,1-.53.44,2.64,2.64,0,0,1-.75.32,2.5,2.5,0,0,1-.71.08,2.22,2.22,0,0,1-.68-.13,4.06,4.06,0,0,1-.65-.27l-.46-.26-.43-.27a2.78,2.78,0,0,1-.47-.39.77.77,0,0,1-.21-.41.59.59,0,0,1,.12-.43,1.5,1.5,0,0,1,.52-.45,2.82,2.82,0,0,1,.75-.32,2.58,2.58,0,0,1,1.39.05A3.11,3.11,0,0,1,410.14,212.62ZM409,214.39a2.19,2.19,0,0,0,.76.23,1.2,1.2,0,0,0,.71-.18c.24-.14.35-.29.31-.43a.85.85,0,0,0-.39-.45l-.43-.26-.44-.25a2,2,0,0,0-.75-.24,1.21,1.21,0,0,0-.72.18c-.24.15-.35.29-.31.43a.88.88,0,0,0,.4.45l.42.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,211a1.34,1.34,0,0,1,.39-.16,1.65,1.65,0,0,1,.38-.05,1.34,1.34,0,0,1,.35,0,1.1,1.1,0,0,1,.29.1l.3.17.27.17a.62.62,0,0,1,.18.18.37.37,0,0,1,.06.21.35.35,0,0,1-.09.22.84.84,0,0,1-.28.23,1.43,1.43,0,0,1-.38.17,1.73,1.73,0,0,1-.38.05,1.34,1.34,0,0,1-.35,0,1.1,1.1,0,0,1-.29-.1l-.3-.17-.28-.17a.58.58,0,0,1-.17-.18.26.26,0,0,1-.06-.21.4.4,0,0,1,.08-.22A1,1,0,0,1,410.05,211Zm2.19-1.15a.14.14,0,0,1,0-.09s0,0,.09-.08l.31-.19.11,0a.18.18,0,0,1,.11,0l0,0,0,0,.8,3.51a.14.14,0,0,1,0,.09s0,.05-.08.08l-.31.19a.27.27,0,0,1-.12,0,.14.14,0,0,1-.11,0l0,0a0,0,0,0,1,0,0Zm-.75,1.69-.1-.06-.14-.09-.14-.08-.1-.06a.94.94,0,0,0-.24-.06.45.45,0,0,0-.28.08c-.1.06-.14.11-.13.17a.23.23,0,0,0,.11.14.32.32,0,0,0,.08.06l.14.09.14.08.11,0a.73.73,0,0,0,.24.07.52.52,0,0,0,.28-.08c.1-.06.15-.12.13-.17A.22.22,0,0,0,411.49,211.57Zm2.6-.79a1.61,1.61,0,0,1,.39-.16,1.73,1.73,0,0,1,.38-.05,2,2,0,0,1,.35,0,2.09,2.09,0,0,1,.3.11l.29.16.28.18a.58.58,0,0,1,.17.18.25.25,0,0,1,.06.2.43.43,0,0,1-.08.23,1,1,0,0,1-.28.23,1.29,1.29,0,0,1-.39.16,1.33,1.33,0,0,1-.72,0l-.3-.1-.3-.17-.27-.17a1,1,0,0,1-.18-.18.42.42,0,0,1-.06-.21.4.4,0,0,1,.09-.23A1.1,1.1,0,0,1,414.09,210.78Zm1.44.53-.09-.06-.14-.08-.14-.08-.1-.06a.71.71,0,0,0-.25-.06.44.44,0,0,0-.27.08c-.1.06-.15.11-.14.16a.29.29,0,0,0,.11.15l.09.06.14.09.14.08.11,0a.48.48,0,0,0,.24.06.53.53,0,0,0,.28-.07c.1-.06.14-.12.13-.17A.29.29,0,0,0,415.53,211.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.06,211.63a6.16,6.16,0,0,0,1.51,5.7,11.6,11.6,0,0,0,2.88,2.36,18.45,18.45,0,0,0,4,1.72l1.85-2.18a13.77,13.77,0,0,1-2.93-1.26,8.43,8.43,0,0,1-2.12-1.75,4.54,4.54,0,0,1-1.11-4.21,6.54,6.54,0,0,1,3.23-3.8l-2.89-1.73A8.91,8.91,0,0,0,394.06,211.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.64,204.76a25.44,25.44,0,0,0-9.56-.9,20.89,20.89,0,0,0-8.63,2.62l2.89,1.73a15.33,15.33,0,0,1,6.38-1.93,18.49,18.49,0,0,1,7.06.66,13.18,13.18,0,0,1,2.94,1.27,8.37,8.37,0,0,1,2.12,1.74,4.54,4.54,0,0,1,1.11,4.21,6.63,6.63,0,0,1-3.23,3.81,15.48,15.48,0,0,1-6.38,1.93,18.76,18.76,0,0,1-7.07-.67l-1.85,2.18a25.44,25.44,0,0,0,9.56.9,20.93,20.93,0,0,0,8.63-2.62,9,9,0,0,0,4.39-5.14,6.15,6.15,0,0,0-1.51-5.7,11.41,11.41,0,0,0-2.88-2.37A18.45,18.45,0,0,0,416.64,204.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.69,234.52a.86.86,0,0,1-.22.39,1.92,1.92,0,0,1-.48.38,3.39,3.39,0,0,1-.71.32,3,3,0,0,1-.67.14,2.15,2.15,0,0,1-.57,0,1.52,1.52,0,0,1-.44-.14c-.05,0-.07-.05-.07-.08a.16.16,0,0,1,.06-.08l.41-.25a.27.27,0,0,1,.12,0l.17,0,.19,0,.24,0,.28-.09a2.15,2.15,0,0,0,.34-.17.89.89,0,0,0,.39-.38c0-.13,0-.24-.17-.33a.73.73,0,0,0-.53-.08,1.57,1.57,0,0,0-.6.24l-.43.25a.23.23,0,0,1-.14,0,.21.21,0,0,1-.14,0l-.37-.21s-.06-.05-.07-.09v-.09l0-.89-1.42.85a.33.33,0,0,1-.14,0,.26.26,0,0,1-.14,0l-.37-.22a.08.08,0,0,1,0-.16l2.26-1.35a.29.29,0,0,1,.14,0,.32.32,0,0,1,.14,0l.36.22s.07.05.07.08a.38.38,0,0,1,0,.1l0,.92a2.85,2.85,0,0,1,.54-.18,3.35,3.35,0,0,1,.53-.07,1.81,1.81,0,0,1,.52.07,2,2,0,0,1,.48.19,1,1,0,0,1,.37.35A.54.54,0,0,1,376.69,234.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.56,233.64a2.59,2.59,0,0,1-.72.07,2.62,2.62,0,0,1-.68-.12,3.65,3.65,0,0,1-.64-.28l-.46-.26-.44-.27a3.24,3.24,0,0,1-.47-.39.77.77,0,0,1-.21-.41.61.61,0,0,1,.12-.43,1.56,1.56,0,0,1,.53-.45,3.91,3.91,0,0,1,.51-.24l.75.45a1.13,1.13,0,0,0-.62.18c-.24.14-.34.28-.31.42a.86.86,0,0,0,.4.45c.12.09.26.17.42.27l.45.25a1.93,1.93,0,0,0,.75.24,1.11,1.11,0,0,0,.71-.19c.21-.12.31-.24.32-.36l.73.44a2.43,2.43,0,0,1-.4.31A2.91,2.91,0,0,1,378.56,233.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,232.51a.86.86,0,0,0-.4-.45c-.12-.09-.27-.17-.43-.27l-.44-.25a2,2,0,0,0-.75-.24h-.1l-.75-.45.23-.07a2.53,2.53,0,0,1,.72-.08,2.62,2.62,0,0,1,.68.12,4,4,0,0,1,.64.28l.22.13.25.14.24.14.21.14a2.27,2.27,0,0,1,.46.38.77.77,0,0,1,.21.41.58.58,0,0,1-.13.42.57.57,0,0,1-.13.14l-.73-.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.05,229.31a1.67,1.67,0,0,0-.38.06,1.19,1.19,0,0,0-.39.16.8.8,0,0,0-.27.23.37.37,0,0,0-.09.23.42.42,0,0,0,.06.21.59.59,0,0,0,.18.17l.27.18.3.16a1.1,1.1,0,0,0,.29.11,1.34,1.34,0,0,0,.35,0,1.65,1.65,0,0,0,.38,0,1.61,1.61,0,0,0,.39-.16,1.1,1.1,0,0,0,.27-.23.4.4,0,0,0,.09-.23.29.29,0,0,0-.06-.21.59.59,0,0,0-.18-.17l-.27-.18-.3-.17a1.63,1.63,0,0,0-.29-.1A1.34,1.34,0,0,0,379.05,229.31Zm.58.69.09.06a.26.26,0,0,1,.11.15s0,.1-.14.16a.45.45,0,0,1-.28.08,1.05,1.05,0,0,1-.24-.06l-.1-.06-.15-.08-.13-.08-.09-.07a.24.24,0,0,1-.11-.14c0-.05,0-.11.13-.17a.55.55,0,0,1,.28-.08.61.61,0,0,1,.24.07l.11.05.14.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.2,230.12a2.27,2.27,0,0,0,.28.18l.29.16a2.09,2.09,0,0,0,.3.11,1.9,1.9,0,0,0,.35,0,1.73,1.73,0,0,0,.38,0,1.59,1.59,0,0,0,.38-.17.84.84,0,0,0,.28-.23.51.51,0,0,0,.09-.22.39.39,0,0,0-.06-.21,1,1,0,0,0-.18-.18l-.28-.17-.29-.17a1.32,1.32,0,0,0-.3-.1,1.29,1.29,0,0,0-.35,0,1.73,1.73,0,0,0-.38.05,1.65,1.65,0,0,0-.39.17.79.79,0,0,0-.27.23.41.41,0,0,0-.09.22.37.37,0,0,0,.06.21A.77.77,0,0,0,382.2,230.12ZM383,230l-.14-.09-.09-.06a.24.24,0,0,1-.11-.14c0-.05,0-.11.14-.17a.52.52,0,0,1,.28-.08.73.73,0,0,1,.24.07.45.45,0,0,1,.1.05l.14.08.14.09a.17.17,0,0,1,.09.06.21.21,0,0,1,.11.14c0,.05,0,.11-.13.17a.45.45,0,0,1-.28.08.61.61,0,0,1-.24-.07l-.11,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.28,231.89l-.81-3.52v-.09a.24.24,0,0,1,.09-.08l.31-.18a.19.19,0,0,1,.12,0l.11,0,0,0s0,0,0,0l.81,3.52a.19.19,0,0,1,0,.08s0,.06-.08.09l-.31.18a.28.28,0,0,1-.12,0,.2.2,0,0,1-.11,0l0,0A0,0,0,0,1,381.28,231.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,226.83a13.35,13.35,0,0,0-2.93-1.26,18.73,18.73,0,0,0-7.06-.67,15.44,15.44,0,0,0-6.38,1.93l-2.89-1.72a20.89,20.89,0,0,1,8.63-2.62,25.46,25.46,0,0,1,9.56.9,18.45,18.45,0,0,1,4,1.72,11.6,11.6,0,0,1,2.88,2.36l-3.65,1.11A8.49,8.49,0,0,0,385.72,226.83Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.72 236.59 388.62 238.32 388.61 238.32 385.72 236.6 385.72 236.59",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,230.25a6.18,6.18,0,0,0,1.52,5.7,11.27,11.27,0,0,0,2.88,2.37,17.87,17.87,0,0,0,4,1.71,25.31,25.31,0,0,0,9.57.91,20.89,20.89,0,0,0,8.62-2.62l-2.89-1.72a15.43,15.43,0,0,1-6.37,1.92,18.56,18.56,0,0,1-7.07-.66,13.1,13.1,0,0,1-2.93-1.27,8.43,8.43,0,0,1-2.13-1.74,4.57,4.57,0,0,1-1.11-4.21,6.61,6.61,0,0,1,3.23-3.8l-2.89-1.73A9,9,0,0,0,362.06,230.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85,228.58a4.54,4.54,0,0,1,1.11,4.21,6.6,6.6,0,0,1-3.24,3.8l2.9,1.73a9,9,0,0,0,4.39-5.15,6.19,6.19,0,0,0-1.51-5.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.87,254.72a2.38,2.38,0,0,1-.8,0c-.37-.06-.48-.22-.25-.35l78.11-45.2a2,2,0,0,1,1.1-.14c.38.06.49.21.25.35l-78.11,45.2A1.27,1.27,0,0,1,370.87,254.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.29,256.69a2.32,2.32,0,0,1-.79,0c-.38-.06-.49-.22-.25-.36l78.11-45.19a2,2,0,0,1,1.1-.15c.37.06.48.22.24.36l-78.1,45.19A.87.87,0,0,1,374.29,256.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,258.67a2.16,2.16,0,0,1-.8,0c-.37-.05-.48-.21-.25-.35l78.11-45.19a1.92,1.92,0,0,1,1.1-.15c.38.06.49.22.25.35L378,258.56A.94.94,0,0,1,377.72,258.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.92,156.12h0a1.55,1.55,0,0,0,.65-1.43,4.88,4.88,0,0,0-2.2-3.82,1.57,1.57,0,0,0-1.57-.15h0L272.6,171l3.12,5.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.16,173.72l36.76-21.22a4.57,4.57,0,0,1,.65,2.19,1.79,1.79,0,0,1,0,.23l-36.19,20.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,175c0,1.41-1,2-2.21,1.28a4.87,4.87,0,0,1-2.2-3.82c0-1.41,1-2,2.2-1.27A4.86,4.86,0,0,1,276.38,175Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.53,184.74a3.92,3.92,0,0,1-1.94-.5l-6.17-3.56a1.77,1.77,0,0,1-1-1.45,1.42,1.42,0,0,1,.79-1.22l6.63-3.84a.56.56,0,0,1,.76.21.54.54,0,0,1-.2.76L267.76,179c-.14.08-.22.18-.22.26s.13.3.44.48l6.16,3.57a2.76,2.76,0,0,0,2.4.12l18-10.4a10.74,10.74,0,0,0,3.46-3.27,10,10,0,0,1,3.14-3.06,4.59,4.59,0,0,1,2.54-.72,10.66,10.66,0,0,0,5.71-1.52L325.76,155c.15-.09.24-.19.24-.26s-.14-.31-.45-.48l-6.17-3.57a2.79,2.79,0,0,0-2.4-.13l-5.84,3.38a5,5,0,0,0-.57-1l5.86-3.38a3.86,3.86,0,0,1,3.51.12l6.17,3.57a1.74,1.74,0,0,1,1,1.44,1.44,1.44,0,0,1-.79,1.23L310,165.39a11.7,11.7,0,0,1-6.3,1.67,3.75,3.75,0,0,0-1.94.57,9,9,0,0,0-2.78,2.73,11.91,11.91,0,0,1-3.82,3.61l-18,10.4A3.28,3.28,0,0,1,275.53,184.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.53,183.74a4,4,0,0,1-1.94-.49l-6.17-3.57a1.77,1.77,0,0,1-1-1.45,1.43,1.43,0,0,1,.79-1.22l6.63-3.83a.56.56,0,0,1,.56,1L267.76,178c-.14.08-.22.18-.22.25s.13.31.44.49l6.16,3.56a2.76,2.76,0,0,0,2.4.13l18-10.41a10.63,10.63,0,0,0,3.46-3.27,10.09,10.09,0,0,1,3.14-3.06,4.66,4.66,0,0,1,2.54-.71,10.68,10.68,0,0,0,5.71-1.53L325.76,154c.15-.08.24-.18.24-.26s-.14-.3-.45-.48l-6.17-3.57a2.76,2.76,0,0,0-2.4-.12l-5.84,3.37a5,5,0,0,0-.57-1l5.86-3.38a3.86,3.86,0,0,1,3.51.12l6.17,3.58a1.74,1.74,0,0,1,1,1.44,1.44,1.44,0,0,1-.79,1.23L310,164.4a11.79,11.79,0,0,1-6.3,1.67,3.66,3.66,0,0,0-1.94.57,8.93,8.93,0,0,0-2.78,2.72,11.8,11.8,0,0,1-3.82,3.61l-18,10.4A3.17,3.17,0,0,1,275.53,183.74Z",
    style: {
      fill: "#455a64"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.77,333.89c0,3.09,2.32,5.07,5.17,6.71l116.82,67.45a11.38,11.38,0,0,0,10.32,0L364.55,299.24c2.85-1.64,5.16-3.76,5.16-6.85s-2.31-5-5.16-6.64L247.72,218.3a11.38,11.38,0,0,0-10.32,0L48.93,327.11C46.08,328.76,43.77,330.8,43.77,333.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.93,333.07l116.83,67.45a11.44,11.44,0,0,0,10.32,0L364.55,291.71c2.85-1.65,2.85-4.32,0-6L247.72,218.3a11.38,11.38,0,0,0-10.32,0L48.93,327.11C46.08,328.76,46.08,331.42,48.93,333.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,401.76v7.52a10.55,10.55,0,0,1-5.16-1.22L48.93,340.6c-2.84-1.64-5.16-3.62-5.16-6.71,0-2.89,2.08-4.91,4.76-6.55-2.21,1.56-2.25,4.19.4,5.73l116.83,67.45A10.45,10.45,0,0,0,170.92,401.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,328l173.2-100a5.37,5.37,0,0,1,4.86,0l6.31,3.53c1.35.78,1.35,2,0,2.81L76,334.32a5.4,5.4,0,0,1-4.86,0l-6.29-3.52C63.53,330,63.53,328.76,64.87,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.88,338,255.07,238a5,5,0,0,1,4.45-.25l45.08,26c1.11.64.92,1.79-.42,2.57l-173,99.85a5,5,0,0,1-4.45.25l-45.27-25.9C80.35,339.94,80.54,338.79,81.88,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,280l5.42-3.13c.23-.13.25-.33,0-.45l-5.18-3a.92.92,0,0,0-.79,0L226,276.6c-.23.13-.25.34-.05.46l5.19,3A.85.85,0,0,0,232,280ZM224,269.19l-5.42,3.13c-.23.14-.26.34-.05.46l5.19,3a.86.86,0,0,0,.78,0l5.43-3.14c.23-.13.25-.33,0-.45l-5.18-3A.92.92,0,0,0,224,269.19Zm-17.52,10.12-9.18,5.29c-.23.14-.25.34,0,.46l5.18,3a.88.88,0,0,0,.79,0l9.18-5.3c.23-.13.25-.34,0-.46l-5.18-3A.85.85,0,0,0,206.52,279.31Zm9.59-5.54-5.42,3.13c-.23.13-.25.33-.05.45l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.45l-5.19-3A.85.85,0,0,0,216.11,273.77Zm-21.27,12.28-5.42,3.13c-.23.13-.25.34,0,.45l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33,0-.45l-5.18-3A.88.88,0,0,0,194.84,286.05Zm-7.93,4.58-5.42,3.13c-.23.13-.25.33-.05.45l5.19,3a.92.92,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3A.85.85,0,0,0,186.91,290.63Zm20.34,12.22,5.42-3.13c.23-.14.25-.34.05-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34,0,.46l5.19,3A.88.88,0,0,0,207.25,302.85Zm-7.93,4.57,5.43-3.13c.23-.13.25-.33,0-.45l-5.19-3a.86.86,0,0,0-.78,0L193.39,304c-.23.13-.25.34,0,.45l5.18,3A.85.85,0,0,0,199.32,307.42ZM191.4,312l5.42-3.13c.23-.14.25-.34.05-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3A.92.92,0,0,0,191.4,312Zm-7.93,4.57,5.42-3.13c.23-.13.26-.33.05-.45l-5.19-3a.89.89,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.34,0,.46l5.18,3A.85.85,0,0,0,183.47,316.57Zm40.56-32,5.42-3.13c.23-.13.25-.34.05-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45l5.19,3A.88.88,0,0,0,224,284.6Zm-8.86,13.67,12.1-7c.23-.14.25-.34,0-.46l-12.6-7.27a.85.85,0,0,0-.79,0l-6.26,3.61c-.23.13-.25.33,0,.45l6.67,3.85c.2.12.18.33-.05.46l-5,2.89c-.23.13-.25.33,0,.45l5.19,3A.86.86,0,0,0,215.17,298.27ZM179,295.2l-5.42,3.13c-.23.13-.26.34,0,.46l5.19,3a.83.83,0,0,0,.78,0l5.43-3.13c.23-.13.25-.33,0-.45l-5.18-3A.92.92,0,0,0,179,295.2Zm-7.93,4.58-5.42,3.13c-.23.13-.25.33,0,.45l5.19,3a.88.88,0,0,0,.79,0L177,303.2c.23-.13.25-.34,0-.45l-5.19-3A.85.85,0,0,0,171.06,299.78Zm-43.85,48.85a.83.83,0,0,0,.78,0l5.43-3.13c.23-.13.25-.33,0-.45l-5.18-3a.92.92,0,0,0-.79,0l-5.42,3.13c-.24.13-.26.34,0,.46Zm-19.55-12.25-5.42,3.13c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3A.88.88,0,0,0,107.66,336.38Zm10,9.18a.92.92,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34,0-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45Zm21.87,4.91,5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3a.92.92,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.46l5.19,3A.85.85,0,0,0,139.58,350.47Zm-8.72,4.61a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45Zm-15.27-23.27-5.43,3.13c-.23.13-.25.33,0,.45l5.18,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.26-.34,0-.46l-5.19-3A.83.83,0,0,0,115.59,331.81Zm39.62-22.88-5.42,3.13c-.23.13-.25.34,0,.45l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.45l-5.19-3A.88.88,0,0,0,155.21,308.93Zm-31.7,18.3-5.42,3.13c-.23.13-.25.34,0,.46l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3A.92.92,0,0,0,123.51,327.23Zm39.63-22.88-5.42,3.13c-.24.14-.26.34-.05.46l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.14.25-.34,0-.46l-5.18-3A.88.88,0,0,0,163.14,304.35Zm-15.85,9.15-5.43,3.13c-.23.14-.25.34,0,.46l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.14.25-.34,0-.46l-5.19-3A.86.86,0,0,0,147.29,313.5Zm-7.93,4.58-5.42,3.13c-.23.13-.25.34-.05.45l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3A.88.88,0,0,0,139.36,318.08Zm-7.92,4.58L126,325.79c-.23.13-.25.33,0,.45l5.18,3a.92.92,0,0,0,.79,0l5.43-3.13c.23-.13.25-.34,0-.46l-5.19-3A.83.83,0,0,0,131.44,322.66Zm36.18,3.07,5.42-3.14c.23-.13.25-.33.05-.45l-5.19-3a.92.92,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34,0,.46l5.18,3A.88.88,0,0,0,167.62,325.73Zm73.94-66.65-5.43,3.13c-.23.13-.25.33,0,.45l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.13.25-.34,0-.46l-5.19-3A.83.83,0,0,0,241.56,259.08Zm-9.6,5.54-5.42,3.13c-.23.13-.25.33,0,.45l5.19,3a.92.92,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.46l-5.19-3A.85.85,0,0,0,232,264.62Zm17.52-10.12-5.42,3.13c-.23.13-.25.34-.05.46l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3A.92.92,0,0,0,249.48,254.5Zm-43.8,40.7,5.42-3.13c.23-.14.25-.34.05-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3A.88.88,0,0,0,205.68,295.2Zm52.52-45.3a.85.85,0,0,0-.79,0L252,253.06c-.23.13-.26.33-.05.45l5.19,3a.89.89,0,0,0,.78,0l5.43-3.13c.23-.13.25-.34,0-.46Zm-82.65,71.25L181,318c.23-.13.25-.34.05-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33-.05.45l5.19,3A.92.92,0,0,0,175.55,321.15ZM272.74,265l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3A.88.88,0,0,0,272.74,265Zm-15.34.29,5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.46l5.19,3A.85.85,0,0,0,257.4,265.33Zm8.21-11.15a.88.88,0,0,0-.79,0l-5.42,3.14c-.23.13-.25.33,0,.45l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46Zm1.67-1,12.59,7.28a.88.88,0,0,0,.79,0l5.42-3.13c.24-.13.26-.34.05-.45l-12.6-7.28a.88.88,0,0,0-.79,0l-5.42,3.13C267.09,252.89,267.07,253.1,267.28,253.21ZM249,263.36l-5.42,3.13c-.23.13-.26.33-.05.45l5.19,3a.89.89,0,0,0,.78,0l5.43-3.13c.23-.13.25-.34,0-.46l-5.18-3A.85.85,0,0,0,249,263.36Zm-59.65,34.43-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.18-3A.88.88,0,0,0,189.32,297.79ZM264,269.64a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.26-.33,0-.45l-5.19-3a.86.86,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.34,0,.45Zm-66.78,23.58-5.42,3.13c-.23.13-.25.34,0,.45l5.18,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.26-.34.05-.45l-5.19-3A.88.88,0,0,0,197.24,293.22Zm-62.11,50.84a.92.92,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0L130,340.6c-.23.14-.25.34-.05.46Zm-9.21-9.66-5.43,3.13c-.23.13-.25.34,0,.46l5.18,3a.85.85,0,0,0,.79,0l5.43-3.13c.23-.13.25-.33,0-.45l-5.19-3A.86.86,0,0,0,125.92,334.4Zm17.92,5.05,5.43-3.13c.23-.13.25-.34,0-.45l-5.18-3a.88.88,0,0,0-.79,0L137.92,336c-.23.13-.26.34,0,.45l5.19,3A.83.83,0,0,0,143.84,339.45Zm7.93-4.57,5.42-3.13c.23-.14.25-.34.05-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3A.88.88,0,0,0,151.77,334.88Zm7.93-4.58,5.42-3.13c.23-.13.25-.34,0-.45l-5.18-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33-.05.45l5.19,3A.88.88,0,0,0,159.7,330.3Zm-25.86-.48L128.42,333c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3A.88.88,0,0,0,133.84,329.82Zm7.93-4.57-5.43,3.13c-.23.13-.25.34,0,.45l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.13.25-.34,0-.45l-5.19-3A.86.86,0,0,0,141.77,325.25Zm31.7-18.3-5.42,3.13c-.23.13-.26.33-.05.45l5.19,3a.92.92,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34,0-.46l-5.18-3A.85.85,0,0,0,173.47,307Zm-7.93,4.57-5.42,3.13c-.23.13-.25.34-.05.46l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3A.92.92,0,0,0,165.54,311.52Zm15.85-9.15L176,305.5c-.23.13-.25.34-.05.45l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3A.88.88,0,0,0,181.39,302.37Zm-31.7,18.3-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3A.88.88,0,0,0,149.69,320.67Zm7.93-4.57-5.42,3.13c-.23.13-.26.33,0,.45l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.13.25-.34,0-.45l-5.18-3A.85.85,0,0,0,157.62,316.1ZM147.5,345.9l5.42-3.13c.23-.14.26-.34.05-.46l-5.19-3a.83.83,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.33,0,.45l5.18,3A.92.92,0,0,0,147.5,345.9Zm-41.79-2-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34,0,.45l5.18,3a.88.88,0,0,0,.79,0l5.42-3.13C105.89,344.25,105.91,344,105.71,343.93ZM116,346.52l-5.19-3a.89.89,0,0,0-.78,0l-8.35,4.82c-.23.13-.25.33,0,.45l5.18,3a.88.88,0,0,0,.79,0L116,347C116.23,346.84,116.25,346.64,116,346.52ZM98,338l-5.19-3a.88.88,0,0,0-.79,0l-6.67,3.86c-.23.13-.25.33,0,.45l5.19,3a.92.92,0,0,0,.79,0l6.67-3.85C98.15,338.33,98.17,338.13,98,338Zm5.11-2.95a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.26-.34,0-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45Zm22.46,14.53-5.19-3a.85.85,0,0,0-.79,0l-10.43,6c-.23.13-.25.33,0,.45l5.19,3a.89.89,0,0,0,.78,0l10.43-6C125.72,349.92,125.74,349.71,125.54,349.59ZM129.2,356l-5.19-3a.88.88,0,0,0-.79,0l-6.67,3.86c-.24.13-.26.33,0,.45l5.19,3a.89.89,0,0,0,.78,0l6.68-3.86C129.38,356.36,129.4,356.16,129.2,356ZM162,301a.92.92,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33-.05.45Zm-15.85,9.15a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34,0-.46l-5.19-3a.85.85,0,0,0-.79,0L141,306.74c-.23.13-.25.33-.05.45ZM111,330.48a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33,0-.45l-5.19-3a.92.92,0,0,0-.79,0L105.87,327c-.23.13-.25.34-.05.46Zm43.07-24.87a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.26-.33.05-.45l-5.19-3a.89.89,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.34,0,.46Zm-15.85,9.15a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34.05-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34,0,.46Zm-5.14,41.6a.85.85,0,0,0-.79,0L124,361.2c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0l8.34-4.82c.23-.13.25-.34,0-.45Zm-6.23-35a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34,0,.45Zm-7.93,4.58a.92.92,0,0,0,.79,0l5.42-3.13c.23-.14.26-.34,0-.46l-5.19-3a.86.86,0,0,0-.78,0l-5.43,3.14c-.23.13-.25.33,0,.45Zm161-54.32a.83.83,0,0,0-.78,0l-13.35,7.7c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0L285.06,275c.23-.13.25-.34,0-.46ZM262.4,281.7a.92.92,0,0,0-.79,0l-5.42,3.13c-.24.14-.26.34-.05.46l5.19,3a.83.83,0,0,0,.78,0l5.43-3.13c.23-.13.25-.33,0-.45Zm-107,59.62,5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.45l5.19,3A.85.85,0,0,0,155.43,341.32Zm91.11-50.46a.86.86,0,0,0-.78,0L240.33,294c-.23.14-.25.34,0,.46l5.19,3a.86.86,0,0,0,.78,0l5.43-3.13c.23-.14.25-.34,0-.46ZM287.84,267a.92.92,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.46l5.19,3a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33,0-.45ZM301,265.43l-12.6-7.27a.83.83,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.33,0,.45l12.6,7.28a.89.89,0,0,0,.78,0l5.43-3.13C301.14,265.76,301.16,265.55,301,265.43Zm-84,42.52a.92.92,0,0,0-.79,0l-6.67,3.85c-.23.14-.25.34-.05.46l5.19,3a.88.88,0,0,0,.79,0l6.67-3.86c.23-.13.25-.33.05-.45Zm20-11.56a.92.92,0,0,0-.79,0l-8.34,4.82c-.23.13-.25.33,0,.45l5.19,3a.88.88,0,0,0,.79,0l8.34-4.82c.23-.13.25-.33,0-.45Zm-38.37,22.16a.85.85,0,0,0-.79,0l-44.63,25.77c-.23.13-.26.33,0,.45l5.19,3a.89.89,0,0,0,.78,0L203.72,322c.23-.13.25-.34,0-.45Zm-47.14,27.21a.92.92,0,0,0-.79,0L144,349.64c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0l6.67-3.86c.23-.13.25-.33,0-.45Zm56.31-32.51a.88.88,0,0,0-.79,0l-6.67,3.85c-.23.14-.25.34,0,.46l5.19,3a.88.88,0,0,0,.79,0l6.67-3.86c.23-.13.25-.33.05-.45Zm-65.49,37.81a.86.86,0,0,0-.78,0l-6.68,3.85c-.23.14-.25.34,0,.46l5.18,3a.88.88,0,0,0,.79,0l6.67-3.86c.24-.13.26-.33,0-.45Zm83.85-48.4a.88.88,0,0,0-.79,0l-6.68,3.86c-.23.13-.25.33,0,.45l5.19,3a.89.89,0,0,0,.78,0l6.68-3.85c.23-.14.25-.34,0-.46Zm28.36-16.38a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45l5.19,3a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.46Zm17.75-12.39,5.42-3.13c.24-.13.26-.34.05-.45l-5.19-3a.83.83,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.33,0,.45l5.19,3A.86.86,0,0,0,272.22,273.89Zm-32.34,1.56,5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0L234,272c-.23.13-.25.33,0,.45l5.18,3A.92.92,0,0,0,239.88,275.45Zm-21,29.27,15.85-9.15c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0l-15.85,9.15c-.23.14-.25.34-.05.46l5.19,3A.88.88,0,0,0,218.83,304.72Zm44.68-26.23a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0L258.37,275c-.23.14-.25.34-.05.46Zm-6.62-4.3,5.42-3.13c.23-.14.25-.34,0-.46l-5.18-3a.88.88,0,0,0-.79,0L251,270.77c-.23.13-.25.33-.05.45l5.19,3A.92.92,0,0,0,256.89,274.19Zm-46,35.1,5.43-3.13c.23-.13.25-.33,0-.45l-5.18-3a.88.88,0,0,0-.79,0L205,305.87c-.23.13-.26.34,0,.45l5.19,3A.83.83,0,0,0,210.9,309.29ZM246,288.61a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.45l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34,0,.45Zm-74.71,43.56L176.7,329c.23-.13.25-.34.05-.45l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34,0,.45l5.19,3A.88.88,0,0,0,171.28,332.17Zm7.92-4.57,5.43-3.13c.23-.14.25-.34,0-.46l-5.19-3a.89.89,0,0,0-.78,0l-5.43,3.13c-.23.14-.25.34,0,.46l5.19,3A.86.86,0,0,0,179.2,327.6Zm-15.85,9.15,5.43-3.13c.23-.14.25-.34,0-.46l-5.19-3a.86.86,0,0,0-.78,0l-5.43,3.13c-.23.14-.25.34,0,.46l5.18,3A.88.88,0,0,0,163.35,336.75Zm31.7-18.31,5.43-3.13c.23-.13.25-.33,0-.45l-5.18-3a.92.92,0,0,0-.79,0L189.12,315c-.23.13-.25.34,0,.46l5.19,3A.83.83,0,0,0,195.05,318.44ZM187.13,323l5.42-3.13c.23-.13.25-.34,0-.46l-5.19-3a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45l5.19,3A.92.92,0,0,0,187.13,323ZM203,313.87l5.42-3.13c.23-.13.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.14c-.23.13-.25.33-.05.45l5.19,3A.92.92,0,0,0,203,313.87Zm43.25-63.66a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34.05-.46l-1.39-.8a.89.89,0,0,0-.78,0L244.89,249c-.23.13-.25.34,0,.46Zm-39.39,24.94a.86.86,0,0,0,.78,0l5.43-3.13c.23-.14.25-.34,0-.46l-5.18-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.24.14-.26.34,0,.46ZM222.69,266a.86.86,0,0,0,.78,0l5.43-3.13c.23-.14.25-.34,0-.46l-5.18-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.26.34-.05.46Zm-25.53,14.74a.88.88,0,0,0,.79,0l5.42-3.14c.23-.13.25-.33,0-.45l-5.19-3a.92.92,0,0,0-.79,0L192,277.29c-.23.14-.25.34-.05.46Zm17.6-10.16a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.45l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.45Zm-33.45,19.31a.88.88,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34,0,.46Zm7.92-4.57a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34.05-.45l-5.19-3a.83.83,0,0,0-.78,0l-5.43,3.13c-.23.13-.25.33,0,.45Zm41.15-25.95a.92.92,0,0,0,.79,0l5.42-3.13c.23-.14.25-.34,0-.46l-1.38-.79a.86.86,0,0,0-.78,0L229,258.11c-.23.14-.25.34,0,.46Zm23.77-13.73a.88.88,0,0,0,.79,0l5.42-3.13c.23-.13.26-.34.05-.45l-1.38-.8a.85.85,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.33,0,.45Zm10.9,6.29a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-5.19-3a.88.88,0,0,0-.79,0l-5.42,3.13c-.23.13-.25.34-.05.45Zm15.1,17.39,5.42-3.14c.23-.13.25-.33.05-.45l-5.19-3a.92.92,0,0,0-.79,0l-5.42,3.13c-.23.14-.25.34-.05.46l5.19,3A.88.88,0,0,0,280.15,269.32ZM238.3,254.79a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.33.05-.45l-1.38-.8a.85.85,0,0,0-.79,0L237,253.54c-.23.13-.25.33-.05.45Zm-64.92,39.68a.85.85,0,0,0,.79,0l5.42-3.13c.23-.13.25-.34,0-.45l-5.19-3a.88.88,0,0,0-.79,0L168.24,291c-.23.13-.25.34,0,.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "196.08 339.57 197.26 340.25 228.58 358.33 284.27 326.17 285.43 325.51 252.94 306.75 196.08 339.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.56 326.58 252.94 308.92 197.98 340.66 228.58 358.33 283.56 326.58",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.53,327.91c-2.26-1-2.87-2.84-3.09-6L28.31,173.74A10.28,10.28,0,0,1,33.08,165L221.55,56.21c2.85-1.64,4.94-2.54,7.57-.74s2.69,2.8,2.9,6L242.15,209.6a10.24,10.24,0,0,1-4.77,8.71L48.91,327.12C46.06,328.77,44.45,329.25,41.53,327.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,61.43c-.21-3.16-2.7-4.39-5.55-2.76L38,167.49a9.73,9.73,0,0,0-3.53,3.79l-4.92-2.47h0A9.9,9.9,0,0,1,33.08,165L221.54,56.21c2.85-1.65,5-2.56,7.57-.74S231.81,58.27,232,61.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53,327.34c-2.59,1.53-4.24,1.72-7,.56-2.11-.88-2.87-2.83-3.09-6L28.31,173.73a9.27,9.27,0,0,1,1.24-4.92l4.92,2.46h0a9.27,9.27,0,0,0-1.24,4.92L43.36,324.37C43.56,327.3,46.1,328.78,48.53,327.34Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.28,173.16,222.65,68.47c1.71-1,3.2-.25,3.33,1.65l9.45,138.23a6.14,6.14,0,0,1-2.87,5.22L51.19,318.26c-1.71,1-3.2.25-3.33-1.65L38.41,178.38A6.14,6.14,0,0,1,41.28,173.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,173.16a6.14,6.14,0,0,0-2.87,5.22l9.3,135.92L227,210.82a6.19,6.19,0,0,0,2.87-5.23l-9.3-135.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.05,72.75a2.25,2.25,0,0,0-2.21.21L44.38,176a5.84,5.84,0,0,0-2.72,5l9,131.37a2.84,2.84,0,0,0,1.45,2.42c.52.24,3.23,1.6,4,2a1.87,1.87,0,0,0,1.76-.13L236.33,213.5a5.83,5.83,0,0,0,2.71-5l-9-132A2,2,0,0,0,229,74.65C228.4,74.4,225.64,73.05,225.05,72.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.41,178,226.88,74.92c1.62-.93,3-.23,3.16,1.57l9,132.05a5.83,5.83,0,0,1-2.71,5L57.87,316.6c-1.63.93-3.09-.5-3.22-2.3L45.7,182.94A5.83,5.83,0,0,1,48.41,178Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.26,75.5c.59,0,.76.57.79,1.06l9,132.05a4.84,4.84,0,0,1-2.23,4L57.37,315.74a1,1,0,0,1-.53.16c-.6,0-1.13-.75-1.2-1.67l-9-131.36a4.84,4.84,0,0,1,2.23-4L227.37,75.78a1.9,1.9,0,0,1,.89-.28m0-1a2.81,2.81,0,0,0-1.38.41L48.41,178a5.83,5.83,0,0,0-2.71,5L54.65,314.3a2.53,2.53,0,0,0,2.19,2.59,2.1,2.1,0,0,0,1-.29L236.33,213.5a5.83,5.83,0,0,0,2.71-5l-9-132c-.09-1.26-.81-2-1.78-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,314.76l3.87,1.89a3,3,0,0,1-1.28-2.35L46.33,192.18l-4-2,8.34,122.19A2.83,2.83,0,0,0,52.07,314.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,76.47c-.13-1.79-1.54-2.48-3.15-1.55L48.41,178a5.83,5.83,0,0,0-2.71,5l.63,9.24L230.67,85.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230,76.47c-.13-1.79-1.54-2.48-3.15-1.55L48.41,178a5.83,5.83,0,0,0-2.71,5l.63,9.24L230.67,85.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.88,74.92,48.41,178a5.66,5.66,0,0,0-2,2.14l-4-2a5.5,5.5,0,0,1,2-2.1L222.85,73a2.26,2.26,0,0,1,2.2-.22c.57.3,3.19,1.58,3.85,1.89A2.32,2.32,0,0,0,226.88,74.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.28,190.16,41.66,181a5.3,5.3,0,0,1,.73-2.85l4,2a5.2,5.2,0,0,0-.72,2.83l.63,9.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.33 192.18 47.46 208.83 231.81 102.42 230.67 85.74 46.33 192.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.3 190.73 71.35 182.09 71.91 190.38 56.86 199.07 56.3 190.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.06 179.9 75.29 183.18 82.79 178.85 82.57 175.57 75.06 179.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.41 184.97 75.63 188.25 83.14 183.91 82.91 180.63 75.41 184.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.32 173.4 86.54 176.68 94.05 172.35 93.83 169.07 86.32 173.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.66 178.46 86.89 181.74 94.39 177.41 94.17 174.13 86.66 178.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.58 166.9 97.8 170.18 105.31 165.84 105.08 162.56 97.58 166.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.92 171.96 98.15 175.24 105.65 170.91 105.43 167.63 97.92 171.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.35 147.4 131.57 150.68 139.08 146.35 138.85 143.07 131.35 147.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.69 152.47 131.92 155.75 139.42 151.41 139.2 148.13 131.69 152.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.6 140.9 142.83 144.18 150.34 139.85 150.11 136.57 142.6 140.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.95 145.97 143.18 149.25 150.68 144.91 150.46 141.63 142.95 145.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.86 134.4 154.09 137.68 161.59 133.35 161.37 130.07 153.86 134.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.21 139.47 154.43 142.75 161.94 138.41 161.72 135.13 154.21 139.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.83 160.4 127.6 149.57 128.16 157.91 109.4 168.74 108.83 160.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.13 127.9 180.18 119.26 180.74 127.55 165.69 136.24 165.13 127.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.89 117.07 184.11 120.35 191.62 116.02 191.4 112.74 183.89 117.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.23 122.14 184.46 125.42 191.97 121.08 191.74 117.8 184.23 122.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.15 110.57 195.37 113.85 202.88 109.52 202.65 106.24 195.15 110.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.49 115.63 195.72 118.91 203.22 114.58 203 111.3 195.49 115.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.4 104.07 206.63 107.35 214.13 103.01 213.91 99.73 206.4 104.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.75 109.13 206.97 112.41 214.48 108.08 214.26 104.8 206.75 109.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.66 97.57 227.63 91.82 228.2 100.16 218.24 105.91 217.66 97.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.33 192.18 42.28 190.15 43.42 206.83 47.46 208.83 46.33 192.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,113.85l0,.61c.07,1,.84,1.37,1.72.86L217.53,89A3.21,3.21,0,0,0,219,86.3l0-.62c-.06-1-.83-1.36-1.72-.85l-45.58,26.32A3.18,3.18,0,0,0,170.18,113.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,86.3l0-.62c-.06-1-.83-1.36-1.72-.85l-5.9,3.41h0l.28,4.17h0L217.53,89A3.21,3.21,0,0,0,219,86.3Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.9 208.3 224.83 110.8 225.4 119.11 75.22 205.81 81.5 297.82 62.74 308.65 55.9 208.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.22 205.81 93.97 194.99 94.54 203.31 75.79 214.15 75.22 205.81",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.77 272.51 98.52 261.69 99.09 270 80.34 280.84 79.77 272.51",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.34 280.85 99.09 270.02 99.66 278.34 80.91 289.18 80.34 280.85",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.34 280.85 99.09 270.02 99.66 278.34 80.91 289.18 80.34 280.85",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.34 207.51 211.09 196.69 211.66 205 192.91 215.85 192.34 207.51",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.34 207.51 211.09 196.69 211.66 205 192.91 215.85 192.34 207.51",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.91 215.85 211.66 205.03 212.22 213.34 193.48 224.19 192.91 215.85",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.91 215.85 211.66 205.03 212.22 213.34 193.48 224.19 192.91 215.85",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.48 224.19 212.22 213.37 212.79 221.68 194.05 232.52 193.48 224.19",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.48 224.19 212.22 213.37 212.79 221.68 194.05 232.52 193.48 224.19",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.04 151.64 187.79 140.82 190.63 182.51 171.89 193.35 169.04 151.64",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.46 201.67 191.2 190.85 194.04 232.46 175.3 243.3 172.46 201.67",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.38 245 116.13 234.18 116.7 242.49 97.95 253.34 97.38 245",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.38 245 116.13 234.18 116.7 242.49 97.95 253.34 97.38 245",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.09 181.64 150.84 170.82 151.4 179.14 132.66 189.98 132.09 181.64",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.09 181.64 150.84 170.82 151.4 179.14 132.66 189.98 132.09 181.64",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,207.93l-.24.14,6.9,101.11.93-.54,17.83-10.3.92-.52h0L99.82,287.5h0l.93-.54,17.84-10.3.93-.53,17.83-10.3.92-.53L156.12,255l.92-.53,17.83-10.3.93-.53,17.84-10.3.93-.53,17.84-10.3.92-.54,17.84-10.3.92-.53L225.2,110ZM81,297.32,63.16,307.61l-.5-7.31L80.49,290ZM80.42,289,62.59,299.27l-.5-7.31,17.84-10.3Zm-.57-8.35L62,290.93l-.5-7.31,17.84-10.3Zm-.56-8.33L61.45,282.59l-.5-7.31L78.79,265ZM78.72,264l-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.32L77.08,240ZM77,238.92,59.17,249.23l-.49-7.32,17.83-10.29Zm-.57-8.34L58.61,240.89l-.5-7.32,17.83-10.29Zm-.57-8.34L58,232.55l-.5-7.32,17.84-10.29Zm-.57-8.34L57.47,224.21l-.5-7.32L74.81,206.6Zm-.56-8.34L56.9,215.87l-.5-7.31,17.84-10.3Zm25,80.92L81.91,296.77l-.5-7.3,17.84-10.31Zm-.57-8.35-17.84,10.3-.5-7.3,17.84-10.31Zm-.57-8.34-17.84,10.3-.49-7.3,17.83-10.31ZM98,261.45l-17.83,10.3-.5-7.3,17.83-10.31Zm-.57-8.34-17.83,10.3-.5-7.3L97,245.8Zm-.57-8.34-17.83,10.3-.5-7.3,17.84-10.31Zm-.56-8.34L78.5,246.73l-.5-7.3,17.84-10.31Zm-.57-8.34-17.84,10.3-.5-7.3,17.84-10.31Zm-.57-8.34-17.84,10.3-.5-7.3L94.7,212.44Zm-.57-8.34-17.84,10.3-.5-7.3L94.13,204.1Zm-.57-8.34-17.84,10.3-.49-7.3,17.83-10.31Zm-.57-8.34L75.65,205l-.49-7.3L93,187.42Zm25,80.92-17.84,10.29-.5-7.31L118,268.33ZM118,267.3l-17.84,10.3-.5-7.31L117.45,260Zm-.57-8.34-17.84,10.3L99,262l17.84-10.3Zm-.57-8.34L99,260.92l-.5-7.31,17.84-10.3Zm-.57-8.34L98.4,252.58l-.5-7.31L115.74,235Zm-.57-8.34-17.84,10.3-.49-7.31,17.83-10.3Zm-.57-8.34L97.27,235.9l-.5-7.31,17.83-10.3Zm-.57-8.34L96.7,227.56l-.5-7.31L114,210Zm-.57-8.34-17.83,10.3-.5-7.31,17.84-10.3Zm-.56-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34L95,202.54l-.5-7.31,17.84-10.3Zm-.57-8.34L94.42,194.2l-.5-7.31,17.84-10.3Zm25,80.91-17.84,10.3L119,267.8l17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.84-10.3Zm-.56-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34L116,225.07l-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.49-7.31,17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.84-10.3Zm25,80.9L138.2,264.28l-.5-7.31,17.85-10.31Zm-.57-8.34-17.85,10.31-.5-7.31L155,238.32Zm-.57-8.34L137.06,247.6l-.5-7.31L154.41,230Zm-.57-8.34-17.85,10.31L136,232l17.84-10.31Zm-.57-8.34-17.84,10.31-.5-7.31,17.84-10.31Zm-.57-8.34-17.84,10.31-.5-7.31L152.71,205Zm-.56-8.34-17.85,10.3-.5-7.31,17.85-10.3Zm-.57-8.34L134.22,205.9l-.5-7.31,17.85-10.31Zm-.57-8.34-17.85,10.3-.5-7.3L151,179.94Zm-.57-8.34-17.85,10.3-.5-7.3,17.85-10.31Zm-.57-8.34-17.85,10.3-.5-7.31,17.85-10.3Zm-.57-8.34-17.85,10.3-.49-7.3,17.84-10.31Zm25,80.91L157,253.44l-.5-7.31,17.84-10.3Zm-.56-8.34L156.4,245.1l-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31L172,202.47Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.49-7.32,17.83-10.29Zm-.57-8.34L153,195.06l-.5-7.31,17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.32,17.84-10.29Zm-.57-8.34-17.83,10.3-.5-7.32,17.84-10.29Zm-.56-8.34L151.28,170l-.5-7.32,17.84-10.29Zm-.57-8.34-17.84,10.3-.5-7.31,17.84-10.3Zm25,80.91-17.84,10.3-.5-7.31L193.07,225ZM193,224l-17.84,10.3-.49-7.31,17.83-10.3Zm-.57-8.34-17.83,10.3-.5-7.31,17.83-10.3Zm-.57-8.34L174,217.59l-.5-7.31L191.37,200ZM191.3,199l-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.32,17.84-10.29Zm-.57-8.34-17.84,10.3-.5-7.32L189.66,175Zm-.57-8.34-17.84,10.3-.5-7.32,17.84-10.29Zm-.57-8.34-17.84,10.3-.5-7.32,17.84-10.29Zm-.57-8.34-17.84,10.3-.5-7.32L188,149.94Zm-.57-8.34-17.83,10.3-.5-7.32,17.83-10.29Zm-.57-8.34-17.83,10.3-.5-7.31,17.84-10.3Zm25,80.9L194.5,231.78l-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.31-.5-7.31,17.84-10.3Zm-.57-8.34L193.36,215.1l-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.31-.49-7.31,17.83-10.3Zm-.57-8.34-17.84,10.31-.49-7.31,17.83-10.3Zm-.57-8.34-17.83,10.31-.5-7.31L209,172.47Zm-.57-8.34-17.83,10.31-.5-7.32,17.84-10.29Zm-.56-8.34L190.52,173.4l-.5-7.32,17.84-10.29Zm-.57-8.34L190,165.06l-.5-7.32,17.84-10.3Zm-.57-8.34-17.84,10.31-.5-7.32,17.84-10.3Zm-.57-8.34-17.84,10.31-.5-7.32,17.84-10.3Zm-.57-8.34L188.24,140l-.5-7.31,17.84-10.31Zm25,80.91-17.84,10.3-.5-7.31,17.84-10.3Zm-.57-8.34-17.84,10.3-.5-7.31L230,195ZM230,194l-17.85,10.3-.5-7.31,17.85-10.3Zm-.57-8.34-17.85,10.3-.5-7.31,17.85-10.3Zm-.57-8.34L211,187.58l-.5-7.31L228.33,170Zm-.57-8.34-17.85,10.3-.5-7.31,17.85-10.3Zm-.57-8.34-17.85,10.3-.5-7.32,17.85-10.29Zm-.57-8.34-17.85,10.3-.5-7.32L226.62,145Zm-.57-8.34-17.84,10.3-.5-7.32,17.84-10.29Zm-.57-8.34-17.84,10.3-.5-7.32,17.85-10.29Zm-.56-8.34-17.85,10.3-.5-7.32,17.85-10.29Zm-.57-8.34L207,129.2l-.5-7.31,17.85-10.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.25,350.4H33.71L38.42,370h0c.36,2.37,2.1,4.68,5.23,6.49,7.08,4.08,18.57,4.08,25.65,0,3.37-1.95,5.12-4.48,5.28-7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7,363.84a19.57,19.57,0,0,0,2.73-1.91L79,351.45a18.32,18.32,0,0,1-4.61,3.66c-9.6,5.55-25,5.69-34.93.45l1.16-4.67-.36-.49H33.72l4.7,19.6h0c.36,2.37,2.1,4.68,5.23,6.49,5.05,2.91,12.32,3.73,18.65,2.5-11.35.84-19.13-4.12-20.3-8.69-.46-1.82-1.28-5.86-1.28-5.86C50.21,369.25,64.64,369.06,73.7,363.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.62,344.6a9.73,9.73,0,0,1-1.52,3.53,16.86,16.86,0,0,1-5.72,5.08c-9.88,5.7-25.91,5.7-35.79,0a16.86,16.86,0,0,1-5.72-5.08,9.71,9.71,0,0,1-1.51-3.53h0c-.88-4.29,1.54-8.77,7.24-12.05,9.88-5.72,25.91-5.72,35.79,0C80.08,335.83,82.5,340.31,81.62,344.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,348.13a16.86,16.86,0,0,1-5.72,5.08c-9.88,5.7-25.91,5.7-35.79,0a16.86,16.86,0,0,1-5.72-5.08,9.71,9.71,0,0,1-1.51-3.53h0l1.13,7.71c.51,3.11,2.82,6.13,7,8.51,9.42,5.44,24.69,5.44,34.11,0,4.07-2.35,6.38-5.34,6.93-8.4l.06-.39,1.09-7.43A9.73,9.73,0,0,1,80.1,348.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,334.26c-8.24-4.75-21.59-4.75-29.83,0-4.66,2.7-6.68,6.33-6.07,9.84.47,2.7,2.5,5.32,6.07,7.38,8.24,4.76,21.59,4.76,29.83,0,3.57-2.06,5.6-4.68,6.07-7.37C78.08,340.59,76.07,337,71.4,334.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.89,347.37a14.21,14.21,0,0,0,4.68,4.11c8.24,4.76,21.59,4.76,29.83,0a14.11,14.11,0,0,0,4.68-4.12c-.06-2.84-2-5.68-5.73-7.85-7.66-4.43-20.07-4.43-27.72,0C38.86,341.68,37,344.52,36.89,347.37Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,338.51c-3.78-1-4.42-9.22-2.3-17.88,2.06-8.42,8.66-21,10.07-20.77s3.15,14,2.17,23.07C66.8,333.9,61.85,339.54,58.06,338.51Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,338.51c-3.78-1-4.42-9.22-2.3-17.88,2.06-8.42,8.66-21,10.07-20.77s3.15,14,2.17,23.07C66.8,333.9,61.85,339.54,58.06,338.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,312c.67,1.07,1.09,2.89,2.68,2.9,1.28,0,2-1.35,3.1-1.66a3.12,3.12,0,0,1,2.54.76c0-.33,0-.66,0-1a3.87,3.87,0,0,0-2.2-.78,3.18,3.18,0,0,0-1.83.83c-.59.46-1.31,1.15-2.13.81s-1.18-1.53-1.65-2.3a3,3,0,0,0-1-1c-.11.23-.21.46-.31.7A2.13,2.13,0,0,1,59.91,312Zm4.49-3.38c.54-.26.85-.8,1.27-1.21a1.84,1.84,0,0,1,2-.37.15.15,0,0,1,.07,0c0-.29-.07-.58-.11-.86l-.36-.09a2.15,2.15,0,0,0-1.58.35c-.52.37-.81,1-1.37,1.35-1,.59-1.77-.49-2.07-1.3-.13-.36-.23-.74-.35-1.1-.1.19-.21.38-.31.58.07.26.14.52.21.76C62.09,307.83,63.1,309.23,64.4,308.62Zm-.13,10.95a9.33,9.33,0,0,1-2.07,1.35c-2,.56-2.4-2.45-3.64-3.34a2.58,2.58,0,0,0-1.77-.46l-.23.69a2.54,2.54,0,0,1,1,0,2.69,2.69,0,0,1,1.71,1.52c.62,1.12,1.42,2.72,3,2.41a5,5,0,0,0,1.81-1,3.24,3.24,0,0,1,2.64-.71,3.48,3.48,0,0,1,1.48.79c0-.3,0-.59,0-.89a3.78,3.78,0,0,0-1.8-.81A3.45,3.45,0,0,0,64.27,319.57Zm1.19,6.61a3.91,3.91,0,0,0-2.58.34c-.91.45-1.56,1.32-2.5,1.68-2.07.78-2.39-2.21-3.89-2.94a3.09,3.09,0,0,0-1.57-.3l-.09.7a3,3,0,0,1,.6,0,2.77,2.77,0,0,1,2.12,1.65c.73,1.36,1.69,2.46,3.36,1.65.89-.44,1.53-1.25,2.45-1.64a2.89,2.89,0,0,1,3.07.28,4.51,4.51,0,0,1,.58.71c.08-.29.15-.6.22-.9A3.33,3.33,0,0,0,65.46,326.18Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,338.51c3.79,1,8.74-4.61,9.94-15.58a64.7,64.7,0,0,0,.21-9.42c-3.09,2.54-6.19,7.72-6.19,7.72A84.8,84.8,0,0,0,58.34,313a57.31,57.31,0,0,0-2.58,7.68C53.64,329.29,54.28,337.49,58.06,338.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,343.06c-5,3.19-9.63-8.17-12.1-16.75s-.86-31,1.65-32.24c1.77-.87,11.18,19.23,13,29C58.89,330.16,58.94,340.52,55,343.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,343.06c-5,3.19-9.63-8.17-12.1-16.75s-.86-31,1.65-32.24c1.77-.87,11.18,19.23,13,29C58.89,330.16,58.94,340.52,55,343.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.23,309.91c1.56.77,2.81.78,4-.54s2-2.78,3.74-2.58c-.18-.39-.35-.79-.52-1.17a2.55,2.55,0,0,0-.86.09c-1.55.41-2.24,2-3.32,3-1.67,1.57-3.45-.49-5.35-.37l-.17,0c0,.34,0,.68,0,1A4.8,4.8,0,0,1,44.23,309.91Zm13.69,15.43a5.19,5.19,0,0,0-.82-.23,3,3,0,0,0-2.35.53c-1.51,1.11-1.58,3.56-4,2.92-1.86-.49-3.25-1.71-5.19-.73a6.66,6.66,0,0,0-1.79,1.34c.09.29.18.57.28.86a5.5,5.5,0,0,1,2.42-1.51c2.1-.54,3.68,1.58,5.77,1.24,1.7-.29,1.89-2.15,3.07-3.08a2.66,2.66,0,0,1,2.76-.17C58,326.12,58,325.73,57.92,325.34Zm-13.6-23.57c.58.8,1.4,1.68,2.48,1.13s1.24-2,2-2.91l-.4-.77c-.72,1-1.08,3.06-2.46,3-1.08-.05-1.51-1.66-2.41-2.12a1.56,1.56,0,0,0-.9-.17c0,.21-.07.43-.1.66l.21,0C43.48,300.58,43.92,301.22,44.32,301.77Zm3.75,17c2,.43,2.92-1.91,3.81-3.21a5.86,5.86,0,0,1,2.73-2.31c-.13-.35-.26-.71-.4-1.06a3.77,3.77,0,0,0-1,.38,6.62,6.62,0,0,0-2.14,2.17,8.67,8.67,0,0,1-2,2.67c-1,.68-2.28-.39-3.37-.59a5.78,5.78,0,0,0-3,.25,5.18,5.18,0,0,0-.92.44c0,.49,0,1,.07,1.44A4.69,4.69,0,0,1,45,317.9C46.14,317.92,47,318.56,48.07,318.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.94,314.18a27.9,27.9,0,0,0-4,6.6s-5.41-7.33-9.2-10.65c-.21,6.09.09,12.44,1.17,16.18,2.47,8.58,7.12,19.94,12.1,16.75,4-2.54,3.91-12.9,2.58-20A61.9,61.9,0,0,0,54.94,314.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.64,348.9c-9.11.49-17.62-5-23.14-12s-9.83-21.31-8.58-22.19,15.94,8.17,21.45,14.71C51.61,338,54.64,348.9,54.64,348.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.64,348.9c-9.11.49-17.62-5-23.14-12s-9.83-21.31-8.58-22.19,15.94,8.17,21.45,14.71C51.61,338,54.64,348.9,54.64,348.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.76,326.1c.53-.86.23-1.9.11-2.82a2.62,2.62,0,0,1,.37-1.77l-1-.73a3.76,3.76,0,0,0-.37,2.47c.15,1.05.41,2.36-1,2.55s-3.65-1.16-4.88.36c-.59.73-.37,1.67-.39,2.53a2.45,2.45,0,0,1-.33,1.11l.51,1a3.2,3.2,0,0,0,.68-1.54c.13-1.06-.29-2.43,1.14-2.65a12.63,12.63,0,0,1,2.92.37A2.32,2.32,0,0,0,34.76,326.1Zm-5.08-7.61a1.83,1.83,0,0,1,.4-.43l-.82-.5c-.67.88-.67,2.08-1.34,3a1.57,1.57,0,0,1-1.72.49,2.43,2.43,0,0,0-2.28.28l.21.66a2,2,0,0,1,1-.27c.68,0,1.32.35,2,.3a1.81,1.81,0,0,0,1.21-.62C29.06,320.54,29.1,319.39,29.68,318.49Zm10.09,12.2a4.45,4.45,0,0,0,1.38-2.34,17.54,17.54,0,0,0,.24-1.93c-.28-.26-.57-.51-.87-.77a9.21,9.21,0,0,1-.63,3.15,2.86,2.86,0,0,1-2.84,1.49,2.94,2.94,0,0,0-2.43.77,4.59,4.59,0,0,0-.91,2.44c-.19,1.27-.38,2.44-1.56,3.16a3.64,3.64,0,0,1-.63.3l.66.79a3.61,3.61,0,0,0,1.31-1c1.52-1.81.29-5.4,3.52-5.4A3.89,3.89,0,0,0,39.77,330.69Zm4.89.92a5,5,0,0,1,.69-.95c-.26-.33-.52-.66-.79-1a5.93,5.93,0,0,0-1.46,2.86,8.58,8.58,0,0,1-1.18,3.39c-.8,1-2.06.91-3.1,1.5a4.4,4.4,0,0,0-2,2.26,10.57,10.57,0,0,0-.48,2.3l1,.79,0-.14a5.74,5.74,0,0,1,1.36-3.56c1-.9,2.29-.77,3.32-1.49C44,336.21,43.68,333.54,44.66,331.61Zm4,3.8a7.85,7.85,0,0,0-.74.67c-1.55,1.71-1.36,3.93-1.93,6A3.7,3.7,0,0,1,44,344.7c-.87.36-1.85,0-2.61.69l-.07.09c.45.25.9.5,1.36.73a4.92,4.92,0,0,1,.76-.09,3.49,3.49,0,0,0,1.42-.34,4.07,4.07,0,0,0,1.73-1.89c.94-2,.52-4.34,1.7-6.2a4.9,4.9,0,0,1,1-1.13C49.07,336.17,48.84,335.79,48.61,335.41Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.13,320.73C35,328.26,39,348.55,54.64,348.9c0,0-3-10.88-10.27-19.45A57.06,57.06,0,0,0,34.13,320.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.64,348.9c-7.17-1-13.31-5.58-16.47-19.07s-3.64-19.58-1.47-20.92C39.2,307.37,49,321,52.12,327,60,342,54.64,348.9,54.64,348.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35,324c1.78.56,4.11,1.16,5.44-.6a16.53,16.53,0,0,0,1.29-2.94q-.46-.69-1-1.38c-.78,1.27-.76,3.15-2.14,3.88a4.49,4.49,0,0,1-3.32-.13,7.75,7.75,0,0,0-3.29-.5,4.59,4.59,0,0,0-1.72.61c.08.39.17.81.26,1.22a5.12,5.12,0,0,1,.71-.34A5.51,5.51,0,0,1,41.35,324Zm-2.12-7a2.86,2.86,0,0,0,1.67.32c1.08-.23,1.65-1.28,2.21-2.13a4.21,4.21,0,0,1,.55-.71l-.68-.81-.13.14c-.68.82-1.25,2.49-2.51,2.51a8.3,8.3,0,0,1-1.79-.52,4.2,4.2,0,0,0-1.54,0,3.77,3.77,0,0,0-1.43.55q0,.46.12,1a4.21,4.21,0,0,1,1.92-.58A3.72,3.72,0,0,1,39.23,317Zm7.82,15a10.23,10.23,0,0,1,2.19-2.86,4.84,4.84,0,0,1,3.65-.65c-.25-.5-.5-1-.77-1.52a5.92,5.92,0,0,0-2.47.16,5.28,5.28,0,0,0-2.74,2,15.23,15.23,0,0,1-1.83,2.65c-1.46,1.33-3.43.16-5.06-.16a6.23,6.23,0,0,0-1.43-.11l.39,1.38a5.88,5.88,0,0,1,1.89.29C43.3,333.9,45.42,334.35,47.05,332Zm8.25,2.62-.36.1a5.63,5.63,0,0,0-2.43,1.82c-.7.9-1.06,2-1.72,2.91a2.25,2.25,0,0,1-2.85.95,4.88,4.88,0,0,0-3.15-.23,5.18,5.18,0,0,0-2,1.24c.24.36.49.7.75,1a4.22,4.22,0,0,1,1.53-.89,3.42,3.42,0,0,1,2.47.3,3.86,3.86,0,0,0,5.07-1.54c.61-.89,1-2,1.66-2.8a4,4,0,0,1,1.48-1.14C55.62,335.79,55.48,335.2,55.3,334.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.12,327c-.57-1.09-1.36-2.42-2.28-3.86-3.1,9.57-4.09,23.54,4.8,25.81C54.64,348.9,60,342,52.12,327Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,348.9c9.1.49,17.61-5,23.13-12s9.83-21.31,8.58-22.19-15.94,8.17-21.45,14.71C61.36,338,58.34,348.9,58.34,348.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,348.9c9.1.49,17.61-5,23.13-12s9.83-21.31,8.58-22.19-15.94,8.17-21.45,14.71C61.36,338,58.34,348.9,58.34,348.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.48,327a12.63,12.63,0,0,1,2.92-.37c1.43.22,1,1.59,1.15,2.65a3.18,3.18,0,0,0,.67,1.54c.18-.34.34-.68.51-1a2.45,2.45,0,0,1-.33-1.11c0-.86.2-1.8-.39-2.53-1.23-1.52-3.35-.15-4.88-.36s-1.15-1.5-1-2.55a3.7,3.7,0,0,0-.37-2.47l-1,.73a2.62,2.62,0,0,1,.37,1.77c-.12.92-.42,2,.11,2.82A2.32,2.32,0,0,0,80.48,327Zm4.18-5.65a1.77,1.77,0,0,0,1.2.62c.7,0,1.34-.32,2-.3a2,2,0,0,1,1,.27l.21-.66a2.43,2.43,0,0,0-2.28-.28,1.57,1.57,0,0,1-1.72-.49c-.67-.88-.67-2.08-1.34-3l-.82.5a1.83,1.83,0,0,1,.4.43C83.87,319.39,83.91,320.54,84.66,321.36Zm-8.7,10c3.23,0,2,3.59,3.52,5.4a3.61,3.61,0,0,0,1.31,1c.22-.26.45-.52.66-.79a3.64,3.64,0,0,1-.63-.3c-1.18-.72-1.37-1.89-1.56-3.16a4.51,4.51,0,0,0-.91-2.44,2.93,2.93,0,0,0-2.43-.77,2.87,2.87,0,0,1-2.84-1.49,9.21,9.21,0,0,1-.63-3.15l-.86.77a15.41,15.41,0,0,0,.23,1.93,4.45,4.45,0,0,0,1.38,2.34A3.9,3.9,0,0,0,76,331.38Zm-5,6.21c1,.72,2.36.59,3.32,1.49s1.16,2.27,1.37,3.56a.59.59,0,0,0,0,.14c.33-.26.65-.52,1-.79a10.57,10.57,0,0,0-.48-2.3,4.43,4.43,0,0,0-1.94-2.26c-1-.59-2.31-.48-3.1-1.5a8.44,8.44,0,0,1-1.19-3.39,5.93,5.93,0,0,0-1.46-2.86c-.27.32-.53.65-.79,1a4.27,4.27,0,0,1,.69.95C69.3,333.54,69,336.21,70.91,337.59Zm-7.22-1a5.11,5.11,0,0,1,1,1.13c1.18,1.86.76,4.24,1.7,6.2a4.07,4.07,0,0,0,1.73,1.89,3.49,3.49,0,0,0,1.42.34,4.65,4.65,0,0,1,.76.09c.46-.23.91-.48,1.36-.73l-.07-.09c-.75-.68-1.74-.33-2.6-.69A3.68,3.68,0,0,1,67,342.1c-.57-2.09-.38-4.31-1.93-6a7.85,7.85,0,0,0-.74-.67C64.13,335.79,63.9,336.17,63.69,336.56Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.84,320.73C78,328.26,74,348.55,58.34,348.9c0,0,3-10.88,10.26-19.45A57.06,57.06,0,0,1,78.84,320.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,348.9c7.16-1,13.3-5.58,16.46-19.07s3.64-19.58,1.47-20.92C73.77,307.37,64,321,60.85,327,53,342,58.34,348.9,58.34,348.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.35,323.79a4.74,4.74,0,0,1,.72.34c.08-.41.17-.83.25-1.22a4.53,4.53,0,0,0-1.72-.61,7.75,7.75,0,0,0-3.29.5,4.47,4.47,0,0,1-3.31.13c-1.38-.73-1.36-2.61-2.15-3.88q-.5.69-1,1.38a16.53,16.53,0,0,0,1.29,2.94c1.34,1.76,3.66,1.16,5.44.6A5.51,5.51,0,0,1,75.35,323.79Zm0-7.1a4.18,4.18,0,0,1,1.92.58c0-.33.09-.65.13-1a3.75,3.75,0,0,0-1.44-.55,4.2,4.2,0,0,0-1.54,0,8.14,8.14,0,0,1-1.79.52c-1.26,0-1.83-1.69-2.5-2.51l-.14-.14-.67.81a4.74,4.74,0,0,1,.54.71c.56.85,1.13,1.9,2.22,2.13a2.84,2.84,0,0,0,1.66-.32A3.72,3.72,0,0,1,75.35,316.69Zm-3.24,16.46a5.78,5.78,0,0,1,1.88-.29q.2-.67.39-1.38a6.27,6.27,0,0,0-1.43.11c-1.63.32-3.6,1.49-5.06.16a15.8,15.8,0,0,1-1.83-2.65,5.25,5.25,0,0,0-2.73-2,6,6,0,0,0-2.48-.16c-.27.52-.52,1-.76,1.52a4.85,4.85,0,0,1,3.65.65A10.2,10.2,0,0,1,65.92,332C67.55,334.35,69.67,333.9,72.11,333.15Zm-14.89,3.2a4,4,0,0,1,1.47,1.14c.69.84,1.05,1.91,1.66,2.8a3.86,3.86,0,0,0,5.07,1.54,3.42,3.42,0,0,1,2.47-.3,4.34,4.34,0,0,1,1.54.89c.25-.33.5-.67.74-1a5.11,5.11,0,0,0-2-1.24,4.88,4.88,0,0,0-3.15.23,2.25,2.25,0,0,1-2.85-.95c-.66-.92-1-2-1.72-2.91A5.66,5.66,0,0,0,58,334.7l-.36-.1C57.5,335.2,57.35,335.79,57.22,336.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,327c.57-1.09,1.36-2.42,2.28-3.86,3.1,9.57,4.1,23.54-4.79,25.81C58.34,348.9,53,342,60.85,327Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,350.39c6,0,8.05-8.22,7.44-14.84s-4.78-19.21-7.44-19.21S49.65,328.93,49,335.55,50.44,350.39,56.49,350.39Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,350.39c6,0,8.05-8.22,7.44-14.84s-4.78-19.21-7.44-19.21S49.65,328.93,49,335.55,50.44,350.39,56.49,350.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.45,325a4.87,4.87,0,0,0,2.25-1.61,3.86,3.86,0,0,1,1.87-1l-.47-1.15a5.71,5.71,0,0,0-2.55,1.57,3.6,3.6,0,0,1-1.27.95c-.73.25-1.17-.14-1.65-.62a4,4,0,0,0-2-1.19h-.06c-.12.31-.25.63-.37.95a3.74,3.74,0,0,1,2.1,1.18A2.28,2.28,0,0,0,56.45,325Zm-4.51,7.25c2,1.58,3.68-.66,5-2,1.07-1.11,2.21-1.34,3.43-.31a8,8,0,0,0,2.3,1.67,4.94,4.94,0,0,0,.69.17c-.07-.38-.16-.76-.24-1.15A6.73,6.73,0,0,1,60.63,329c-1.79-1.47-3.41-.86-4.84.78-.82.94-2.15,2.56-3.5,1.55-.79-.6-1.17-1.61-2-2.18l0,0-.24,1C50.79,330.61,51.19,331.62,51.94,332.2Zm2.26,7.24c1.14,1.51,2.56,1.89,4.11.59a29.16,29.16,0,0,1,2.07-2.09c1.15-.77,2.47-.37,3.65.1,0-.36,0-.72,0-1.08a8.37,8.37,0,0,0-1.68-.52,3.36,3.36,0,0,0-2.6.53c-.86.6-1.38,1.55-2.21,2.19a2.06,2.06,0,0,1-1.74.56c-.69-.26-1.11-1.12-1.61-1.63a5,5,0,0,0-2.33-1.34A4.31,4.31,0,0,0,49,337c0,.34,0,.68,0,1A4.25,4.25,0,0,1,54.2,339.44Zm5.73,6.16a4.73,4.73,0,0,1-3.41,1,2.71,2.71,0,0,1-1.72-.75c-.33-.34-.57-.76-.91-1.1a4,4,0,0,0-2.28-1.13,4.47,4.47,0,0,0-1.89.16c.1.37.22.73.35,1.08a3.15,3.15,0,0,1,3,.42c.72.54,1.07,1.42,1.84,1.92a4.22,4.22,0,0,0,2.35.61,5.36,5.36,0,0,0,2.51-.62c.87-.45,1.48-1.24,2.33-1.72a3.6,3.6,0,0,1,.69-.32c.17-.44.32-.9.45-1.37a3.84,3.84,0,0,0-.84.18A8.3,8.3,0,0,0,59.93,345.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.67,450.88l43.5-25.11a2.07,2.07,0,0,0,1.18-1.8c0-.67,0-4.33,0-4.33s-1.16,1.67-1.18,1.68l-33,19-10.57,6.1a6.33,6.33,0,0,1-5.72,0l-65.87-38-1.14-1.32s-.06,3.52,0,4.27a2,2,0,0,0,1.17,1.5l65.88,38A6.27,6.27,0,0,0,125.67,450.88Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,451.53v-4.46a5.34,5.34,0,0,0,2.08-.64l10.57-6.1,33-19s1.17-1.66,1.18-1.68,0,3.66,0,4.33a2.07,2.07,0,0,1-1.18,1.8l-43.5,25.11A5.57,5.57,0,0,1,123.58,451.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,421.32l.06-.05c1.51-.9,1.48-2.36-.06-3.26l-65.89-38a6.32,6.32,0,0,0-5.73,0L54.07,405.09c-1.57.9-1.58,2.36-.06,3.27l.06,0,65.87,38a6.33,6.33,0,0,0,5.72,0l10.57-6.1Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.18,421.32l.06-.05c1.51-.9,1.48-2.36-.06-3.26l-65.89-38a6.32,6.32,0,0,0-5.73,0L54.07,405.09c-1.57.9-1.58,2.36-.06,3.27l.06,0,65.87,38a6.33,6.33,0,0,0,5.72,0l10.57-6.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.07,408.4c19.09,10.8,45.48,25.92,64.55,37,2.18,1.58,5.15,2.14,7.48.53l28.69-16.44,14.39-8.14-14.25,8.38-28.59,16.61c-2.42,1.7-5.69,1.17-8-.49C99.24,434.8,73,419.55,54.07,408.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,380,87,386.08l71.61,41.35,10.57-6.1c1.57-.91,1.58-2.37.06-3.27l-.06,0L103.3,380A6.29,6.29,0,0,0,97.57,380Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.71 409.38 58.08 410.75 93.9 390.06 91.54 388.7 55.71 409.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,389a.16.16,0,0,1-.11-.13.13.13,0,0,1,.07-.13l5.09-2.94a.46.46,0,0,1,.22,0,.61.61,0,0,1,.24.06l2.67,1.55a2.56,2.56,0,0,1,.82.65,1.1,1.1,0,0,1,.25.59.76.76,0,0,1-.17.48,1.25,1.25,0,0,1-.4.36,2.3,2.3,0,0,1-.49.2,3.23,3.23,0,0,1-.5.08h-.42l-.29,0a.84.84,0,0,1,0,.57,1,1,0,0,1-.53.58,2.35,2.35,0,0,1-.72.27,3.28,3.28,0,0,1-.9.09,4.43,4.43,0,0,1-1-.13,3.84,3.84,0,0,1-1-.41Zm7.41-.24q.3-.17.24-.39c-.05-.14-.22-.3-.54-.48l-1.61-.93-1.21.7,1.61.93a2.29,2.29,0,0,0,.84.31A1.09,1.09,0,0,0,106.3,388.79Zm-5.45.24,1.68,1a2.12,2.12,0,0,0,.92.32,1.15,1.15,0,0,0,.71-.15c.2-.11.29-.25.25-.42s-.21-.34-.53-.52l-1.68-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,391c.1,0,.15.11.15.16a.27.27,0,0,1-.07.19l-2.75,4.16,0,0a.53.53,0,0,1-.23,0,.44.44,0,0,1-.23-.06l-.66-.38c-.12-.07-.18-.13-.18-.19a.15.15,0,0,1,0-.13l.48-.73-2.87-1.66-1.26.28a.86.86,0,0,1-.24,0,.68.68,0,0,1-.32-.11l-.65-.38a.17.17,0,0,1-.11-.13.12.12,0,0,1,.08-.13l.06,0,7.2-1.58a1.39,1.39,0,0,1,.33-.05.76.76,0,0,1,.28.09Zm-3,2.28,1.24-1.87-3.24.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,398.51c-.11-.06-.16-.12-.17-.18a.72.72,0,0,1,0-.13l.73-3.36-3.24,1.87a.48.48,0,0,1-.22.05.61.61,0,0,1-.24-.07l-.73-.42c-.07,0-.11-.09-.11-.14s0-.09.07-.13l5.09-2.93a.45.45,0,0,1,.22-.05.52.52,0,0,1,.23.07l.64.36c.1.06.16.12.17.18a.55.55,0,0,1,0,.13l-.73,3.36,3.25-1.87a.36.36,0,0,1,.22,0,.41.41,0,0,1,.23.06l.74.42a.21.21,0,0,1,.11.14.12.12,0,0,1-.08.13l-5.08,2.93a.38.38,0,0,1-.22.05.61.61,0,0,1-.24-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,402.43s0,.06,0,.07a.05.05,0,0,1,0,0,.36.36,0,0,1-.22.05.52.52,0,0,1-.23-.07l-.87-.49c-.12-.07-.19-.15-.2-.22a.87.87,0,0,1,0-.13l0-2.44L119,400.42a.36.36,0,0,1-.22,0,.41.41,0,0,1-.23-.06l-.74-.42a.21.21,0,0,1-.11-.14.12.12,0,0,1,.08-.13l5.08-2.93a.38.38,0,0,1,.22,0,.61.61,0,0,1,.24.07l.73.42c.07,0,.11.08.11.14a.12.12,0,0,1-.07.12l-1.85,1.07,3.87.06.29,0a1.15,1.15,0,0,1,.29.11l.83.48c.07,0,.11.09.11.14a.13.13,0,0,1-.07.13.44.44,0,0,1-.18,0l-4.75-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,405l-1.17-.67a.19.19,0,0,1-.09-.11.12.12,0,0,1,.06-.1.34.34,0,0,1,.18,0,.59.59,0,0,1,.19.05l.38.23,1.69-1c.09-.06.14-.12.13-.2a.29.29,0,0,0-.18-.22h0c-.06,0-.09-.07-.09-.11s0-.07.06-.1a.34.34,0,0,1,.18,0,.41.41,0,0,1,.19.05h0a.64.64,0,0,1,.35.43.4.4,0,0,1-.25.41l-1.69,1,.39.23c.06,0,.09.07.09.11s0,.07-.06.1a.27.27,0,0,1-.18,0A.35.35,0,0,1,80.05,405Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,405.83l-.78-.45a.84.84,0,0,0-.37-.1.63.63,0,0,0-.35.07l-.26.15a.05.05,0,0,0,0,.05.08.08,0,0,0,0,.05l1.65,1c.06,0,.09.07.09.11s0,.07-.06.1a.34.34,0,0,1-.18,0,.48.48,0,0,1-.18-.06l-2-1.12a.16.16,0,0,1-.09-.11s0-.07.06-.1l.51-.29a1.25,1.25,0,0,1,.7-.15,1.61,1.61,0,0,1,.75.21l.78.45a.88.88,0,0,0,.37.1.66.66,0,0,0,.36-.07l.33-.19a.21.21,0,0,0,.13-.21.33.33,0,0,0-.18-.22l-.78-.45a.88.88,0,0,0-.37-.1.8.8,0,0,0-.36.07.29.29,0,0,1-.17,0,.41.41,0,0,1-.19-.05.19.19,0,0,1-.09-.11s0-.07.07-.1a1.18,1.18,0,0,1,.7-.14,1.67,1.67,0,0,1,.75.2l.78.45a.62.62,0,0,1,.35.43.4.4,0,0,1-.25.41l-.33.19a1.29,1.29,0,0,1-.71.15A1.56,1.56,0,0,1,83.59,405.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,408.18l-.16.09a1.31,1.31,0,0,1-.71.15,1.56,1.56,0,0,1-.75-.21l-.78-.45a.6.6,0,0,1-.35-.43.39.39,0,0,1,.25-.4.32.32,0,0,1,.18,0,.35.35,0,0,1,.18.05c.06,0,.09.07.09.11s0,.07-.06.1a.2.2,0,0,0-.12.2.3.3,0,0,0,.17.22L86,408a.76.76,0,0,0,.37.1.66.66,0,0,0,.36-.07l.17-.1a.2.2,0,0,0,.12-.2.31.31,0,0,0-.18-.22l-.19-.11c-.06,0-.09-.07-.09-.11s0-.07.06-.1a.34.34,0,0,1,.18,0,.42.42,0,0,1,.19.06l.19.11a.88.88,0,0,0,.37.1.66.66,0,0,0,.36-.07l.17-.1a.2.2,0,0,0,.12-.2.31.31,0,0,0-.18-.22l-.78-.45a.84.84,0,0,0-.37-.1.63.63,0,0,0-.35.07.34.34,0,0,1-.18,0,.59.59,0,0,1-.19-.05.14.14,0,0,1-.08-.11.08.08,0,0,1,.06-.1,1.27,1.27,0,0,1,.7-.15,1.61,1.61,0,0,1,.75.21l.78.45a.58.58,0,0,1,.35.43.41.41,0,0,1-.25.41l-.16.09a1,1,0,0,1-.35.12,1.48,1.48,0,0,1-.42,0,.38.38,0,0,1,0,.24A.53.53,0,0,1,87.31,408.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,410.4a.38.38,0,0,1-.19,0,.19.19,0,0,1-.09-.11s0-.07.07-.1l.93-.54a1.7,1.7,0,0,1-.48-.17L89,409a.64.64,0,0,1-.35-.43.4.4,0,0,1,.25-.41l.84-.49a.29.29,0,0,1,.17,0,.38.38,0,0,1,.19.05.16.16,0,0,1,.09.11.12.12,0,0,1-.06.1l-.84.48a.21.21,0,0,0-.13.21.3.3,0,0,0,.18.21l.78.45a.73.73,0,0,0,.37.11.63.63,0,0,0,.35-.08l.85-.48a.29.29,0,0,1,.17,0,.41.41,0,0,1,.19.05.19.19,0,0,1,.09.11.1.1,0,0,1-.07.1l-2.35,1.36A.34.34,0,0,1,89.58,410.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,411.91s0,0,0,0a.07.07,0,0,0,0,.06l1.07.61a.61.61,0,0,1,.35.44.39.39,0,0,1-.24.4l-.34.2a1.29,1.29,0,0,1-.71.14,1.59,1.59,0,0,1-.74-.2l-.78-.45a.63.63,0,0,1-.36-.43.42.42,0,0,1,.25-.41.34.34,0,0,1,.18,0,.42.42,0,0,1,.19.06.17.17,0,0,1,.09.1.1.1,0,0,1-.07.1.22.22,0,0,0-.12.21.31.31,0,0,0,.17.21l.78.45a.67.67,0,0,0,.38.1.55.55,0,0,0,.35-.07l.34-.19a.21.21,0,0,0,.12-.21.3.3,0,0,0-.18-.21l-1.16-.68a.3.3,0,0,1-.18-.21.2.2,0,0,1,.12-.2l.85-.49a.29.29,0,0,1,.17,0,.38.38,0,0,1,.19.05l1.95,1.13c.05,0,.08.06.08.1s0,.08-.06.11a.29.29,0,0,1-.17,0,.38.38,0,0,1-.19-.05l-1.65-1-.1,0-.09,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.06,414l.77.45a.62.62,0,0,1,.36.44.39.39,0,0,1-.25.4l-.33.2a1.41,1.41,0,0,1-.71.14,1.56,1.56,0,0,1-.75-.21l-.78-.44a.63.63,0,0,1-.35-.44.39.39,0,0,1,.25-.4l1.34-.78a1.31,1.31,0,0,1,.71-.15,1.68,1.68,0,0,1,.75.21l.78.45a.62.62,0,0,1,.35.43.4.4,0,0,1-.25.41.23.23,0,0,1-.17,0,.36.36,0,0,1-.19-.05.14.14,0,0,1-.09-.1.14.14,0,0,1,.06-.11.19.19,0,0,0,.13-.2.33.33,0,0,0-.18-.22l-.78-.45a.88.88,0,0,0-.37-.1.77.77,0,0,0-.36.07l-.42.25A1.7,1.7,0,0,1,99.06,414Zm-1.4.36c-.1.06-.14.12-.13.21a.3.3,0,0,0,.18.21l.78.45a.76.76,0,0,0,.37.1.58.58,0,0,0,.36-.07l.33-.19c.1-.06.14-.12.13-.21a.3.3,0,0,0-.18-.21l-.78-.45a.76.76,0,0,0-.37-.1.58.58,0,0,0-.36.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55,416.67l-2.31.32h-.32l0,0a.2.2,0,0,1-.09-.1s0-.08.07-.11a.58.58,0,0,1,.26,0l2.14-.32.21-.05.16-.07.06,0a.2.2,0,0,0,.12-.2.29.29,0,0,0-.18-.22l-.39-.22-.19-.12-.78-.45a.17.17,0,0,1-.09-.1.11.11,0,0,1,.06-.1.34.34,0,0,1,.18,0,.41.41,0,0,1,.19.05l.78.45.19.11.39.23a.58.58,0,0,1,.35.43.39.39,0,0,1-.25.4,1.14,1.14,0,0,1-.27.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,419l-.17.1a1.21,1.21,0,0,1-.71.14,1.48,1.48,0,0,1-.74-.2l-.78-.45a.59.59,0,0,1-.35-.43.41.41,0,0,1,.24-.41l.17-.1a1.6,1.6,0,0,1,.35-.12,1.48,1.48,0,0,1,.42,0,.36.36,0,0,1,0-.25.67.67,0,0,1,.21-.2l.17-.1a1.39,1.39,0,0,1,.71-.14,1.59,1.59,0,0,1,.74.2l.78.45a.62.62,0,0,1,.36.44.4.4,0,0,1-.25.4l-.17.1a1,1,0,0,1-.35.12,2,2,0,0,1-.42,0,.34.34,0,0,1,0,.24A.45.45,0,0,1,106,419Zm.79-.9a.21.21,0,0,0,.12-.21.31.31,0,0,0-.17-.21l-.78-.45a.77.77,0,0,0-.38-.1.65.65,0,0,0-.35.07l-.17.1a.2.2,0,0,0-.12.2.33.33,0,0,0,.18.22l.77.44a.8.8,0,0,0,.38.11.63.63,0,0,0,.35-.08Zm-1.18.68c.09-.06.13-.12.12-.2a.3.3,0,0,0-.17-.22l-.78-.45a.77.77,0,0,0-.38-.1.65.65,0,0,0-.35.07l-.17.1a.2.2,0,0,0-.12.2.33.33,0,0,0,.18.22l.77.45a.93.93,0,0,0,.38.1.73.73,0,0,0,.35-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,422.6l-.77-.45a.62.62,0,0,1-.36-.44.41.41,0,0,1,.25-.4.34.34,0,0,1,.18,0,.59.59,0,0,1,.19.05s.08.07.08.11a.08.08,0,0,1-.06.1.21.21,0,0,0-.12.21.31.31,0,0,0,.17.21l.78.45a.77.77,0,0,0,.38.1.55.55,0,0,0,.35-.07l.43-.24a1.71,1.71,0,0,1-.48-.18l-.78-.45a.61.61,0,0,1-.36-.43.42.42,0,0,1,.25-.41l.34-.19a1.19,1.19,0,0,1,.7-.14,1.6,1.6,0,0,1,.75.2l.78.45a.61.61,0,0,1,.36.43.4.4,0,0,1-.25.41l-1.35.78a1.28,1.28,0,0,1-.7.14A1.68,1.68,0,0,1,110.6,422.6Zm2.42-.94a.22.22,0,0,0,.12-.21.33.33,0,0,0-.18-.22l-.77-.45a.93.93,0,0,0-.38-.1.73.73,0,0,0-.35.07l-.34.2a.2.2,0,0,0-.12.2.32.32,0,0,0,.17.22l.78.45a.93.93,0,0,0,.38.1.63.63,0,0,0,.35-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.52,424.28l-1.17-.67a.14.14,0,0,1-.08-.11.08.08,0,0,1,.06-.1.29.29,0,0,1,.17,0,.36.36,0,0,1,.19.05l.39.23,1.69-1a.2.2,0,0,0,.12-.2.31.31,0,0,0-.17-.21h0a.17.17,0,0,1-.09-.1.13.13,0,0,1,.07-.11.4.4,0,0,1,.17,0,.38.38,0,0,1,.19.05h0a.59.59,0,0,1,.35.43.41.41,0,0,1-.25.41l-1.68,1,.39.23a.17.17,0,0,1,.09.1.13.13,0,0,1-.07.11.4.4,0,0,1-.17,0A.38.38,0,0,1,113.52,424.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.05,425.74l-.77-.45a.59.59,0,0,1-.36-.43.42.42,0,0,1,.25-.41l1.35-.77a1.27,1.27,0,0,1,.7-.15,1.5,1.5,0,0,1,.75.21l.78.45a.58.58,0,0,1,.35.43.39.39,0,0,1-.24.4l-1.35.78a1.29,1.29,0,0,1-.71.15A1.68,1.68,0,0,1,116.05,425.74Zm-.44-.64.78.45a1,1,0,0,0,.23.08l.26-1.71-1.32.76a.2.2,0,0,0-.12.2A.32.32,0,0,0,115.61,425.1Zm2.8-.72-.77-.45a.9.9,0,0,0-.23-.08l-.26,1.71,1.32-.76a.2.2,0,0,0,.12-.2A.29.29,0,0,0,118.41,424.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,427.43l-1.17-.68a.17.17,0,0,1-.09-.1.12.12,0,0,1,.07-.11.29.29,0,0,1,.17,0,.38.38,0,0,1,.19.05l.39.22,1.68-1c.1-.06.14-.12.13-.2a.32.32,0,0,0-.17-.22h0a.19.19,0,0,1-.09-.11s0-.07.07-.1a.29.29,0,0,1,.17,0,.59.59,0,0,1,.19.05h0a.63.63,0,0,1,.35.44.39.39,0,0,1-.25.4l-1.68,1,.39.22a.19.19,0,0,1,.09.11s0,.07-.07.1a.29.29,0,0,1-.17,0A.53.53,0,0,1,119,427.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,430.57l-1.17-.67a.19.19,0,0,1-.09-.11s0-.07.07-.1a.29.29,0,0,1,.17,0,.53.53,0,0,1,.19.05l.39.23,1.68-1a.21.21,0,0,0,.13-.21.31.31,0,0,0-.17-.21h0a.22.22,0,0,1-.09-.11.11.11,0,0,1,.06-.1.34.34,0,0,1,.18,0,.41.41,0,0,1,.19,0h0a.64.64,0,0,1,.35.43.4.4,0,0,1-.25.41l-1.68,1,.39.23a.19.19,0,0,1,.09.11s0,.07-.07.1a.23.23,0,0,1-.17,0A.36.36,0,0,1,124.42,430.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,431.45l-.77-.45a.93.93,0,0,0-.38-.1.63.63,0,0,0-.35.07l-.25.15s0,0,0,.05a.05.05,0,0,0,0,.05l1.66,1a.14.14,0,0,1,.08.11s0,.07-.06.1a.23.23,0,0,1-.17,0,.36.36,0,0,1-.19-.05l-2-1.12a.19.19,0,0,1-.09-.11.12.12,0,0,1,.06-.1l.51-.29a1.29,1.29,0,0,1,.71-.15,1.6,1.6,0,0,1,.74.21l.78.45a.89.89,0,0,0,.38.1.63.63,0,0,0,.35-.07l.34-.2a.2.2,0,0,0,.12-.2.33.33,0,0,0-.18-.22l-.78-.45a.84.84,0,0,0-.37-.1.73.73,0,0,0-.35.07.38.38,0,0,1-.36,0c-.06,0-.09-.07-.09-.11s0-.07.06-.1a1.25,1.25,0,0,1,.7-.15,1.61,1.61,0,0,1,.75.21l.78.45a.61.61,0,0,1,.36.43.42.42,0,0,1-.25.41l-.34.19a1.27,1.27,0,0,1-.7.15A1.68,1.68,0,0,1,128,431.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,433.72,128.7,433a.17.17,0,0,1-.09-.1.11.11,0,0,1,.06-.1.34.34,0,0,1,.18,0,.38.38,0,0,1,.19.05l.39.22,1.68-1a.19.19,0,0,0,.13-.2.31.31,0,0,0-.17-.21h0a.19.19,0,0,1-.09-.11.12.12,0,0,1,.06-.1.34.34,0,0,1,.18,0,.41.41,0,0,1,.19.05h0a.62.62,0,0,1,.35.43.41.41,0,0,1-.25.41l-1.68,1,.39.22s.08.07.08.11a.08.08,0,0,1-.06.1.31.31,0,0,1-.17,0A.36.36,0,0,1,129.87,433.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,435.14l-.16.1a1.31,1.31,0,0,1-.71.15,1.68,1.68,0,0,1-.75-.21l-.78-.45a.62.62,0,0,1-.35-.43.41.41,0,0,1,.25-.41.31.31,0,0,1,.17,0,.38.38,0,0,1,.19.05.16.16,0,0,1,.09.11.12.12,0,0,1-.06.1.21.21,0,0,0-.13.2.31.31,0,0,0,.18.22l.78.45a.88.88,0,0,0,.37.1.77.77,0,0,0,.36-.07l.16-.1a.19.19,0,0,0,.13-.2.29.29,0,0,0-.18-.22l-.19-.11c-.06,0-.09-.07-.09-.11s0-.07.06-.1a.38.38,0,0,1,.36,0l.2.12a.88.88,0,0,0,.37.1.8.8,0,0,0,.36-.07l.16-.1c.1-.06.14-.12.13-.21a.3.3,0,0,0-.18-.21l-.78-.45a.73.73,0,0,0-.37-.1.63.63,0,0,0-.35.07.34.34,0,0,1-.18,0,.6.6,0,0,1-.19-.06.17.17,0,0,1-.09-.1.13.13,0,0,1,.07-.11,1.35,1.35,0,0,1,.7-.14,1.5,1.5,0,0,1,.75.21l.78.44a.63.63,0,0,1,.35.44.39.39,0,0,1-.25.4l-.17.1a.85.85,0,0,1-.35.12,1.91,1.91,0,0,1-.42,0,.34.34,0,0,1,0,.24A.45.45,0,0,1,134,435.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,425.21l-1.18-.68c-.06,0-.09-.07-.09-.11a.1.1,0,0,1,.06-.11.32.32,0,0,1,.18,0,.41.41,0,0,1,.19.05l.39.23,1.71-1c.1-.06.14-.12.13-.21a.31.31,0,0,0-.17-.21h0c-.06,0-.09-.07-.09-.11s0-.07.06-.1a.34.34,0,0,1,.18,0,.39.39,0,0,1,.19.06h0a.61.61,0,0,1,.36.43.41.41,0,0,1-.25.42l-1.71,1,.39.23c.06,0,.09.07.09.11s0,.08-.06.11a.48.48,0,0,1-.18,0A.38.38,0,0,1,101.26,425.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.86,426.1l-.79-.46a.93.93,0,0,0-.38-.1.74.74,0,0,0-.36.07l-.26.15s0,0,0,.05,0,0,0,.06l1.68,1a.19.19,0,0,1,.09.11.1.1,0,0,1-.07.1.3.3,0,0,1-.18,0,.48.48,0,0,1-.18,0l-2-1.14c-.06,0-.09-.07-.09-.11a.1.1,0,0,1,.06-.11l.51-.29a1.33,1.33,0,0,1,.72-.15,1.57,1.57,0,0,1,.76.21l.79.45a.77.77,0,0,0,.38.11.8.8,0,0,0,.36-.07l.34-.2a.21.21,0,0,0,.13-.21c0-.08-.07-.15-.19-.22l-.79-.46a.84.84,0,0,0-.37-.1.74.74,0,0,0-.36.07.34.34,0,0,1-.18,0,.41.41,0,0,1-.19-.05.19.19,0,0,1-.09-.11.08.08,0,0,1,.06-.1,1.33,1.33,0,0,1,.72-.15,1.57,1.57,0,0,1,.76.21l.79.45a.64.64,0,0,1,.36.44.43.43,0,0,1-.25.42l-.35.19a1.29,1.29,0,0,1-.71.15A1.57,1.57,0,0,1,104.86,426.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6,428.84l-.79-.46a.8.8,0,0,0-.38-.1.64.64,0,0,0-.36.07l-.26.15a.05.05,0,0,0,0,.05s0,0,0,.05l1.68,1a.16.16,0,0,1,.09.11s0,.07-.07.1a.25.25,0,0,1-.18,0,.41.41,0,0,1-.19-.05l-2-1.14c-.06,0-.09-.07-.09-.11s0-.07.06-.1l.51-.3a1.33,1.33,0,0,1,.72-.14,1.68,1.68,0,0,1,.76.2l.79.46a.77.77,0,0,0,.38.1.6.6,0,0,0,.36-.07l.34-.2a.21.21,0,0,0,.13-.2.33.33,0,0,0-.19-.22l-.79-.46a.74.74,0,0,0-.38-.1.63.63,0,0,0-.35.07.34.34,0,0,1-.18,0,.38.38,0,0,1-.19-.05s-.09-.07-.09-.11a.1.1,0,0,1,.06-.11,1.33,1.33,0,0,1,.72-.14,1.68,1.68,0,0,1,.76.2l.79.46a.62.62,0,0,1,.36.44c0,.17-.07.3-.26.41l-.34.2a1.29,1.29,0,0,1-.71.15A1.82,1.82,0,0,1,109.6,428.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.37,431.22l-.17.09a1.29,1.29,0,0,1-.71.15,1.57,1.57,0,0,1-.76-.21l-.79-.45a.62.62,0,0,1-.36-.44.4.4,0,0,1,.25-.41.34.34,0,0,1,.18,0,.38.38,0,0,1,.19,0,.19.19,0,0,1,.09.11.11.11,0,0,1-.06.1.21.21,0,0,0-.13.21.31.31,0,0,0,.18.22l.79.46a.93.93,0,0,0,.38.1.68.68,0,0,0,.36-.07l.17-.1c.09-.06.14-.13.12-.21a.32.32,0,0,0-.17-.22l-.2-.11c-.06,0-.09-.07-.09-.11a.08.08,0,0,1,.06-.1.34.34,0,0,1,.18,0,.41.41,0,0,1,.19.05l.2.11a.77.77,0,0,0,.38.11.73.73,0,0,0,.35-.07l.18-.1a.22.22,0,0,0,.12-.21.31.31,0,0,0-.18-.22l-.79-.46a.89.89,0,0,0-.38-.1.73.73,0,0,0-.35.07.34.34,0,0,1-.18,0,.36.36,0,0,1-.19-.05c-.06,0-.09-.07-.09-.11a.08.08,0,0,1,.06-.1,1.33,1.33,0,0,1,.72-.15,1.53,1.53,0,0,1,.75.21l.79.45a.64.64,0,0,1,.36.44.4.4,0,0,1-.25.41l-.17.1a1,1,0,0,1-.36.12,1.18,1.18,0,0,1-.42,0,.36.36,0,0,1,0,.25A.53.53,0,0,1,113.37,431.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,427.92v0a.12.12,0,0,1,.07-.17l3.43-1.43a.14.14,0,0,1,.18.07.16.16,0,0,1-.07.18L105.28,428A.13.13,0,0,1,105.12,427.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,400.85,97.79,405a2.16,2.16,0,0,1-2,0L87,400c-.54-.32-.54-.82,0-1.13l7.21-4.16a2.1,2.1,0,0,1,2,0c2.39,1.37,6.41,3.63,8.8,5A.6.6,0,0,1,105,400.85Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,400.85,97.79,405a2.16,2.16,0,0,1-2,0L87,400c-.54-.32-.54-.82,0-1.13l7.21-4.16a2.1,2.1,0,0,1,2,0c2.39,1.37,6.41,3.63,8.8,5A.6.6,0,0,1,105,400.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,403.87l-3.46-2L99.54,400l3.46,2,.44-.25L92.7,395.6l-.44.25,3.46,2-3.24,1.87-3.46-2-.44.26,10.74,6.15Zm-3.9-2.23L92.92,400l3.24-1.87,2.94,1.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,438.24l-8.23-4.73a2.37,2.37,0,0,0-2.17,0l-.15.08a.67.67,0,0,0,0,1.26l8.23,4.73a2.35,2.35,0,0,0,2.16,0l.16-.09A.66.66,0,0,0,128,438.24Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 401.46 322.91 337.42 378.54 369.44 267.27 433.48 211.65 401.46",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 401.46 322.91 337.42 378.54 369.44 267.27 433.48 211.65 401.46",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.91,340.79,217.5,401.46l49.77,28.65,105.41-60.67Zm-55.64,87.64-46.84-27,102.48-59,46.84,27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.35,397.68c-5-2.86-7.73-6.78-7.73-11,0-4.63,3.35-9.22,9.19-12.58,11.44-6.59,29.39-7,40-.84,5,2.86,7.73,6.78,7.73,11,0,4.63-3.35,9.22-9.19,12.58h0c-6,3.45-13.78,5.2-21.36,5.2C286.13,402,279.41,400.59,274.35,397.68Zm2-22.75c-5.52,3.18-8.69,7.45-8.69,11.72,0,3.88,2.57,7.49,7.23,10.17,10.35,6,27.86,5.58,39-.84h0c5.52-3.18,8.69-7.45,8.69-11.72,0-3.88-2.56-7.49-7.22-10.17-4.93-2.84-11.47-4.24-18.17-4.24C289.77,369.85,282.16,371.56,276.31,374.93Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.15,394.57c-3.82-2.2-5.92-5-5.92-7.92,0-3.32,2.69-6.77,7.38-9.47,5.22-3,12.35-4.73,19.56-4.73,6.52,0,12.51,1.38,16.86,3.89,3.82,2.2,5.92,5,5.92,7.92,0,3.31-2.69,6.77-7.38,9.47-5.22,3-12.35,4.73-19.55,4.73C286.49,398.46,280.5,397.08,276.15,394.57Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270,420.67a5.94,5.94,0,0,0-5.37,0l-3.17,1.82-30.51-17.45,3.68-2.11a1.62,1.62,0,0,0,1-1.26c0-.45-.35-.89-1-1.25l-3.67-2.12,33.49-19.38-.66,1.42a13.07,13.07,0,0,0-1.23,5.47c0,5.43,5.46,11,10.87,14.12a46.55,46.55,0,0,0,21.28,5.59,52,52,0,0,0,6.6-.43l2.45-.31L273.13,422.5Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.18,409.08a3.4,3.4,0,0,1-2-2.87,4,4,0,0,1,2.31-3.23,10.64,10.64,0,0,1,9.59-.19,3.4,3.4,0,0,1,2,2.87,4,4,0,0,1-2.3,3.22,10.47,10.47,0,0,1-5.11,1.24A9.19,9.19,0,0,1,255.18,409.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,390.53a19.08,19.08,0,0,0,1.28-6.66c0-4.52-3.57-8.87-10.61-12.92-5.64-3.25-14.29-5.43-21.54-5.43a51.52,51.52,0,0,0-6.6.42l-2.48.32L317,348.71l3.17,1.83a6,6,0,0,0,5.36,0l3.17-1.83L359.12,366l-3.67,2.13a1.58,1.58,0,0,0-1,1.25c0,.45.34.9,1,1.26l3.67,2.11-33.43,19.19Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.2,368.93a3.39,3.39,0,0,1-2-2.86,4,4,0,0,1,2.31-3.23,10.64,10.64,0,0,1,9.59-.19,3.39,3.39,0,0,1,2,2.86,4,4,0,0,1-2.31,3.23h0a10.42,10.42,0,0,1-5.11,1.24A9.07,9.07,0,0,1,325.2,368.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 401.46 211.65 414.94 267.27 446.97 267.27 433.48 211.65 401.46",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 401.46 211.65 414.94 267.27 446.97 267.27 433.48 211.65 401.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "267.27 436.49 249.71 426.74 267.28 437.31 267.27 436.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 407.87 217.5 411.58 211.65 408.55 211.65 407.87"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 411.08 240.92 428.43 211.65 412.07 211.65 411.08"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.28 439.7 238 423.37 267.28 440.76 267.28 439.7"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "267.27 446.97 378.54 382.93 378.54 369.44 267.27 433.48 267.27 446.97",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.27 446.97 378.54 382.93 378.54 369.44 267.27 433.48 267.27 446.97"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.27 436.49 273.14 433.48 267.28 437.31 267.27 436.49"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.28 439.7 296.71 423.29 267.28 440.76 267.28 439.7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.54 375.79 358.04 387.98 378.54 376.58 378.54 375.79"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.54 379.18 366.82 386.3 378.54 379.93 378.54 379.18"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "257.58 372.78 315.15 405.93 332.71 395.82 275.15 362.67 257.58 372.78",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.71 395.82 332.71 410.49 315.15 420.6 315.15 405.93 332.71 395.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.15 420.6 314.12 420 315.15 419.41 315.15 420.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.58 372.78 257.58 375.02 259.53 373.9 257.58 372.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.12 420 314.12 406.52 315.15 405.93 315.15 419.4 314.12 420"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.12 406.52 258.5 374.5 259.53 373.9 315.15 405.93 314.12 406.52"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "259.48 371.69 317.05 404.83 318.51 403.99 260.94 370.86 259.48 371.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.78 364.62 329.35 397.75 330.81 396.91 273.25 363.78 271.78 364.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.05 404.83 317.05 419.5 318.51 418.66 318.51 403.99 317.05 404.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.35 397.75 329.35 412.42 330.82 411.58 330.81 396.91 329.35 397.75",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.82,306.3v7.95a4.07,4.07,0,0,1-.49,1.35L475.19,328a18.28,18.28,0,0,1-5.71,5.7l-60.64,35a8,8,0,0,1-7.23,0l-55-31.74a2.56,2.56,0,0,1-1.51-2.09v-6.53a2.58,2.58,0,0,1,1.51-2.09l60.64-35a18.42,18.42,0,0,0,5.7-5.69l7.13-12.37a4.2,4.2,0,0,1,5.71-1.53l55,31.74A4.14,4.14,0,0,1,482.82,306.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.25,292.39l-58.6,33.84a2.58,2.58,0,0,0-1.51,2.09v6.53a2.56,2.56,0,0,0,1.51,2.09l55,31.74a7.31,7.31,0,0,0,3.64.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.82,307.72a4.07,4.07,0,0,1-.49,1.35l-.79,1.38-6.35,11a18.28,18.28,0,0,1-5.71,5.7l-60.64,35a8,8,0,0,1-7.23,0l-52.93-30.56-2-1.18a2.2,2.2,0,0,1,0-4.18l60.64-35a18.42,18.42,0,0,0,5.7-5.69l7.13-12.37a4.2,4.2,0,0,1,5.71-1.53l55,31.74a4.14,4.14,0,0,1,2,2.94A4.23,4.23,0,0,1,482.82,307.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,286.9l4.11-6.82a2.86,2.86,0,0,1,3.85-1l46.07,26.6a2.71,2.71,0,0,1,1,3.77l-4.11,6.82a2.86,2.86,0,0,1-3.85,1l-46.07-26.6A2.7,2.7,0,0,1,419.32,286.9Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.32,286.9l4.11-6.82a2.86,2.86,0,0,1,3.85-1l46.07,26.6a2.71,2.71,0,0,1,1,3.77l-4.11,6.82a2.86,2.86,0,0,1-3.85,1l-46.07-26.6A2.7,2.7,0,0,1,419.32,286.9Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79,324.25l5.77,3.33a2.56,2.56,0,0,0,2.29,0l3.08-1.78a.76.76,0,0,0,.45-.64V323.5a.74.74,0,0,0-.45-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-3.08,1.78a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,446.79,324.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79,324.25l5.77,3.33a2.56,2.56,0,0,0,2.29,0l3.08-1.78a.76.76,0,0,0,.45-.64V323.5a.74.74,0,0,0-.45-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-3.08,1.78a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,446.79,324.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,319.54l5.77,3.33a.7.7,0,0,1,0,1.32L454.85,326a2.56,2.56,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l3.08-1.78A2.5,2.5,0,0,1,452.16,319.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.34,322.15v1.46a.76.76,0,0,0,.45.64l5.77,3.33a2.23,2.23,0,0,0,1.15.27v-1.61a2.35,2.35,0,0,1-1.15-.27l-5.77-3.33A1,1,0,0,1,446.34,322.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,316.5l5.76,3.33a2.58,2.58,0,0,0,2.3,0l3.08-1.78a.77.77,0,0,0,.44-.64c0-.07,0-1.6,0-1.66a.77.77,0,0,0-.44-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-3.08,1.78a.76.76,0,0,0-.45.63v1.67A.76.76,0,0,0,433.36,316.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,316.5l5.76,3.33a2.58,2.58,0,0,0,2.3,0l3.08-1.78a.77.77,0,0,0,.44-.64c0-.07,0-1.6,0-1.66a.77.77,0,0,0-.44-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-3.08,1.78a.76.76,0,0,0-.45.63v1.67A.76.76,0,0,0,433.36,316.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,311.78l5.77,3.33a.7.7,0,0,1,0,1.33l-3.08,1.78a2.58,2.58,0,0,1-2.3,0l-5.76-3.33a.7.7,0,0,1,0-1.33l3.08-1.78A2.56,2.56,0,0,1,438.73,311.78Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.91,314.4v1.45a.78.78,0,0,0,.45.65l5.77,3.33a2.32,2.32,0,0,0,1.14.27v-1.61a2.24,2.24,0,0,1-1.14-.28l-5.77-3.32A1,1,0,0,1,432.91,314.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.92,308.74l5.77,3.33a2.5,2.5,0,0,0,2.29,0l3.08-1.78a.74.74,0,0,0,.45-.63V308a.75.75,0,0,0-.45-.63L425.3,304a2.56,2.56,0,0,0-2.29,0l-3.09,1.78a.76.76,0,0,0-.44.63v1.67A.75.75,0,0,0,419.92,308.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.92,308.74l5.77,3.33a2.5,2.5,0,0,0,2.29,0l3.08-1.78a.74.74,0,0,0,.45-.63V308a.75.75,0,0,0-.45-.63L425.3,304a2.56,2.56,0,0,0-2.29,0l-3.09,1.78a.76.76,0,0,0-.44.63v1.67A.75.75,0,0,0,419.92,308.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,304l5.76,3.33c.64.37.64,1,0,1.32L428,310.46a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32L423,304A2.56,2.56,0,0,1,425.3,304Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.48,306.65v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.19,2.19,0,0,0,1.14.28v-1.62a2.21,2.21,0,0,1-1.14-.27l-5.77-3.33A1,1,0,0,1,419.48,306.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.49,301l5.77,3.33a2.56,2.56,0,0,0,2.29,0l3.08-1.78a.76.76,0,0,0,.45-.64v-1.66a.74.74,0,0,0-.45-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-3.08,1.78a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,406.49,301Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.49,301l5.77,3.33a2.56,2.56,0,0,0,2.29,0l3.08-1.78a.76.76,0,0,0,.45-.64v-1.66a.74.74,0,0,0-.45-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-3.08,1.78a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,406.49,301Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,296.28l5.77,3.33a.7.7,0,0,1,0,1.32l-3.08,1.78a2.56,2.56,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l3.08-1.78A2.5,2.5,0,0,1,411.86,296.28Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,298.89v1.46a.76.76,0,0,0,.45.64l5.77,3.33a2.33,2.33,0,0,0,1.15.27V303a2.35,2.35,0,0,1-1.15-.27l-5.77-3.33A1,1,0,0,1,406,298.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.33,332l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.75.75,0,0,0,.44-.63c0-.07,0-1.6,0-1.67a.76.76,0,0,0-.44-.63l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.75.75,0,0,0-.44.63c0,.06,0,1.6,0,1.66A.77.77,0,0,0,433.33,332Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.42,325.74l5.77,3.33a.7.7,0,0,1,0,1.32l-5.8,3.35a2.56,2.56,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,441.42,325.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.27,326a1.87,1.87,0,0,1,.9.2l5.77,3.33c.16.1.22.19.22.23s-.06.14-.22.23l-5.8,3.35a2.1,2.1,0,0,1-1.79,0L433.58,330c-.16-.1-.22-.19-.22-.23s.06-.14.22-.23l5.8-3.35a1.86,1.86,0,0,1,.89-.2m0-.5a2.37,2.37,0,0,0-1.14.27l-5.8,3.35a.7.7,0,0,0,0,1.32l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.7.7,0,0,0,0-1.32l-5.77-3.33a2.38,2.38,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.89,329.92v1.46a.76.76,0,0,0,.45.64l5.76,3.33a2.35,2.35,0,0,0,1.15.27V334a2.38,2.38,0,0,1-1.15-.27l-5.76-3.33A.94.94,0,0,1,432.89,329.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.89,329.92v-.19a.68.68,0,0,1,.23-.49A.62.62,0,0,0,432.89,329.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.92,324.23l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.75.75,0,0,0,.45-.64v-1.66a.75.75,0,0,0-.45-.63L428,318a2.5,2.5,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,419.92,324.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,318l5.76,3.33a.69.69,0,0,1,0,1.32L428,326a2.56,2.56,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.5,2.5,0,0,1,428,318Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.86,318.17h0a1.9,1.9,0,0,1,.9.21l5.76,3.33c.17.1.23.19.23.23s-.06.14-.23.23l-5.79,3.35a1.9,1.9,0,0,1-.9.2,1.83,1.83,0,0,1-.89-.2l-5.77-3.33c-.17-.1-.23-.19-.23-.23s.06-.14.23-.23l5.79-3.35a1.9,1.9,0,0,1,.9-.21m0-.49a2.41,2.41,0,0,0-1.15.27l-5.79,3.35a.7.7,0,0,0,0,1.32l5.77,3.33a2.34,2.34,0,0,0,1.14.27A2.38,2.38,0,0,0,428,326l5.79-3.35a.69.69,0,0,0,0-1.32L428,318a2.41,2.41,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.47,322.13v1.46a.76.76,0,0,0,.45.64l5.77,3.33a2.33,2.33,0,0,0,1.15.27v-1.61a2.35,2.35,0,0,1-1.15-.27l-5.77-3.33A.94.94,0,0,1,419.47,322.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.47,322.13v-.19a.66.66,0,0,1,.24-.49A.61.61,0,0,0,419.47,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,316.44l5.76,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.76.76,0,0,0,.45-.64v-1.66a.78.78,0,0,0-.45-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-5.79,3.34a.76.76,0,0,0-.45.63v1.67A.76.76,0,0,0,406.51,316.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,310.16l5.77,3.33a.7.7,0,0,1,0,1.32l-5.8,3.35a2.56,2.56,0,0,1-2.29,0l-5.76-3.33a.7.7,0,0,1,0-1.33l5.79-3.34A2.5,2.5,0,0,1,414.59,310.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.45,310.38a1.86,1.86,0,0,1,.89.21l5.77,3.33c.16.1.22.19.22.23s-.06.13-.22.23l-5.8,3.35a1.83,1.83,0,0,1-.89.2,1.79,1.79,0,0,1-.9-.21l-5.76-3.32c-.17-.1-.23-.19-.23-.23s.06-.14.23-.23l5.79-3.35a1.9,1.9,0,0,1,.9-.21m0-.5a2.39,2.39,0,0,0-1.15.28l-5.79,3.34a.7.7,0,0,0,0,1.33l5.76,3.33a2.38,2.38,0,0,0,1.15.27,2.34,2.34,0,0,0,1.14-.27l5.8-3.35a.7.7,0,0,0,0-1.32l-5.77-3.33a2.35,2.35,0,0,0-1.14-.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.06,314.34v1.46a.78.78,0,0,0,.45.64l5.77,3.33a2.32,2.32,0,0,0,1.14.27v-1.61a2.32,2.32,0,0,1-1.14-.27l-5.77-3.33A.94.94,0,0,1,406.06,314.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.06,314.34v-.19a.68.68,0,0,1,.24-.5A.63.63,0,0,0,406.06,314.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.27,339l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.8-3.35a.75.75,0,0,0,.44-.63v-1.66a.77.77,0,0,0-.44-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.75.75,0,0,0-.44.63c0,.07,0,1.6,0,1.66A.77.77,0,0,0,421.27,339Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36,332.7l5.77,3.33a.7.7,0,0,1,0,1.33l-5.8,3.34a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,429.36,332.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.21,332.93h0a1.87,1.87,0,0,1,.9.2l5.77,3.33c.16.1.22.19.22.23s-.06.14-.22.23l-5.8,3.35a2,2,0,0,1-1.79,0l-5.77-3.33c-.16-.1-.22-.19-.22-.23s.06-.13.22-.23l5.8-3.35a1.86,1.86,0,0,1,.89-.2m0-.5a2.34,2.34,0,0,0-1.14.27l-5.8,3.35a.7.7,0,0,0,0,1.32L427,340.7a2.56,2.56,0,0,0,2.29,0l5.8-3.34a.7.7,0,0,0,0-1.33l-5.77-3.33a2.38,2.38,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,336.89v1.45a.75.75,0,0,0,.45.64l5.76,3.33a2.25,2.25,0,0,0,1.15.27V341a2.38,2.38,0,0,1-1.15-.27l-5.76-3.33A1,1,0,0,1,420.83,336.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,336.89v-.2a.7.7,0,0,1,.23-.49A.64.64,0,0,0,420.83,336.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.86,331.19l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.74.74,0,0,0,.45-.63v-1.66a.76.76,0,0,0-.45-.64L416,324.91a2.58,2.58,0,0,0-2.3,0l-5.79,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,407.86,331.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,324.91l5.76,3.33a.7.7,0,0,1,0,1.32l-5.79,3.35a2.56,2.56,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.79-3.35A2.58,2.58,0,0,1,416,324.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,325.14a1.9,1.9,0,0,1,.9.2l5.76,3.33c.17.1.23.19.23.23s-.06.14-.23.23l-5.79,3.35a1.9,1.9,0,0,1-.9.21,1.83,1.83,0,0,1-.89-.21l-5.77-3.33c-.17-.1-.23-.19-.23-.23s.06-.14.23-.23l5.79-3.35a1.9,1.9,0,0,1,.9-.2m0-.5a2.41,2.41,0,0,0-1.15.27l-5.79,3.35a.7.7,0,0,0,0,1.32l5.77,3.33a2.34,2.34,0,0,0,1.14.27,2.38,2.38,0,0,0,1.15-.27l5.79-3.35a.7.7,0,0,0,0-1.32L416,324.91a2.41,2.41,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,329.09v1.46a.76.76,0,0,0,.45.64l5.77,3.33a2.23,2.23,0,0,0,1.15.27v-1.61a2.35,2.35,0,0,1-1.15-.27l-5.77-3.33A.94.94,0,0,1,407.41,329.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,329.09v-.19a.66.66,0,0,1,.24-.49A.62.62,0,0,0,407.41,329.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.45,323.4l5.76,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.74.74,0,0,0,.45-.64v-1.66a.79.79,0,0,0-.45-.63l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.79,3.35a.74.74,0,0,0-.45.63v1.66A.76.76,0,0,0,394.45,323.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.53,317.12l5.77,3.33a.7.7,0,0,1,0,1.32l-5.8,3.35a2.56,2.56,0,0,1-2.29,0l-5.76-3.33c-.64-.37-.64-1,0-1.32l5.79-3.35A2.56,2.56,0,0,1,402.53,317.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,317.35a1.86,1.86,0,0,1,.89.2l5.77,3.33c.16.1.22.19.22.23s-.06.14-.22.23l-5.8,3.35a1.83,1.83,0,0,1-.89.2,1.9,1.9,0,0,1-.9-.2l-5.77-3.33c-.16-.1-.22-.19-.22-.23s.06-.14.22-.23l5.8-3.35a1.87,1.87,0,0,1,.9-.2m0-.5a2.38,2.38,0,0,0-1.15.27l-5.79,3.35c-.64.36-.64.95,0,1.32l5.76,3.33a2.38,2.38,0,0,0,1.15.27,2.34,2.34,0,0,0,1.14-.27l5.8-3.35a.7.7,0,0,0,0-1.32l-5.77-3.33a2.34,2.34,0,0,0-1.14-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,321.3v1.46a.76.76,0,0,0,.45.64l5.77,3.33a2.29,2.29,0,0,0,1.14.27v-1.61a2.32,2.32,0,0,1-1.14-.27l-5.77-3.33A.94.94,0,0,1,394,321.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,321.3v-.19a.66.66,0,0,1,.24-.49A.61.61,0,0,0,394,321.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.21,345.94l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.8-3.34a.77.77,0,0,0,.44-.64v-1.66a.77.77,0,0,0-.44-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.76.76,0,0,0-.44.63c0,.07,0,1.6,0,1.67A.78.78,0,0,0,409.21,345.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,339.66l5.77,3.33a.7.7,0,0,1,0,1.33l-5.8,3.34a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,417.3,339.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.15,339.89a1.79,1.79,0,0,1,.9.21l5.77,3.33c.16.09.22.19.22.23s-.06.13-.22.22l-5.8,3.35a2,2,0,0,1-1.79,0l-5.77-3.33c-.16-.09-.22-.19-.22-.23s.06-.13.22-.23l5.8-3.34a1.75,1.75,0,0,1,.89-.21m0-.5a2.34,2.34,0,0,0-1.14.27l-5.8,3.35a.7.7,0,0,0,0,1.32l5.77,3.33a2.48,2.48,0,0,0,2.29,0l5.8-3.34a.7.7,0,0,0,0-1.33l-5.77-3.33a2.38,2.38,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.77,343.85v1.45a.76.76,0,0,0,.44.64l5.77,3.33a2.25,2.25,0,0,0,1.15.28v-1.62a2.27,2.27,0,0,1-1.15-.27l-5.77-3.33A1,1,0,0,1,408.77,343.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.77,343.85v-.2a.66.66,0,0,1,.23-.49A.64.64,0,0,0,408.77,343.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,338.15l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.79-3.34a.76.76,0,0,0,.45-.64v-1.66a.76.76,0,0,0-.45-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.79,3.35a.78.78,0,0,0-.45.63v1.66A.75.75,0,0,0,395.8,338.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.89,331.87l5.76,3.33a.7.7,0,0,1,0,1.33l-5.79,3.34a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.79-3.35A2.58,2.58,0,0,1,403.89,331.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74,332.1h0a1.79,1.79,0,0,1,.9.21l5.76,3.32c.17.1.23.19.23.23s-.06.14-.23.23l-5.79,3.35a1.9,1.9,0,0,1-.9.21,1.83,1.83,0,0,1-.89-.21l-5.77-3.33c-.17-.1-.23-.19-.23-.23s.06-.13.23-.23l5.79-3.35a1.9,1.9,0,0,1,.9-.2m0-.5a2.41,2.41,0,0,0-1.15.27l-5.79,3.35a.7.7,0,0,0,0,1.32l5.77,3.33a2.35,2.35,0,0,0,1.14.28,2.39,2.39,0,0,0,1.15-.28l5.79-3.34a.7.7,0,0,0,0-1.33l-5.76-3.33a2.41,2.41,0,0,0-1.15-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,336.06v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.23,2.23,0,0,0,1.15.28v-1.62a2.25,2.25,0,0,1-1.15-.27l-5.77-3.33A1,1,0,0,1,395.35,336.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,336.06v-.2a.68.68,0,0,1,.24-.49A.63.63,0,0,0,395.35,336.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,330.36l5.76,3.33a2.5,2.5,0,0,0,2.29,0l5.8-3.35a.74.74,0,0,0,.45-.63v-1.66a.81.81,0,0,0-.45-.64l-5.77-3.33a2.56,2.56,0,0,0-2.29,0l-5.79,3.35a.74.74,0,0,0-.45.63v1.66A.76.76,0,0,0,382.39,330.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,324.08l5.77,3.33a.7.7,0,0,1,0,1.32l-5.8,3.35a2.5,2.5,0,0,1-2.29,0l-5.76-3.33a.69.69,0,0,1,0-1.32l5.79-3.35A2.56,2.56,0,0,1,390.47,324.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.33,324.31a1.86,1.86,0,0,1,.89.2l5.77,3.33c.16.1.22.19.22.23s-.06.14-.22.23l-5.8,3.35a1.83,1.83,0,0,1-.89.21,1.9,1.9,0,0,1-.9-.21l-5.77-3.33c-.16-.1-.22-.19-.22-.23s.06-.13.22-.23l5.8-3.35a1.87,1.87,0,0,1,.9-.2m0-.5a2.38,2.38,0,0,0-1.15.27l-5.79,3.35a.69.69,0,0,0,0,1.32l5.76,3.33a2.38,2.38,0,0,0,1.15.27,2.34,2.34,0,0,0,1.14-.27l5.8-3.35a.7.7,0,0,0,0-1.32l-5.77-3.33a2.34,2.34,0,0,0-1.14-.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,328.27v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.19,2.19,0,0,0,1.14.27v-1.61a2.32,2.32,0,0,1-1.14-.27l-5.77-3.33A1,1,0,0,1,381.94,328.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.94,328.27v-.2a.68.68,0,0,1,.24-.49A.63.63,0,0,0,381.94,328.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.15,352.9l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.8-3.34a.77.77,0,0,0,.44-.64v-1.66A.75.75,0,0,0,411,350l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-5.8,3.34a.79.79,0,0,0-.45.63v1.67A.78.78,0,0,0,397.15,352.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.24,346.63,411,350a.7.7,0,0,1,0,1.32l-5.8,3.34a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.34A2.5,2.5,0,0,1,405.24,346.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.09,346.85a1.9,1.9,0,0,1,.9.21l5.77,3.33c.16.09.22.19.22.23s-.06.13-.22.23l-5.8,3.34a2,2,0,0,1-1.79,0l-5.77-3.33c-.16-.09-.22-.19-.22-.23s.06-.13.22-.23l5.8-3.34a1.86,1.86,0,0,1,.89-.21m0-.5a2.24,2.24,0,0,0-1.14.28l-5.8,3.34a.7.7,0,0,0,0,1.32l5.77,3.33a2.48,2.48,0,0,0,2.29,0l5.8-3.34a.7.7,0,0,0,0-1.32l-5.77-3.33a2.28,2.28,0,0,0-1.15-.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.71,350.81v1.45a.79.79,0,0,0,.44.65l5.77,3.32a2.25,2.25,0,0,0,1.15.28V354.9a2.28,2.28,0,0,1-1.15-.28l-5.77-3.33A1,1,0,0,1,396.71,350.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.71,350.81v-.19a.67.67,0,0,1,.23-.5A.64.64,0,0,0,396.71,350.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,345.11l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.79-3.34a.76.76,0,0,0,.45-.64V342.8a.76.76,0,0,0-.45-.64l-5.77-3.32a2.5,2.5,0,0,0-2.29,0l-5.79,3.34a.79.79,0,0,0-.45.63v1.67A.74.74,0,0,0,383.74,345.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.82,338.84l5.77,3.32a.7.7,0,0,1,0,1.33l-5.79,3.34a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.79-3.34A2.5,2.5,0,0,1,391.82,338.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.68,339.06a1.9,1.9,0,0,1,.9.21l5.76,3.33c.17.09.23.19.23.23s-.06.13-.23.23l-5.79,3.34a1.9,1.9,0,0,1-.9.21,1.83,1.83,0,0,1-.89-.21L384,343.07c-.17-.09-.23-.19-.23-.23s.06-.13.23-.23l5.79-3.34a1.9,1.9,0,0,1,.9-.21m0-.5a2.3,2.3,0,0,0-1.15.28l-5.79,3.34a.7.7,0,0,0,0,1.32l5.77,3.33a2.24,2.24,0,0,0,1.14.28,2.28,2.28,0,0,0,1.15-.28l5.79-3.34a.7.7,0,0,0,0-1.33l-5.77-3.32a2.24,2.24,0,0,0-1.14-.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,343v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.23,2.23,0,0,0,1.15.28V347.1a2.25,2.25,0,0,1-1.15-.27l-5.77-3.33A1,1,0,0,1,383.29,343Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,343v-.2a.68.68,0,0,1,.24-.49A.63.63,0,0,0,383.29,343Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.33,337.32l5.76,3.33a2.5,2.5,0,0,0,2.29,0l5.8-3.34a.79.79,0,0,0,.45-.64V335a.81.81,0,0,0-.45-.64L378.41,331a2.56,2.56,0,0,0-2.29,0l-5.79,3.35a.74.74,0,0,0-.45.63v1.66A.75.75,0,0,0,370.33,337.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.41,331l5.77,3.33a.7.7,0,0,1,0,1.33l-5.8,3.34a2.5,2.5,0,0,1-2.29,0l-5.76-3.33a.69.69,0,0,1,0-1.32l5.79-3.35A2.56,2.56,0,0,1,378.41,331Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.18,334.37c-2-1-4.05-2.26-6-3.31a2.84,2.84,0,0,0-2.67.47l-1.72,1c-1.13.65-2.28,1.28-3.44,1.89q1.67-1,3.36-2l1.69-1a2.9,2.9,0,0,1,2.88-.51c2,1.11,4,2.34,5.92,3.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.88,335.23v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.19,2.19,0,0,0,1.14.28v-1.62a2.21,2.21,0,0,1-1.14-.27l-5.77-3.33A1,1,0,0,1,369.88,335.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09,308.65l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.77.77,0,0,0,.44-.64v-1.66a.75.75,0,0,0-.44-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-5.8,3.34a.79.79,0,0,0-.45.63V308A.81.81,0,0,0,393.09,308.65Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09,308.65l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.8-3.35a.77.77,0,0,0,.44-.64v-1.66a.75.75,0,0,0-.44-.63l-5.77-3.33a2.5,2.5,0,0,0-2.29,0l-5.8,3.34a.79.79,0,0,0-.45.63V308A.81.81,0,0,0,393.09,308.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,302.37,407,305.7a.7.7,0,0,1,0,1.32l-5.8,3.35a2.56,2.56,0,0,1-2.29,0L393.09,307a.7.7,0,0,1,0-1.33l5.8-3.34A2.5,2.5,0,0,1,401.18,302.37Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,302.37,407,305.7a.7.7,0,0,1,0,1.32l-5.8,3.35a2.56,2.56,0,0,1-2.29,0L393.09,307a.7.7,0,0,1,0-1.33l5.8-3.34A2.5,2.5,0,0,1,401.18,302.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,306.55V308a.8.8,0,0,0,.45.65l5.77,3.33a2.35,2.35,0,0,0,1.15.27v-1.61a2.28,2.28,0,0,1-1.15-.28L393.09,307A1,1,0,0,1,392.64,306.55Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,315.61l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.75.75,0,0,0,.45-.64v-1.66a.75.75,0,0,0-.45-.63l-5.76-3.33a2.5,2.5,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63V315A.81.81,0,0,0,381,315.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,315.61l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.75.75,0,0,0,.45-.64v-1.66a.75.75,0,0,0-.45-.63l-5.76-3.33a2.5,2.5,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63V315A.81.81,0,0,0,381,315.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,309.33l5.76,3.33a.69.69,0,0,1,0,1.32l-5.79,3.35a2.56,2.56,0,0,1-2.29,0L381,314a.7.7,0,0,1,0-1.32l5.8-3.35A2.5,2.5,0,0,1,389.12,309.33Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,309.33l5.76,3.33a.69.69,0,0,1,0,1.32l-5.79,3.35a2.56,2.56,0,0,1-2.29,0L381,314a.7.7,0,0,1,0-1.32l5.8-3.35A2.5,2.5,0,0,1,389.12,309.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,313.51V315a.8.8,0,0,0,.45.64l5.77,3.33a2.35,2.35,0,0,0,1.15.27V317.6a2.38,2.38,0,0,1-1.15-.27L381,314A1,1,0,0,1,380.58,313.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,322.57l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.74.74,0,0,0,.45-.63v-1.67a.75.75,0,0,0-.45-.63l-5.76-3.33a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,369,322.57Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,322.57l5.77,3.33a2.56,2.56,0,0,0,2.29,0l5.79-3.35a.74.74,0,0,0,.45-.63v-1.67a.75.75,0,0,0-.45-.63l-5.76-3.33a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,369,322.57Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,316.29l5.76,3.33c.64.37.64,1,0,1.32L377,324.29a2.56,2.56,0,0,1-2.29,0L369,321a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,377.06,316.29Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,316.29l5.76,3.33c.64.37.64,1,0,1.32L377,324.29a2.56,2.56,0,0,1-2.29,0L369,321a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,377.06,316.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.52,320.47v1.46a.79.79,0,0,0,.45.64l5.77,3.33a2.35,2.35,0,0,0,1.15.27v-1.61a2.38,2.38,0,0,1-1.15-.27L369,321A1,1,0,0,1,368.52,320.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91,329.53l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.79-3.35a.74.74,0,0,0,.45-.63v-1.66a.76.76,0,0,0-.45-.64L365,323.25a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,356.91,329.53Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91,329.53l5.77,3.33a2.5,2.5,0,0,0,2.29,0l5.79-3.35a.74.74,0,0,0,.45-.63v-1.66a.76.76,0,0,0-.45-.64L365,323.25a2.56,2.56,0,0,0-2.29,0l-5.8,3.35a.78.78,0,0,0-.45.63v1.66A.76.76,0,0,0,356.91,329.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,323.25l5.76,3.33c.64.37.64,1,0,1.32L365,331.25a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,365,323.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,323.25l5.76,3.33c.64.37.64,1,0,1.32L365,331.25a2.5,2.5,0,0,1-2.29,0l-5.77-3.33a.7.7,0,0,1,0-1.32l5.8-3.35A2.56,2.56,0,0,1,365,323.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,327.44v1.45a.75.75,0,0,0,.45.64l5.77,3.33a2.23,2.23,0,0,0,1.15.27v-1.61a2.35,2.35,0,0,1-1.15-.27l-5.77-3.33A1.07,1.07,0,0,1,356.46,327.44Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M143.82,342.44c-17.12,9.88-17.12,25.9,0,35.78s44.86,9.88,62,0,17.11-25.9,0-35.78S160.93,332.56,143.82,342.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,351.13a23,23,0,0,0-8.47-7.84c-13.85-8-36.31-8-50.16,0a22.87,22.87,0,0,0-8.47,7.84H140v7.24h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.84,10.13-8.84,10.39-13.88h0v-7.24Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,351.13a23,23,0,0,0-8.47-7.84c-13.85-8-36.31-8-50.16,0a22.87,22.87,0,0,0-8.47,7.84H140v7.24h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.84,10.13-8.84,10.39-13.88h0v-7.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,337.3c-9.08,0-18.16,2-25.08,6a22.87,22.87,0,0,0-8.47,7.84H140v7.24h0c.26,5,3.71,10,10.37,13.88,6.92,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,340.62a38.85,38.85,0,0,0-5.71,2.67,22.87,22.87,0,0,0-8.47,7.84H140v7.24h0c.26,5,3.71,10,10.37,13.88a38.88,38.88,0,0,0,5.71,2.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,340.62a39.34,39.34,0,0,1,5.71,2.67,23,23,0,0,1,8.47,7.84H211v7.24h0c-.26,5-3.73,10-10.39,13.88a39.37,39.37,0,0,1-5.71,2.68Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,336.65c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.87,44.59,2.63h0l.55-.21a37.51,37.51,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.75-24.61h0a27.05,27.05,0,0,0-5.75-4.35C186.74,328.66,164.28,328.65,150.43,336.65Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,336.65c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.87,44.59,2.63h0l.55-.21a37.51,37.51,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.75-24.61h0a27.05,27.05,0,0,0-5.75-4.35C186.74,328.66,164.28,328.65,150.43,336.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34,341a15.49,15.49,0,0,1,3.71,12.64c-1.23,7-11.08,13-14.48,14.38a37.51,37.51,0,0,0,5-2.41C212.14,358.94,214.06,348.82,206.34,341Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.67,361.26A15.55,15.55,0,0,1,141,348.63c1.23-7,11.09-13,14.48-14.39a39.28,39.28,0,0,0-5,2.41C138.88,343.32,137,353.44,144.67,361.26Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.52,
    cy: 351.1,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.52,
    cy: 351.1,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,356.79c2.65-4.9,1.79-10.3-2.59-14.88a21.9,21.9,0,0,0-2.79-2.45,29.4,29.4,0,0,0-2.67-1.76c-.52-.3-1.06-.6-1.62-.88,1.37,2.26.87,4.67-6.9,5.13-15.2.89,4.06,15.41,4.06,15.41S204.28,352.63,207,356.79Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,352.77c2.28-.25,3.41-2.6,2.52-5.24s-3.45-4.57-5.73-4.31-3.42,2.6-2.53,5.24S203.14,353,205.43,352.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.39,364.87c-.75-5.64-25.42-21.26-25.42-21.26s-5.47-2.2-3.65-6a26.09,26.09,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.26-7.35,6.36-7.35,14.72,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.95,2.61,1.37.72.34,1.47.66,2.22,1s1.53.58,2.32.83a48.08,48.08,0,0,0,7.35,1.77c.55.09,1.11.17,1.66.24a57.27,57.27,0,0,0,16.36-.27S180.68,368.58,181.39,364.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,364.87c-.75-5.64-25.42-21.26-25.42-21.26s-5.47-2.2-3.65-6a26.09,26.09,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.26-7.35,6.36-7.36,14.72,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.95,2.61,1.37q1.08.51,2.22,1c.75.3,1.53.58,2.31.83a48.49,48.49,0,0,0,7.36,1.77c.55.09,1.11.17,1.66.24a57.27,57.27,0,0,0,16.36-.27S180.33,368.58,181,364.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.14,341.07c-9.2,5.32-9.57,13.79-1.12,19.36.36.24.73.47,1.12.7,9.6,5.54,25.14,5.54,34.74,0s9.59-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C182,335.54,167.34,335.76,158.14,341.07Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.14,341.07c-9.2,5.32-9.57,13.79-1.12,19.36.36.24.73.47,1.12.7,9.6,5.54,25.14,5.54,34.74,0s9.59-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C182,335.54,167.34,335.76,158.14,341.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.52,
    cy: 351.1,
    rx: 23.48,
    ry: 13.56,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.52,
    cy: 351.1,
    rx: 23.48,
    ry: 13.56,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.92,345.3c9.17-5.3,24-5.3,33.2,0,3.75,2.16,6,4.88,6.65,7.69-.68,2.82-2.9,5.53-6.65,7.7-9.17,5.29-24,5.29-33.2,0-3.75-2.17-6-4.88-6.65-7.7C153,350.18,155.17,347.46,158.92,345.3Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.92,345.3c9.17-5.3,24-5.3,33.2,0,3.75,2.16,6,4.88,6.65,7.69-.68,2.82-2.9,5.53-6.65,7.7-9.17,5.29-24,5.29-33.2,0-3.75-2.17-6-4.88-6.65-7.7C153,350.18,155.17,347.46,158.92,345.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.31,355.19c0-.46,0-2.33,0-2.81,0-1.15-.8-2.26-2.51-3.26l-.06,0c-3.15-1.82-6.41-1.58-9.31-.85h0c-1.24.31-2.41.71-3.48,1.08a36.88,36.88,0,0,1-3.73,1.16h0a6.62,6.62,0,0,1-1.77.17,3.78,3.78,0,0,1-1.47-.39l.12-.08a3.32,3.32,0,0,1,.37-.23,9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3v-2.79a14.32,14.32,0,0,0-8.23-.3,16.52,16.52,0,0,0-2.61.91l-3-1.74-3.6,2.07v2.79l1.23.71a3,3,0,0,0-.53,1.62c0,.47,0,2.32,0,2.79,0,1.15.82,2.26,2.56,3.26a10.45,10.45,0,0,0,5,1.42h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15l1-.36-3,3v2.79a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.07v-2.79L189.7,357A3.32,3.32,0,0,0,190.31,355.19Zm-7.58-.24c-.28.15-.56.29-.83.41a7.73,7.73,0,0,1-5.88.09c2.81-1,5.16-1.86,7.17-.8C183.05,354.75,182.9,354.85,182.73,355Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.43,348.23h0c-1.24.31-2.41.71-3.48,1.08a36.88,36.88,0,0,1-3.73,1.16h0a6.62,6.62,0,0,1-1.77.17,3.9,3.9,0,0,1-1.71-.51c-1.15-.67-1.32-1.65.36-2.75.11-.08.24-.15.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.11l3-3a14.32,14.32,0,0,0-8.23-.3,16.52,16.52,0,0,0-2.61.91l-3-1.74-3.6,2.07,3,1.72,0,0c-3,2.3-3.08,4.68.32,6.64a10.46,10.46,0,0,0,5,1.43h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3-.28.15-.56.29-.83.41a7.75,7.75,0,0,1-6,.05l-3.15,3.16a14.8,14.8,0,0,0,11.61-.5l3,1.71,3.59-2.07L188,356c3-2.31,3.33-4.83-.16-6.87l-.06,0C184.59,347.26,181.33,347.5,178.43,348.23Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.43,348.23h0c-1.24.31-2.41.71-3.48,1.08a36.88,36.88,0,0,1-3.73,1.16h0a6.62,6.62,0,0,1-1.77.17,3.9,3.9,0,0,1-1.71-.51c-1.15-.67-1.32-1.65.36-2.75.11-.08.24-.15.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.11l3-3a14.32,14.32,0,0,0-8.23-.3,16.52,16.52,0,0,0-2.61.91l-3-1.74-3.6,2.07,3,1.72,0,0c-3,2.3-3.08,4.68.32,6.64a10.46,10.46,0,0,0,5,1.43h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3-.28.15-.56.29-.83.41a7.75,7.75,0,0,1-6,.05l-3.15,3.16a14.8,14.8,0,0,0,11.61-.5l3,1.71,3.59-2.07L188,356c3-2.31,3.33-4.83-.16-6.87l-.06,0C184.59,347.26,181.33,347.5,178.43,348.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "160.2 344.45 163.83 342.81 166.81 344.12 163.8 342.38 160.2 344.45",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,343.32a16.79,16.79,0,0,1,7.72.27l-2.09,3,3-3A14.38,14.38,0,0,0,169,343.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,349.08l.06,0c3.49,2,3.15,4.56.16,6.87,2.65-2.88,2.17-4.89-.71-6.56a13.63,13.63,0,0,0-8.82-1.2C181.33,347.5,184.59,347.26,187.74,349.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.96 355.99 190.24 357.74 187.34 359.78 190.93 357.71 187.96 355.99",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.9,355.36a7.72,7.72,0,0,1-5.73.5l-3.41,2.71,3.15-3.16A7.75,7.75,0,0,0,181.9,355.36Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.19,350.47a4.68,4.68,0,0,1-4.3-.41c-1-.89-.37-1.85,1.18-2.68-1.68,1.1-1.51,2.08-.36,2.75a3.9,3.9,0,0,0,1.71.51A6.62,6.62,0,0,0,171.19,350.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,346.19c-.25.23-2.42,2.24-1.46,4.26s4.18,3.53,6.74,3.81h0a10.46,10.46,0,0,1-5-1.43C160.07,350.87,160.13,348.49,163.15,346.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,341.32a22.77,22.77,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.92,22.92,0,0,0-8.47,7.83H145.2v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.14-8.84,10.39-13.88h0v-7.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,341.32a22.77,22.77,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.92,22.92,0,0,0-8.47,7.83H145.2v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.14-8.84,10.39-13.88h0v-7.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67,327.49c-9.07,0-18.15,2-25.08,6a22.92,22.92,0,0,0-8.47,7.83H145.2v7.25h0c.25,5,3.7,10,10.36,13.88,6.93,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,330.81a38.35,38.35,0,0,0-5.71,2.68,22.92,22.92,0,0,0-8.47,7.83H145.2v7.25h0c.25,5,3.7,10,10.36,13.88a39.34,39.34,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,330.81a37.88,37.88,0,0,1,5.71,2.68,22.77,22.77,0,0,1,8.47,7.83h1.92v7.25h0c-.26,5-3.73,10-10.39,13.88a38.85,38.85,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.59,326.84c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.88,44.6,2.63h0l.55-.22a38,38,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.76-24.6h0a27.13,27.13,0,0,0-5.75-4.35C191.9,318.85,169.44,318.85,155.59,326.84Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.59,326.84c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.88,44.6,2.63h0l.55-.22a38,38,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.76-24.6h0a27.13,27.13,0,0,0-5.75-4.35C191.9,318.85,169.44,318.85,155.59,326.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.51,331.2a15.52,15.52,0,0,1,3.71,12.63c-1.23,7-11.09,13-14.48,14.38a38,38,0,0,0,5-2.41C217.3,349.14,219.22,339,211.51,331.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84,351.45a15.48,15.48,0,0,1-3.71-12.63c1.23-7,11.08-13,14.48-14.38a37.51,37.51,0,0,0-5,2.41C144,333.51,142.12,343.64,149.84,351.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.68,
    cy: 341.3,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.68,
    cy: 341.3,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,347c2.65-4.9,1.78-10.3-2.59-14.88a22.56,22.56,0,0,0-2.79-2.44,28.7,28.7,0,0,0-2.67-1.76c-.53-.31-1.07-.6-1.63-.88,1.37,2.25.87,4.67-6.89,5.12-15.2.89,4.06,15.41,4.06,15.41S209.44,342.82,212.16,347Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.59,343c2.28-.25,3.41-2.6,2.52-5.23s-3.45-4.57-5.73-4.32-3.41,2.6-2.52,5.24S208.31,343.22,210.59,343Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,355.07c-.74-5.65-25.41-21.27-25.41-21.27s-5.47-2.19-3.66-6a28.45,28.45,0,0,0-2.63,1.71c-.57.41-1.11.83-1.61,1.27-7.34,6.36-7.35,14.71,0,21.08.49.43,1,.85,1.6,1.27a27.06,27.06,0,0,0,2.44,1.59c.84.49,1.71.94,2.61,1.37.72.34,1.47.66,2.23.95s1.52.58,2.31.84a49.41,49.41,0,0,0,7.36,1.77l1.65.24a58.18,58.18,0,0,0,7.36.46,56.08,56.08,0,0,0,9-.74S185.85,358.78,186.55,355.07Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2,355.07c-.75-5.65-25.41-21.27-25.41-21.27s-5.47-2.19-3.66-6a30.07,30.07,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.27-7.34,6.36-7.35,14.71,0,21.08.5.43,1,.85,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.84.49,1.71.94,2.61,1.37.72.34,1.47.66,2.23.95s1.52.58,2.31.84a49.41,49.41,0,0,0,7.36,1.77l1.65.24a58.18,58.18,0,0,0,7.36.46,56,56,0,0,0,9-.74S185.5,358.78,186.2,355.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3,331.27c-9.2,5.31-9.57,13.79-1.12,19.36.36.23.74.47,1.13.69,9.59,5.54,25.14,5.54,34.73,0s9.6-14.51,0-20.05c-.39-.23-.79-.44-1.2-.65C187.19,325.74,172.51,326,163.3,331.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3,331.27c-9.2,5.31-9.57,13.79-1.12,19.36.36.23.74.47,1.13.69,9.59,5.54,25.14,5.54,34.73,0s9.6-14.51,0-20.05c-.39-.23-.79-.44-1.2-.65C187.19,325.74,172.51,326,163.3,331.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.69,
    cy: 341.3,
    rx: 23.48,
    ry: 13.56,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.69,
    cy: 341.3,
    rx: 23.48,
    ry: 13.56,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,335.49c9.17-5.29,24-5.29,33.21,0,3.75,2.17,6,4.88,6.64,7.7-.68,2.81-2.89,5.53-6.64,7.69-9.17,5.29-24,5.29-33.21,0-3.75-2.16-6-4.88-6.64-7.69C158.12,340.37,160.33,337.66,164.08,335.49Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,335.49c9.17-5.29,24-5.29,33.21,0,3.75,2.17,6,4.88,6.64,7.7-.68,2.81-2.89,5.53-6.64,7.69-9.17,5.29-24,5.29-33.21,0-3.75-2.16-6-4.88-6.64-7.69C158.12,340.37,160.33,337.66,164.08,335.49Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.47,345.38c0-.46,0-2.32,0-2.8,0-1.15-.79-2.27-2.5-3.27l-.06,0c-3.16-1.82-6.41-1.58-9.32-.85h0c-1.23.31-2.41.71-3.48,1.07a32.28,32.28,0,0,1-3.72,1.16h0a6.26,6.26,0,0,1-1.77.17,3.78,3.78,0,0,1-1.47-.39l.11-.08.37-.23a9.08,9.08,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.11l3-3V333.7a14.41,14.41,0,0,0-8.23-.3,17.71,17.71,0,0,0-2.62.91l-3-1.74-3.59,2.08v2.78l1.23.71a3,3,0,0,0-.53,1.63v2.78c0,1.15.83,2.26,2.56,3.26a10.5,10.5,0,0,0,5,1.43h0c.33,0,.67,0,1,0a19.53,19.53,0,0,0,5.32-1.15l1-.35-3,3v2.79a14.8,14.8,0,0,0,11.61-.5l3,1.71,3.6-2.07V347.9l-1.24-.71A3.3,3.3,0,0,0,195.47,345.38Zm-7.58-.24a7.18,7.18,0,0,1-.83.42,7.7,7.7,0,0,1-5.87.08c2.81-1,5.16-1.86,7.16-.79C188.21,345,188.06,345,187.89,345.14Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,338.42h0c-1.23.31-2.41.71-3.48,1.07a32.28,32.28,0,0,1-3.72,1.16h0a6.26,6.26,0,0,1-1.77.17,3.74,3.74,0,0,1-1.71-.51c-1.16-.67-1.33-1.64.35-2.75l.37-.22a7.57,7.57,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.41,14.41,0,0,0-8.23-.3,17.71,17.71,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.5,10.5,0,0,0,5,1.43h1a19.91,19.91,0,0,0,5.32-1.15c3.45-1.16,6.25-2.52,8.57-1.17,1.55.89,1.12,2-.59,3a7.18,7.18,0,0,1-.83.42,7.72,7.72,0,0,1-6,0l-3.16,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.6-2.08-3-1.71c3-2.32,3.34-4.83-.15-6.88l-.06,0C189.75,337.45,186.5,337.69,183.59,338.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.59,338.42h0c-1.23.31-2.41.71-3.48,1.07a32.28,32.28,0,0,1-3.72,1.16h0a6.26,6.26,0,0,1-1.77.17,3.74,3.74,0,0,1-1.71-.51c-1.16-.67-1.33-1.64.35-2.75l.37-.22a7.57,7.57,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.41,14.41,0,0,0-8.23-.3,17.71,17.71,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.5,10.5,0,0,0,5,1.43h1a19.91,19.91,0,0,0,5.32-1.15c3.45-1.16,6.25-2.52,8.57-1.17,1.55.89,1.12,2-.59,3a7.18,7.18,0,0,1-.83.42,7.72,7.72,0,0,1-6,0l-3.16,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.6-2.08-3-1.71c3-2.32,3.34-4.83-.15-6.88l-.06,0C189.75,337.45,186.5,337.69,183.59,338.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "165.37 334.65 169 333 171.97 334.31 168.96 332.57 165.37 334.65",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.17,333.52a16.78,16.78,0,0,1,7.72.26l-2.08,3,3-3A14.33,14.33,0,0,0,174.17,333.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,339.27l.06,0c3.49,2.05,3.14,4.56.15,6.88,2.65-2.89,2.17-4.9-.7-6.56a13.61,13.61,0,0,0-8.83-1.21C186.5,337.69,189.75,337.45,192.91,339.27Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.12 346.19 195.4 347.94 192.5 349.98 196.1 347.9 193.12 346.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.06,345.56a7.78,7.78,0,0,1-5.73.5l-3.41,2.7,3.16-3.16A7.72,7.72,0,0,0,187.06,345.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.36,340.66a4.61,4.61,0,0,1-4.3-.41c-1-.89-.38-1.85,1.17-2.68-1.68,1.11-1.51,2.08-.35,2.75a3.74,3.74,0,0,0,1.71.51A6.26,6.26,0,0,0,176.36,340.66Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.31,336.39c-.25.22-2.41,2.24-1.46,4.25s4.19,3.53,6.74,3.81h0a10.5,10.5,0,0,1-5-1.43C165.23,341.06,165.3,338.68,168.31,336.39Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,328.59a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,328.59a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06,314.76c-9.08,0-18.16,2-25.08,6a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.26,5,3.71,10,10.37,13.88,6.92,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,318.09a38.85,38.85,0,0,0-5.71,2.67,22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.26,5,3.71,10,10.37,13.88a38.85,38.85,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.43,318.09a39.34,39.34,0,0,1,5.71,2.67,22.92,22.92,0,0,1,8.47,7.83h1.92v7.25h0c-.26,5-3.73,10-10.39,13.88a39.34,39.34,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,314.12c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.87,44.59,2.62h0l.55-.21a38.78,38.78,0,0,0,5-2.41c11.55-6.67,13.47-16.8,5.75-24.61h0a27,27,0,0,0-5.75-4.34C185.29,306.12,162.83,306.12,149,314.12Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,314.12c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.87,44.59,2.62h0l.55-.21a38.78,38.78,0,0,0,5-2.41c11.55-6.67,13.47-16.8,5.75-24.61h0a27,27,0,0,0-5.75-4.34C185.29,306.12,162.83,306.12,149,314.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,318.47a15.48,15.48,0,0,1,3.71,12.63c-1.23,7-11.08,13-14.48,14.39a38.78,38.78,0,0,0,5-2.41C210.69,336.41,212.61,326.28,204.89,318.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,338.73a15.54,15.54,0,0,1-3.7-12.64c1.22-7,11.08-13,14.47-14.38a38,38,0,0,0-5,2.41C137.43,320.79,135.51,330.91,143.22,338.73Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.07,
    cy: 328.57,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.07,
    cy: 328.57,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.54,334.25c2.65-4.89,1.79-10.29-2.59-14.87a21.15,21.15,0,0,0-2.79-2.45,27.43,27.43,0,0,0-2.67-1.76c-.52-.31-1.06-.6-1.62-.88,1.37,2.25.87,4.67-6.9,5.12-15.19.89,4.06,15.41,4.06,15.41S202.83,330.09,205.54,334.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,330.24c2.28-.26,3.41-2.6,2.52-5.24s-3.45-4.57-5.73-4.31-3.41,2.6-2.53,5.23S201.69,330.49,204,330.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.94,342.34c-.75-5.64-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a27.9,27.9,0,0,0-2.64,1.7c-.57.41-1.1.83-1.6,1.27-7.34,6.36-7.35,14.71,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.94,2.61,1.37.72.34,1.47.66,2.22,1s1.53.57,2.32.83a47.93,47.93,0,0,0,7.36,1.77c.54.09,1.1.17,1.65.24a56.83,56.83,0,0,0,16.36-.28S179.23,346.05,179.94,342.34Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,342.34c-.75-5.64-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a27.9,27.9,0,0,0-2.64,1.7c-.57.41-1.1.83-1.6,1.27-7.35,6.36-7.36,14.71,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.94,2.61,1.37.72.34,1.47.66,2.22,1s1.53.57,2.31.83a48.49,48.49,0,0,0,7.36,1.77c.55.09,1.11.17,1.66.24a56.83,56.83,0,0,0,16.36-.28S178.88,346.05,179.59,342.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,318.54c-9.2,5.31-9.57,13.79-1.12,19.36.36.24.73.47,1.12.7,9.6,5.53,25.14,5.53,34.74,0s9.59-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C180.57,313,165.89,313.23,156.69,318.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.69,318.54c-9.2,5.31-9.57,13.79-1.12,19.36.36.24.73.47,1.12.7,9.6,5.53,25.14,5.53,34.74,0s9.59-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C180.57,313,165.89,313.23,156.69,318.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,319c-9.17,5.3-9.17,13.88,0,19.17s24,5.3,33.2,0,9.17-13.87,0-19.17S166.64,313.69,157.47,319Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,319c-9.17,5.3-9.17,13.88,0,19.17s24,5.3,33.2,0,9.17-13.87,0-19.17S166.64,313.69,157.47,319Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,322.76c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.16,5.3-24,5.3-33.2,0-3.75-2.16-6-4.88-6.65-7.69C151.51,327.64,153.72,324.93,157.47,322.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,322.76c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.16,5.3-24,5.3-33.2,0-3.75-2.16-6-4.88-6.65-7.69C151.51,327.64,153.72,324.93,157.47,322.76Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,332.65c0-.46,0-2.32,0-2.8,0-1.15-.8-2.26-2.51-3.27l-.06,0c-3.15-1.82-6.41-1.59-9.31-.86h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.69,6.69,0,0,1-1.78.16,3.78,3.78,0,0,1-1.47-.39l.12-.08.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3V321a14.23,14.23,0,0,0-8.23-.3,16.47,16.47,0,0,0-2.61.9l-3-1.74-3.6,2.08v2.78l1.23.72a2.9,2.9,0,0,0-.52,1.62v2.78c0,1.15.82,2.26,2.56,3.26a10.46,10.46,0,0,0,5,1.43h1a19.61,19.61,0,0,0,5.33-1.16l1-.35-3,3v2.78a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08v-2.79l-1.23-.71A3.27,3.27,0,0,0,188.86,332.65Zm-7.58-.24a8.09,8.09,0,0,1-.83.42,7.77,7.77,0,0,1-5.88.09c2.81-1,5.16-1.86,7.17-.8A4,4,0,0,1,181.28,332.41Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,325.69h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.69,6.69,0,0,1-1.78.16,3.65,3.65,0,0,1-1.71-.51c-1.15-.66-1.32-1.64.36-2.74.12-.08.24-.16.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.23,14.23,0,0,0-8.23-.3,16.47,16.47,0,0,0-2.61.9l-3-1.74-3.6,2.08,3,1.72,0,0c-3,2.29-3.08,4.67.32,6.64a10.45,10.45,0,0,0,5,1.42h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3a8.09,8.09,0,0,1-.83.42,7.75,7.75,0,0,1-6,0L171.31,336a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.08-3-1.71c3-2.31,3.33-4.83-.16-6.88l-.06,0C183.14,324.73,179.88,325,177,325.69Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177,325.69h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.69,6.69,0,0,1-1.78.16,3.65,3.65,0,0,1-1.71-.51c-1.15-.66-1.32-1.64.36-2.74.12-.08.24-.16.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.23,14.23,0,0,0-8.23-.3,16.47,16.47,0,0,0-2.61.9l-3-1.74-3.6,2.08,3,1.72,0,0c-3,2.29-3.08,4.67.32,6.64a10.45,10.45,0,0,0,5,1.42h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3a8.09,8.09,0,0,1-.83.42,7.75,7.75,0,0,1-6,0L171.31,336a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.08-3-1.71c3-2.31,3.33-4.83-.16-6.88l-.06,0C183.14,324.73,179.88,325,177,325.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "158.75 321.92 162.38 320.27 165.36 321.58 162.35 319.85 158.75 321.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56,320.79a16.78,16.78,0,0,1,7.72.26l-2.09,3,3-3A14.23,14.23,0,0,0,167.56,320.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,326.55l.06,0c3.49,2.05,3.15,4.57.16,6.88,2.65-2.89,2.17-4.9-.71-6.56a13.58,13.58,0,0,0-8.82-1.21C179.88,325,183.14,324.73,186.29,326.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.51 333.46 188.79 335.21 185.89 337.25 189.48 335.18 186.51 333.46",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,332.83a7.78,7.78,0,0,1-5.73.5L171.31,336l3.15-3.17A7.75,7.75,0,0,0,180.45,332.83Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,327.94a4.69,4.69,0,0,1-4.31-.41c-1-.9-.37-1.85,1.18-2.68-1.68,1.1-1.51,2.08-.36,2.74a3.65,3.65,0,0,0,1.71.51A6.69,6.69,0,0,0,169.75,327.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.7,323.66c-.25.23-2.42,2.24-1.46,4.26s4.18,3.52,6.74,3.8h0a10.45,10.45,0,0,1-5-1.42C158.62,328.33,158.68,326,161.7,323.66Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.86,320.23a22.88,22.88,0,0,0-8.48-7.83c-13.85-8-36.3-8-50.16,0a22.92,22.92,0,0,0-8.47,7.83h-1.91v7.25h0c.26,5,3.7,10,10.36,13.88,13.86,8,36.31,8,50.16,0,6.66-3.85,10.14-8.84,10.39-13.88h0v-7.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.86,320.23a22.88,22.88,0,0,0-8.48-7.83c-13.85-8-36.3-8-50.16,0a22.92,22.92,0,0,0-8.47,7.83h-1.91v7.25h0c.26,5,3.7,10,10.36,13.88,13.86,8,36.31,8,50.16,0,6.66-3.85,10.14-8.84,10.39-13.88h0v-7.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,306.4c-9.08,0-18.16,2-25.09,6a22.92,22.92,0,0,0-8.47,7.83h-1.91v7.25h0c.26,5,3.7,10,10.36,13.88,6.93,4,16,6,25.09,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.93,309.73a39.34,39.34,0,0,0-5.71,2.67,22.92,22.92,0,0,0-8.47,7.83h-1.91v7.25h0c.26,5,3.7,10,10.36,13.88a39.34,39.34,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.67,309.73a38.85,38.85,0,0,1,5.71,2.67,22.88,22.88,0,0,1,8.48,7.83h1.91v7.25h0c-.25,5-3.73,10-10.39,13.88a38.85,38.85,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,305.76c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.87,44.6,2.62h0l.55-.21a39.28,39.28,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.76-24.61h0a27.1,27.1,0,0,0-5.75-4.34C192.53,297.76,170.08,297.76,156.22,305.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,305.76c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.87,44.6,2.62h0l.55-.21a39.28,39.28,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.76-24.61h0a27.1,27.1,0,0,0-5.75-4.34C192.53,297.76,170.08,297.76,156.22,305.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14,310.11a15.52,15.52,0,0,1,3.71,12.63c-1.23,7-11.08,13-14.48,14.39a39.28,39.28,0,0,0,5-2.41C217.93,328.05,219.85,317.93,212.14,310.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,330.37a15.53,15.53,0,0,1-3.71-12.64c1.23-7,11.08-13,14.48-14.38a38.73,38.73,0,0,0-5,2.41C144.67,312.43,142.76,322.55,150.47,330.37Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.32,
    cy: 320.21,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.32,
    cy: 320.21,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.79,325.9c2.65-4.9,1.78-10.3-2.59-14.88a21.81,21.81,0,0,0-2.79-2.45,28.7,28.7,0,0,0-2.67-1.76c-.53-.31-1.07-.6-1.63-.88,1.37,2.26.87,4.67-6.89,5.12-15.2.89,4.06,15.41,4.06,15.41S210.07,321.74,212.79,325.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,321.88c2.28-.26,3.41-2.6,2.53-5.24s-3.46-4.57-5.74-4.31-3.41,2.6-2.52,5.23S208.94,322.13,211.22,321.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,334c-.75-5.64-25.42-21.26-25.42-21.26s-5.47-2.2-3.65-6a27.9,27.9,0,0,0-2.64,1.7c-.57.41-1.11.84-1.61,1.27-7.34,6.36-7.35,14.71,0,21.08.49.43,1,.86,1.6,1.27a28.56,28.56,0,0,0,2.44,1.59c.84.49,1.71.95,2.62,1.37q1.08.51,2.22,1c.75.3,1.52.57,2.31.83a48.49,48.49,0,0,0,7.36,1.77c.55.09,1.1.17,1.66.24a56.27,56.27,0,0,0,7.36.46,54.93,54.93,0,0,0,9-.74S186.48,337.69,187.19,334Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.83,334c-.74-5.64-25.41-21.26-25.41-21.26s-5.47-2.2-3.66-6a27.71,27.71,0,0,0-2.63,1.7c-.57.41-1.11.84-1.61,1.27-7.34,6.36-7.35,14.71,0,21.08.49.43,1,.86,1.6,1.27a27.06,27.06,0,0,0,2.44,1.59c.84.49,1.71.95,2.61,1.37.72.34,1.47.66,2.23,1s1.52.57,2.31.83a48.21,48.21,0,0,0,7.36,1.77l1.65.24a56.38,56.38,0,0,0,7.36.46,55,55,0,0,0,9-.74S186.13,337.69,186.83,334Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94,310.18c-9.21,5.31-9.58,13.79-1.13,19.36.36.24.74.47,1.13.7,9.59,5.53,25.14,5.54,34.73,0s9.6-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C187.82,304.65,173.14,304.87,163.94,310.18Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94,310.18c-9.21,5.31-9.58,13.79-1.13,19.36.36.24.74.47,1.13.7,9.59,5.53,25.14,5.54,34.73,0s9.6-14.52,0-20.06c-.39-.22-.8-.44-1.21-.65C187.82,304.65,173.14,304.87,163.94,310.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.32,
    cy: 320.21,
    rx: 23.48,
    ry: 13.56,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.32,
    cy: 320.21,
    rx: 23.48,
    ry: 13.56,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,314.4c9.16-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.69,2.81-2.9,5.53-6.65,7.69-9.17,5.3-24,5.3-33.2,0-3.75-2.16-6-4.88-6.65-7.69C158.75,319.28,161,316.57,164.72,314.4Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,314.4c9.16-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.69,2.81-2.9,5.53-6.65,7.69-9.17,5.3-24,5.3-33.2,0-3.75-2.16-6-4.88-6.65-7.69C158.75,319.28,161,316.57,164.72,314.4Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,324.29c0-.45,0-2.32,0-2.8,0-1.15-.79-2.26-2.5-3.26l-.06,0c-3.15-1.82-6.41-1.58-9.31-.85h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.62,6.62,0,0,1-1.77.16,3.77,3.77,0,0,1-1.47-.38l.12-.09a4,4,0,0,1,.37-.22,6.89,6.89,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3v-2.78a14.24,14.24,0,0,0-8.23-.3,16.58,16.58,0,0,0-2.62.9l-3-1.74L166,313.56v2.79l1.23.71a3,3,0,0,0-.53,1.62c0,.46,0,2.32,0,2.78,0,1.15.83,2.26,2.56,3.26a10.5,10.5,0,0,0,5,1.43h0c.32,0,.66,0,1,0a20,20,0,0,0,5.33-1.15l1-.36-3,3v2.78a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08v-2.78l-1.24-.72A3.19,3.19,0,0,0,196.1,324.29Zm-7.57-.24a8.22,8.22,0,0,1-.84.42,7.75,7.75,0,0,1-5.87.09c2.81-1,5.16-1.86,7.16-.8A5,5,0,0,1,188.53,324.05Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.23,317.34h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.62,6.62,0,0,1-1.77.16,3.62,3.62,0,0,1-1.71-.51c-1.16-.66-1.32-1.64.36-2.74a4,4,0,0,1,.37-.23,8.14,8.14,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.24,14.24,0,0,0-8.23-.3,16.58,16.58,0,0,0-2.62.9l-3-1.74L166,313.56l3,1.72s0,0,0,0c-3,2.3-3.08,4.68.31,6.64a10.61,10.61,0,0,0,5,1.43h0c.32,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.44-1.15,6.24-2.51,8.56-1.17,1.55.9,1.12,2-.58,3a8.22,8.22,0,0,1-.84.42,7.68,7.68,0,0,1-6,0l-3.16,3.17a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.07-3-1.72c3-2.31,3.33-4.83-.16-6.87l-.06,0C190.39,316.37,187.13,316.61,184.23,317.34Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.23,317.34h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.62,6.62,0,0,1-1.77.16,3.62,3.62,0,0,1-1.71-.51c-1.16-.66-1.32-1.64.36-2.74a4,4,0,0,1,.37-.23,8.14,8.14,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.24,14.24,0,0,0-8.23-.3,16.58,16.58,0,0,0-2.62.9l-3-1.74L166,313.56l3,1.72s0,0,0,0c-3,2.3-3.08,4.68.31,6.64a10.61,10.61,0,0,0,5,1.43h0c.32,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.44-1.15,6.24-2.51,8.56-1.17,1.55.9,1.12,2-.58,3a8.22,8.22,0,0,1-.84.42,7.68,7.68,0,0,1-6,0l-3.16,3.17a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.07-3-1.72c3-2.31,3.33-4.83-.16-6.87l-.06,0C190.39,316.37,187.13,316.61,184.23,317.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "166 313.56 169.63 311.92 172.6 313.22 169.59 311.49 166 313.56",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,312.43a16.78,16.78,0,0,1,7.72.26l-2.08,3,3-3A14.26,14.26,0,0,0,174.8,312.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.54,318.19l.06,0c3.49,2,3.14,4.56.16,6.87,2.64-2.89,2.17-4.9-.71-6.56a13.51,13.51,0,0,0-8.82-1.2C187.13,316.61,190.39,316.37,193.54,318.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.76 325.1 196.03 326.85 193.14 328.89 196.73 326.82 193.76 325.1",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.69,324.47a7.69,7.69,0,0,1-5.72.5l-3.42,2.71,3.16-3.17A7.68,7.68,0,0,0,187.69,324.47Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,319.58a4.67,4.67,0,0,1-4.3-.41c-1-.89-.37-1.85,1.18-2.68-1.68,1.1-1.52,2.08-.36,2.74a3.62,3.62,0,0,0,1.71.51A6.62,6.62,0,0,0,177,319.58Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,315.3c-.26.23-2.42,2.24-1.47,4.26s4.19,3.53,6.75,3.8h0a10.61,10.61,0,0,1-5-1.43C165.87,320,165.93,317.6,169,315.3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,308.77a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83H140.1V316h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,308.77a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83H140.1V316h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,294.94c-9.08,0-18.16,2-25.08,6a22.77,22.77,0,0,0-8.47,7.83H140.1V316h0c.26,5,3.71,10,10.37,13.88,6.92,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,298.26a37.88,37.88,0,0,0-5.71,2.68,22.77,22.77,0,0,0-8.47,7.83H140.1V316h0c.26,5,3.71,10,10.37,13.88a38.85,38.85,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.94,298.26a38.35,38.35,0,0,1,5.71,2.68,22.92,22.92,0,0,1,8.47,7.83H211V316h0c-.26,5-3.73,10-10.39,13.88a39.34,39.34,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49,294.29c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.88,44.59,2.63h0l.55-.22a37.51,37.51,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.75-24.6h0a27.39,27.39,0,0,0-5.75-4.35C186.8,286.3,164.34,286.3,150.49,294.29Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49,294.29c-13.85,8-13.85,21,0,29,12.12,7,30.82,7.88,44.59,2.63h0l.55-.22a37.51,37.51,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.75-24.6h0a27.39,27.39,0,0,0-5.75-4.35C186.8,286.3,164.34,286.3,150.49,294.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,298.65a15.48,15.48,0,0,1,3.71,12.63c-1.23,7-11.08,13-14.48,14.38a37.51,37.51,0,0,0,5-2.41C212.2,316.59,214.12,306.46,206.4,298.65Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73,318.9A15.52,15.52,0,0,1,141,306.27c1.23-7,11.09-13,14.48-14.38a38,38,0,0,0-5,2.41C138.94,301,137,311.09,144.73,318.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,322.21c12.88-7.44,12.88-19.49,0-26.92s-33.75-7.44-46.62,0-12.88,19.48,0,26.92S186,329.64,198.89,322.21Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,322.21c12.88-7.44,12.88-19.49,0-26.92s-33.75-7.44-46.62,0-12.88,19.48,0,26.92S186,329.64,198.89,322.21Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,314.43c2.65-4.9,1.79-10.3-2.59-14.88a21.85,21.85,0,0,0-2.79-2.44,27.43,27.43,0,0,0-2.67-1.76c-.52-.31-1.06-.6-1.62-.88,1.37,2.25.87,4.67-6.9,5.12-15.2.89,4.06,15.41,4.06,15.41S204.34,310.27,207.05,314.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.49,310.41c2.28-.25,3.41-2.6,2.52-5.23s-3.45-4.57-5.73-4.32-3.42,2.6-2.53,5.24S203.2,310.67,205.49,310.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,322.52c-.75-5.65-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a30.07,30.07,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.27-7.35,6.36-7.35,14.71,0,21.08.5.43,1,.85,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.94,2.61,1.37.72.34,1.47.66,2.22,1s1.53.58,2.32.84a49.28,49.28,0,0,0,7.35,1.77l1.66.24a58.06,58.06,0,0,0,7.36.46,56,56,0,0,0,9-.74S180.74,326.23,181.45,322.52Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,322.52c-.75-5.65-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a30.07,30.07,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.27-7.35,6.36-7.36,14.71,0,21.08.5.43,1,.85,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.94,2.61,1.37.72.34,1.46.66,2.22,1s1.53.58,2.31.84a49.72,49.72,0,0,0,7.36,1.77l1.66.24a58.06,58.06,0,0,0,7.36.46,56,56,0,0,0,9-.74S180.39,326.23,181.1,322.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,298.72c-9.2,5.31-9.58,13.79-1.12,19.36.36.23.73.47,1.12.69,9.6,5.54,25.14,5.54,34.74,0s9.59-14.51,0-20c-.39-.23-.8-.44-1.21-.65C182.08,293.19,167.4,293.41,158.2,298.72Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,298.72c-9.2,5.31-9.58,13.79-1.12,19.36.36.23.73.47,1.12.69,9.6,5.54,25.14,5.54,34.74,0s9.59-14.51,0-20c-.39-.23-.8-.44-1.21-.65C182.08,293.19,167.4,293.41,158.2,298.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.58,
    cy: 308.75,
    rx: 23.48,
    ry: 13.56,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.58,
    cy: 308.75,
    rx: 23.48,
    ry: 13.56,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,302.94c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.17,5.29-24,5.29-33.2,0-3.75-2.16-6-4.88-6.65-7.69C153,307.82,155.23,305.11,159,302.94Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,302.94c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.17,5.29-24,5.29-33.2,0-3.75-2.16-6-4.88-6.65-7.69C153,307.82,155.23,305.11,159,302.94Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.36,312.83c0-.46,0-2.32,0-2.8,0-1.15-.8-2.27-2.51-3.27l-.06,0c-3.15-1.82-6.41-1.58-9.31-.85h0c-1.24.31-2.41.71-3.48,1.07a32.36,32.36,0,0,1-3.73,1.16h0a6.23,6.23,0,0,1-1.77.17,3.78,3.78,0,0,1-1.47-.39l.12-.08c.11-.08.24-.15.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.11l3-3v-2.79a14.4,14.4,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08v2.78l1.23.71a3,3,0,0,0-.53,1.63c0,.46,0,2.31,0,2.78,0,1.15.82,2.26,2.56,3.26a10.43,10.43,0,0,0,5,1.43h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15l1-.36-3,3V319a14.81,14.81,0,0,0,11.61-.5l3,1.71,3.59-2.07v-2.79l-1.23-.71A3.2,3.2,0,0,0,190.36,312.83Zm-7.57-.24a9.25,9.25,0,0,1-.83.42,7.72,7.72,0,0,1-5.88.08c2.81-1,5.16-1.86,7.17-.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,305.87h0c-1.24.31-2.41.71-3.48,1.07a32.36,32.36,0,0,1-3.73,1.16h0a6.23,6.23,0,0,1-1.77.17,3.77,3.77,0,0,1-1.71-.51c-1.15-.67-1.32-1.64.36-2.75l.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.4,14.4,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.43,10.43,0,0,0,5,1.43h0q.49,0,1,0a20,20,0,0,0,5.33-1.15c3.45-1.16,6.24-2.52,8.56-1.17,1.56.89,1.13,2-.58,3a9.25,9.25,0,0,1-.83.42,7.75,7.75,0,0,1-6,0l-3.15,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08-3-1.71c3-2.32,3.33-4.83-.16-6.88l-.06,0C184.65,304.9,181.39,305.14,178.49,305.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.49,305.87h0c-1.24.31-2.41.71-3.48,1.07a32.36,32.36,0,0,1-3.73,1.16h0a6.23,6.23,0,0,1-1.77.17,3.77,3.77,0,0,1-1.71-.51c-1.15-.67-1.32-1.64.36-2.75l.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.4,14.4,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.43,10.43,0,0,0,5,1.43h0q.49,0,1,0a20,20,0,0,0,5.33-1.15c3.45-1.16,6.24-2.52,8.56-1.17,1.56.89,1.13,2-.58,3a9.25,9.25,0,0,1-.83.42,7.75,7.75,0,0,1-6,0l-3.15,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08-3-1.71c3-2.32,3.33-4.83-.16-6.88l-.06,0C184.65,304.9,181.39,305.14,178.49,305.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "160.26 302.1 163.89 300.45 166.87 301.76 163.86 300.02 160.26 302.1",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.07,301a16.78,16.78,0,0,1,7.72.26l-2.09,3,3-3A14.3,14.3,0,0,0,169.07,301Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,306.72l.06,0c3.49,2.05,3.15,4.56.16,6.88,2.65-2.89,2.17-4.9-.71-6.56a13.58,13.58,0,0,0-8.82-1.21C181.39,305.14,184.65,304.9,187.8,306.72Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.02 313.64 190.3 315.39 187.4 317.43 190.99 315.35 188.02 313.64",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,313a7.78,7.78,0,0,1-5.73.5l-3.41,2.7,3.15-3.16A7.75,7.75,0,0,0,182,313Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.25,308.11a4.62,4.62,0,0,1-4.3-.41c-1-.89-.37-1.85,1.18-2.68-1.68,1.11-1.51,2.08-.36,2.75a3.77,3.77,0,0,0,1.71.51A6.23,6.23,0,0,0,171.25,308.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,303.84c-.25.22-2.42,2.24-1.46,4.25s4.18,3.53,6.74,3.81h0a10.43,10.43,0,0,1-5-1.43C160.13,308.51,160.19,306.13,163.21,303.84Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,295.05a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,295.05a22.92,22.92,0,0,0-8.47-7.83c-13.85-8-36.31-8-50.16,0a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.39-13.88h0v-7.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.59,281.22c-9.08,0-18.15,2-25.08,6a22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88,6.93,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,284.55a38.85,38.85,0,0,0-5.71,2.67,22.77,22.77,0,0,0-8.47,7.83h-1.92v7.25h0c.25,5,3.7,10,10.36,13.88a38.85,38.85,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,284.55a38.85,38.85,0,0,1,5.71,2.67,22.92,22.92,0,0,1,8.47,7.83h1.92v7.25h0c-.26,5-3.73,10-10.39,13.88a38.85,38.85,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,280.58c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.87,44.59,2.62h0l.54-.21a38.78,38.78,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.75-24.61h0a27.1,27.1,0,0,0-5.75-4.34C185.82,272.58,163.36,272.58,149.51,280.58Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,280.58c-13.85,8-13.85,21,0,29,12.12,7,30.83,7.87,44.59,2.62h0l.54-.21a38.78,38.78,0,0,0,5-2.41c11.55-6.67,13.47-16.79,5.75-24.61h0a27.1,27.1,0,0,0-5.75-4.34C185.82,272.58,163.36,272.58,149.51,280.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42,284.93a15.48,15.48,0,0,1,3.71,12.63c-1.22,7-11.08,13-14.48,14.39a38.78,38.78,0,0,0,5-2.41C211.22,302.87,213.14,292.75,205.42,284.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,305.19a15.49,15.49,0,0,1-3.71-12.64c1.22-7,11.08-13,14.47-14.38a38,38,0,0,0-5,2.41C138,287.25,136,297.37,143.76,305.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.6,
    cy: 295.03,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.6,
    cy: 295.03,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,300.71c2.66-4.89,1.79-10.29-2.58-14.87a21.92,21.92,0,0,0-2.8-2.45,26.27,26.27,0,0,0-2.67-1.76c-.52-.31-1.06-.6-1.62-.88,1.37,2.26.87,4.67-6.9,5.12-15.19.89,4.06,15.41,4.06,15.41S203.36,296.56,206.07,300.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51,296.7c2.28-.26,3.41-2.6,2.52-5.24s-3.45-4.57-5.73-4.31-3.41,2.6-2.53,5.23S202.23,297,204.51,296.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,308.8c-.75-5.64-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a27.9,27.9,0,0,0-2.64,1.7c-.57.41-1.1.84-1.6,1.27-7.34,6.36-7.35,14.71,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.84.49,1.71.95,2.61,1.37.72.34,1.47.66,2.22,1s1.53.57,2.32.83a47.93,47.93,0,0,0,7.36,1.77l1.65.24a56.38,56.38,0,0,0,7.36.46,54.93,54.93,0,0,0,9-.74S179.77,312.51,180.47,308.8Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,308.8c-.75-5.64-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a27.9,27.9,0,0,0-2.64,1.7c-.57.41-1.1.84-1.6,1.27-7.35,6.36-7.35,14.71,0,21.08.5.43,1,.86,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.95,2.61,1.37.72.34,1.47.66,2.22,1s1.53.57,2.32.83a48.08,48.08,0,0,0,7.35,1.77c.55.09,1.11.17,1.66.24a56.27,56.27,0,0,0,7.36.46,54.93,54.93,0,0,0,9-.74S179.41,312.51,180.12,308.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.22,285c-9.2,5.31-9.57,13.79-1.12,19.36.36.24.73.47,1.13.7,9.59,5.53,25.14,5.53,34.73,0s9.59-14.52,0-20.06c-.39-.22-.79-.44-1.2-.65C181.11,279.47,166.42,279.69,157.22,285Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.22,285c-9.2,5.31-9.57,13.79-1.12,19.36.36.24.73.47,1.13.7,9.59,5.53,25.14,5.53,34.73,0s9.59-14.52,0-20.06c-.39-.22-.79-.44-1.2-.65C181.11,279.47,166.42,279.69,157.22,285Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.6,
    cy: 295.03,
    rx: 23.48,
    ry: 13.56,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.6,
    cy: 295.03,
    rx: 23.48,
    ry: 13.56,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,289.22c9.17-5.29,24-5.29,33.21,0,3.74,2.17,6,4.88,6.64,7.7-.68,2.81-2.9,5.53-6.64,7.69-9.17,5.3-24,5.3-33.21,0-3.75-2.16-6-4.88-6.65-7.69C152,294.1,154.25,291.39,158,289.22Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,289.22c9.17-5.29,24-5.29,33.21,0,3.74,2.17,6,4.88,6.64,7.7-.68,2.81-2.9,5.53-6.64,7.69-9.17,5.3-24,5.3-33.21,0-3.75-2.16-6-4.88-6.65-7.69C152,294.1,154.25,291.39,158,289.22Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.39,299.11c0-.46,0-2.32,0-2.8,0-1.15-.8-2.26-2.51-3.27l-.06,0c-3.15-1.82-6.41-1.59-9.31-.85h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.65,6.65,0,0,1-1.78.16,4,4,0,0,1-1.47-.38l.12-.09.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3v-2.78a14.23,14.23,0,0,0-8.23-.3,16.82,16.82,0,0,0-2.61.9l-3-1.74-3.6,2.08v2.79l1.23.71a2.9,2.9,0,0,0-.52,1.62v2.78c0,1.15.83,2.26,2.56,3.26a10.46,10.46,0,0,0,5,1.43h1a20,20,0,0,0,5.33-1.15l1-.36-3,3v2.78a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08v-2.78l-1.23-.72A3.27,3.27,0,0,0,189.39,299.11Zm-7.58-.24a7.18,7.18,0,0,1-.83.42,7.77,7.77,0,0,1-5.88.09c2.82-1,5.17-1.86,7.17-.8A4,4,0,0,1,181.81,298.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,292.16h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.65,6.65,0,0,1-1.78.16,3.61,3.61,0,0,1-1.7-.51c-1.16-.66-1.33-1.64.35-2.74.12-.08.24-.16.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.23,14.23,0,0,0-8.23-.3,16.82,16.82,0,0,0-2.61.9l-3-1.74-3.6,2.08,3,1.72,0,0c-3,2.29-3.08,4.68.32,6.64a10.45,10.45,0,0,0,5,1.42h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3a7.18,7.18,0,0,1-.83.42,7.7,7.7,0,0,1-6,0l-3.15,3.17a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.07-3-1.72c3-2.31,3.33-4.83-.16-6.88l-.06,0C183.67,291.19,180.41,291.42,177.51,292.16Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.51,292.16h0c-1.24.31-2.41.71-3.48,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.65,6.65,0,0,1-1.78.16,3.61,3.61,0,0,1-1.7-.51c-1.16-.66-1.33-1.64.35-2.74.12-.08.24-.16.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.12l3-3a14.23,14.23,0,0,0-8.23-.3,16.82,16.82,0,0,0-2.61.9l-3-1.74-3.6,2.08,3,1.72,0,0c-3,2.29-3.08,4.68.32,6.64a10.45,10.45,0,0,0,5,1.42h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15c3.45-1.15,6.24-2.51,8.56-1.17,1.56.9,1.13,2-.58,3a7.18,7.18,0,0,1-.83.42,7.7,7.7,0,0,1-6,0l-3.15,3.17a14.76,14.76,0,0,0,11.61-.51l3,1.72,3.59-2.07-3-1.72c3-2.31,3.33-4.83-.16-6.88l-.06,0C183.67,291.19,180.41,291.42,177.51,292.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "159.29 288.38 162.91 286.74 165.89 288.04 162.88 286.31 159.29 288.38",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,287.25a16.78,16.78,0,0,1,7.72.26l-2.09,3,3-3A14.23,14.23,0,0,0,168.09,287.25Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,293l.06,0c3.49,2,3.15,4.57.16,6.88,2.65-2.89,2.17-4.9-.71-6.56a13.51,13.51,0,0,0-8.82-1.2C180.41,291.42,183.67,291.19,186.82,293Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.04 299.92 189.32 301.67 186.42 303.71 190.01 301.63 187.04 299.92",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,299.29a7.72,7.72,0,0,1-5.73.5l-3.41,2.71,3.15-3.17A7.7,7.7,0,0,0,181,299.29Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,294.4A4.69,4.69,0,0,1,166,294c-1-.9-.37-1.85,1.18-2.68-1.68,1.1-1.51,2.08-.35,2.74a3.61,3.61,0,0,0,1.7.51A6.65,6.65,0,0,0,170.28,294.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.23,290.12c-.25.23-2.41,2.24-1.46,4.26s4.18,3.53,6.74,3.8h0a10.45,10.45,0,0,1-5-1.42C159.15,294.8,159.21,292.41,162.23,290.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,283.2a22.92,22.92,0,0,0-8.47-7.83c-13.86-8-36.31-8-50.16,0a22.88,22.88,0,0,0-8.48,7.83H145v7.25h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.38-13.88h0V283.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,283.2a22.92,22.92,0,0,0-8.47-7.83c-13.86-8-36.31-8-50.16,0a22.88,22.88,0,0,0-8.48,7.83H145v7.25h0c.26,5,3.71,10,10.37,13.88,13.85,8,36.31,8,50.16,0,6.66-3.85,10.13-8.84,10.38-13.88h0V283.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,269.37c-9.08,0-18.16,2-25.08,6a22.88,22.88,0,0,0-8.48,7.83H145v7.25h0c.26,5,3.71,10,10.37,13.88,6.92,4,16,6,25.08,6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.08,272.69a37.88,37.88,0,0,0-5.71,2.68,22.88,22.88,0,0,0-8.48,7.83H145v7.25h0c.26,5,3.71,10,10.37,13.88a38.85,38.85,0,0,0,5.71,2.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,272.69a38.35,38.35,0,0,1,5.71,2.68A22.92,22.92,0,0,1,214,283.2h1.91v7.25h0c-.25,5-3.72,10-10.38,13.88a39.34,39.34,0,0,1-5.71,2.67Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,268.72c-13.86,8-13.85,21,0,29,12.12,7,30.82,7.88,44.59,2.63h0l.55-.22a38.11,38.11,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.75-24.6h0a27.65,27.65,0,0,0-5.75-4.35C191.68,260.73,169.22,260.73,155.37,268.72Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,268.72c-13.86,8-13.85,21,0,29,12.12,7,30.82,7.88,44.59,2.63h0l.55-.22a38.11,38.11,0,0,0,5-2.41c11.55-6.66,13.47-16.79,5.75-24.6h0a27.65,27.65,0,0,0-5.75-4.35C191.68,260.73,169.22,260.73,155.37,268.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,273.08A15.48,15.48,0,0,1,215,285.71c-1.23,7-11.08,13-14.48,14.38a38.11,38.11,0,0,0,5-2.41C217.08,291,219,280.89,211.28,273.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,293.33a15.48,15.48,0,0,1-3.71-12.63c1.23-7,11.09-13,14.48-14.38a38,38,0,0,0-5,2.41C143.82,275.39,141.9,285.52,149.61,293.33Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.46,
    cy: 283.18,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.46,
    cy: 283.18,
    rx: 32.97,
    ry: 19.04,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,288.86c2.65-4.9,1.79-10.3-2.59-14.88a22.56,22.56,0,0,0-2.79-2.44,28.7,28.7,0,0,0-2.67-1.76c-.53-.31-1.07-.6-1.62-.88,1.37,2.25.86,4.67-6.9,5.12-15.2.89,4.06,15.41,4.06,15.41S209.22,284.7,211.93,288.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,284.84c2.28-.25,3.41-2.6,2.53-5.23s-3.46-4.57-5.74-4.32-3.41,2.6-2.52,5.24S208.08,285.1,210.36,284.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,297c-.75-5.65-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a30.07,30.07,0,0,0-2.64,1.71c-.57.41-1.1.83-1.6,1.27-7.35,6.36-7.36,14.71,0,21.08.5.43,1,.85,1.6,1.27a28.76,28.76,0,0,0,2.45,1.59c.83.49,1.71.94,2.61,1.37.72.34,1.47.66,2.22.95s1.53.58,2.31.84a49.72,49.72,0,0,0,7.36,1.77l1.66.24a58.06,58.06,0,0,0,7.36.46,56,56,0,0,0,9-.74S185.62,300.66,186.33,297Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,297c-.75-5.65-25.42-21.27-25.42-21.27s-5.47-2.19-3.65-6a30.07,30.07,0,0,0-2.64,1.71,19,19,0,0,0-1.6,1.27c-7.35,6.36-7.36,14.71,0,21.08.49.43,1,.85,1.6,1.27a28.56,28.56,0,0,0,2.44,1.59c.84.49,1.72.94,2.62,1.37.72.34,1.46.66,2.22.95s1.53.58,2.31.84a49.72,49.72,0,0,0,7.36,1.77l1.66.24a58.06,58.06,0,0,0,7.36.46,56,56,0,0,0,9-.74S185.27,300.66,186,297Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.08,273.15c-9.2,5.31-9.58,13.79-1.12,19.36.35.23.73.47,1.12.69,9.59,5.54,25.14,5.54,34.74,0s9.59-14.51,0-20.05c-.39-.23-.8-.44-1.21-.65C187,267.62,172.28,267.84,163.08,273.15Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.08,273.15c-9.2,5.31-9.58,13.79-1.12,19.36.35.23.73.47,1.12.69,9.59,5.54,25.14,5.54,34.74,0s9.59-14.51,0-20.05c-.39-.23-.8-.44-1.21-.65C187,267.62,172.28,267.84,163.08,273.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,273.59c-9.17,5.29-9.17,13.88,0,19.17s24,5.29,33.2,0,9.17-13.88,0-19.17S173,268.3,163.86,273.59Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,273.59c-9.17,5.29-9.17,13.88,0,19.17s24,5.29,33.2,0,9.17-13.88,0-19.17S173,268.3,163.86,273.59Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,277.37c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.17,5.29-24,5.29-33.2,0-3.75-2.16-6-4.88-6.65-7.69C157.89,282.25,160.11,279.54,163.86,277.37Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,277.37c9.17-5.29,24-5.29,33.2,0,3.75,2.17,6,4.88,6.65,7.7-.68,2.81-2.9,5.53-6.65,7.69-9.17,5.29-24,5.29-33.2,0-3.75-2.16-6-4.88-6.65-7.69C157.89,282.25,160.11,279.54,163.86,277.37Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,287.26c0-.46,0-2.32,0-2.8,0-1.15-.8-2.27-2.51-3.27l-.06,0c-3.15-1.82-6.41-1.58-9.31-.85h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.23,6.23,0,0,1-1.77.17,3.78,3.78,0,0,1-1.47-.39l.12-.08c.11-.08.24-.15.37-.23a9,9,0,0,1,1-.49,6.81,6.81,0,0,1,5.22-.11l3-3v-2.79a14.41,14.41,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08v2.78l1.23.71a3,3,0,0,0-.53,1.63c0,.46,0,2.31,0,2.78,0,1.15.82,2.26,2.56,3.26a10.43,10.43,0,0,0,5,1.43h0c.33,0,.66,0,1,0a19.6,19.6,0,0,0,5.33-1.15l1-.35-3,3v2.79a14.81,14.81,0,0,0,11.61-.5l3,1.71,3.59-2.07v-2.79l-1.23-.71A3.2,3.2,0,0,0,195.24,287.26Zm-7.57-.24a8.22,8.22,0,0,1-.84.42,7.7,7.7,0,0,1-5.87.08c2.81-1,5.16-1.86,7.16-.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,280.3h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.23,6.23,0,0,1-1.77.17,3.74,3.74,0,0,1-1.71-.51c-1.15-.67-1.32-1.64.36-2.75l.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.41,14.41,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.43,10.43,0,0,0,5,1.43h1a20,20,0,0,0,5.33-1.15c3.45-1.16,6.24-2.52,8.56-1.17,1.56.89,1.13,2-.58,3a8.22,8.22,0,0,1-.84.42,7.72,7.72,0,0,1-6,0l-3.15,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08-3-1.71c3-2.32,3.33-4.83-.16-6.88l-.06,0C189.53,279.33,186.27,279.57,183.37,280.3Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.37,280.3h0c-1.23.31-2.4.71-3.47,1.08a34.13,34.13,0,0,1-3.73,1.15h0a6.23,6.23,0,0,1-1.77.17,3.74,3.74,0,0,1-1.71-.51c-1.15-.67-1.32-1.64.36-2.75l.37-.22a7.46,7.46,0,0,1,1-.49,6.77,6.77,0,0,1,5.22-.12l3-3a14.41,14.41,0,0,0-8.23-.3,18.12,18.12,0,0,0-2.62.91l-3-1.74-3.59,2.08,3,1.71,0,0c-3,2.29-3.08,4.67.32,6.63a10.43,10.43,0,0,0,5,1.43h1a20,20,0,0,0,5.33-1.15c3.45-1.16,6.24-2.52,8.56-1.17,1.56.89,1.13,2-.58,3a8.22,8.22,0,0,1-.84.42,7.72,7.72,0,0,1-6,0l-3.15,3.16a14.76,14.76,0,0,0,11.61-.5l3,1.72,3.59-2.08-3-1.71c3-2.32,3.33-4.83-.16-6.88l-.06,0C189.53,279.33,186.27,279.57,183.37,280.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "165.14 276.53 168.77 274.88 171.74 276.19 168.73 274.45 165.14 276.53",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.94,275.4a16.82,16.82,0,0,1,7.73.26l-2.09,3,3-3A14.33,14.33,0,0,0,173.94,275.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,281.15l.06,0c3.49,2.05,3.15,4.56.16,6.88,2.65-2.89,2.17-4.9-.71-6.56a13.59,13.59,0,0,0-8.82-1.21C186.27,279.57,189.53,279.33,192.68,281.15Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.9 288.07 195.18 289.82 192.28 291.86 195.87 289.78 192.9 288.07",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.83,287.44a7.75,7.75,0,0,1-5.72.5l-3.41,2.7,3.15-3.16A7.72,7.72,0,0,0,186.83,287.44Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,282.54a4.62,4.62,0,0,1-4.3-.41c-1-.89-.37-1.85,1.18-2.68-1.68,1.11-1.51,2.08-.36,2.75a3.74,3.74,0,0,0,1.71.51A6.23,6.23,0,0,0,176.13,282.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,278.27c-.26.22-2.42,2.24-1.46,4.25s4.18,3.53,6.74,3.81h0a10.43,10.43,0,0,1-5-1.43C165,282.94,165.07,280.56,168.09,278.27Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.82,322s-7.32,13.11-8.49,18.49c-1.22,5.61-2.92,7.27-2.94,13.57,0,1.37.29,4.17.29,5.28a1.64,1.64,0,0,1-1.81,1.78c-2.59.13-6-5.11-7.18-10.43a145.76,145.76,0,0,1-2.1-18.44,7.77,7.77,0,0,1,1.43-3.84,12.49,12.49,0,0,1,1.48-1.87c1.23-2.34,2.39-7,3.61-10.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85,336.64a6.13,6.13,0,0,0-1,1.75c-.24,1.12,1.76,5.24,2.56,6.74a9,9,0,0,1,.84,6.72c-.73,3.59.34,7.31,2.24,10.65a25.33,25.33,0,0,0,11.29,10c5.79,2.75,8.42.09,8.42.09s2.35-2.58,1.41-3.93S189.85,336.64,189.85,336.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,326.52c-.18,0-.5-.14-1.07.35-.21.19-1.75,2.7-2.9,4s-4,3.57-4.68,5.8c.7,4.63,4.43,8.35,4.39,12.62s-.75,9.11,5,15.21,12.36,7.64,15,6.66,2.83-3.55.23-8.9c-2.75-5.67-3.36-17.15-3.36-17.15a35.24,35.24,0,0,1,.13-4.82,30.4,30.4,0,0,1,1.21-4.61,3.5,3.5,0,0,0,0-2.17,3.76,3.76,0,0,0-1.61-1.49,16.14,16.14,0,0,0-3.18-1.62,5.48,5.48,0,0,0-3.53-.12c-.82.28-1.54.82-2.39,1a3.15,3.15,0,0,1-3.12-1,2.59,2.59,0,0,1-.4-3A6,6,0,0,1,198.5,326.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,359.8s3.35-4.67,10.3-3.58,8.79,4.9,9.52,7.1c.87,2.62,1.47,7.21-1.6,8-3.32.89-6.84-.08-12-3.71S196.05,359.8,196.05,359.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,339.49a.71.71,0,0,0,.63.1c1.16-.37,7-.68,9.86,2.83.48-.27.49-.9.08-1.85-3.48-3-9-2.73-10.43-2.28a.65.65,0,0,0-.42.86A.73.73,0,0,0,200.63,339.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,346.5a2.06,2.06,0,0,0-.1-1.93c-3.49-2.61-8.65-2.36-10-1.93a.66.66,0,0,0-.42.87.78.78,0,0,0,.28.34.7.7,0,0,0,.63.09C202.72,343.58,208.29,343.3,211.19,346.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.54,356.12a3.89,3.89,0,0,0-.49-2.6c-3.49-2.86-8.91-2.61-10.3-2.16a.65.65,0,0,0-.41.86.72.72,0,0,0,.27.35.76.76,0,0,0,.64.09C203.47,352.27,209.94,352,212.54,356.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.29,348.21a.73.73,0,0,0,.63.09c1.15-.37,6.9-.66,9.75,2.73a2.37,2.37,0,0,0-.25-2.11c-3.49-2.61-8.65-2.35-10-1.92a.67.67,0,0,0-.14,1.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,342s.68,13,1.28,23c.44,7.29,6,10.57,10.52,15.37,1,1,3.25,3,4.06,3.81a1.69,1.69,0,0,1-.09,2.63c-1.9,1.91-10.18,2.71-14.94-.51s-9.25-10.32-12.11-13c-1.08-1-2.1-2-3.07-3.08s-.72-2.08-.84-3.29c-.06-.58,0-2.19,0-2.19-.73-2.83-2.92-11.5-3.93-14.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.87,377.69a6,6,0,0,0,.28,2.06c.5,1.09,4.78,3.32,6.41,4.09A9.56,9.56,0,0,1,217.5,389c1.65,3.46,4.9,5.93,8.61,7.57A27.23,27.23,0,0,0,242,398c6.64-1.22,7.19-5.06,7.19-5.06s.35-3.61-1.3-4.17S205.87,377.69,205.87,377.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,363.91c-.18.08-.52.19-.69.95-.06.28.22,3.33,0,5.1s-1.13,5.44-.29,7.73c3.5,3.46,9,4.3,11.66,7.9s5.11,8.11,13.79,9.73,15.28-1.14,16.89-3.57.15-4.71-5.41-7.62c-5.9-3.08-13.65-12.33-13.65-12.34a37.18,37.18,0,0,1-2.93-4.13,32.64,32.64,0,0,1-1.89-4.6,3.62,3.62,0,0,0-1.33-1.84,3.86,3.86,0,0,0-2.29-.27,16.58,16.58,0,0,0-3.72.58,5.73,5.73,0,0,0-3.06,2.06,26.49,26.49,0,0,1-1.37,2.31,3.34,3.34,0,0,1-3.3,1,2.74,2.74,0,0,1-2.25-2.29A7.27,7.27,0,0,1,206.81,363.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,393.34s-.1-6,6.45-9.3,10.53-1.26,12.53.14c2.39,1.67,5.79,5.16,3.71,7.73-2.24,2.77-5.83,4.11-12.51,4.24S225.7,393.34,225.7,393.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,373.5a.81.81,0,0,0,.6-.31c.74-1,5.52-4.86,10.11-3.64.24-.53-.14-1.06-1.09-1.61-4.83-.39-9.36,3.22-10.26,4.46a.67.67,0,0,0,.19,1A.89.89,0,0,0,216.78,373.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.12,372.92a2.2,2.2,0,0,0-1.3-1.56c-4.59-.06-8.8,3.31-9.66,4.49a.67.67,0,0,0,.19,1,.75.75,0,0,0,.45.12.76.76,0,0,0,.6-.31C221.12,375.65,225.66,372,230.12,372.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33,380.17a4.13,4.13,0,0,0-2.05-1.88c-4.76-.27-9.18,3.26-10.07,4.48a.67.67,0,0,0,.19,1,.89.89,0,0,0,.45.12.79.79,0,0,0,.6-.31C227.23,382.48,232.51,378.27,237.33,380.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83,380.41a.77.77,0,0,0,.59-.31c.74-1,5.42-4.77,10-3.67a2.5,2.5,0,0,0-1.54-1.61c-4.6-.06-8.8,3.31-9.67,4.49a.68.68,0,0,0,.2,1A.71.71,0,0,0,222.83,380.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,242.39s27.36,15.43,40.05,28.47c4.54,4.66,7.37,8.76,2.67,20.9-3.61,9.35-9.88,19.68-15.67,31.78l-56.05-65.66Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,242.39s27.36,15.43,40.05,28.47c4.54,4.66,7.37,8.76,2.67,20.9-3.61,9.35-9.88,19.68-15.67,31.78l-56.05-65.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.75,321.91c-8.7-7.83-36.15-52.76-36.15-52.76l1.23-.2c6.73-3,9.47-12.11,9.47-12.11.83,3.64-.65,8.84-2.9,11.64,3.82,2.78,12.44,9.07,25.68,18.93,2.31,1.71,7,5,6.69,11.38-.35,8.4-.59,16.65-.59,16.65Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,242.39h0L138.15,253.2c0,6.62.4,16.54,5.42,24,3.64,5.39,7.65,8.66,21.74,16,13.13,6.86,24.88,12.56,27.88,14.17,2.27,1.2,1.86,6.27,2.57,12.23.73,6.26,1.41,9.74,4.88,23.08,1.69,6.49,3.43,12.09,3.43,12.09s10.93,1.18,19.05-3.2c0,0-1.42-32.85-1.87-40.91-.38-6.89.06-13.3-5.22-18.42-4.53-4.39-32.2-23.28-32.2-23.28S195.71,254.7,191,242.39Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,242.39h0L138.15,253.2c0,6.62.4,16.54,5.42,24,3.64,5.39,7.65,8.66,21.74,16,13.13,6.86,24.88,12.56,27.88,14.17,2.27,1.2,1.86,6.27,2.57,12.23.73,6.26,1.41,9.74,4.88,23.08,1.69,6.49,3.43,12.09,3.43,12.09s10.93,1.18,19.05-3.2c0,0-1.42-32.85-1.87-40.91-.38-6.89.06-13.3-5.22-18.42-4.53-4.39-32.2-23.28-32.2-23.28S195.71,254.7,191,242.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,251.16l.77-.11c.33,9.06,1.6,15.94,8.15,22.59,4.15-2.82,3.29-5.42,1.72-10.07-.47-1.4-1-3-1.46-4.78A47.62,47.62,0,0,1,150.8,250l.77-.12A46.11,46.11,0,0,0,153,258.6c.45,1.76,1,3.34,1.44,4.72,1.57,4.64,2.6,7.75-1.89,10.87a44.23,44.23,0,0,0,5.31,4.35c9.77,6.92,23.55,15,31.78,19.87,2.88,1.69,5.15,3,6.33,3.77,4.77,3,4.91,4.81,4.76,12.8-.12,7,4.75,30.36,7.23,39.92h-.79c-2.51-9.75-7.33-32.93-7.2-39.93.14-8.1-.12-9.44-4.41-12.15-1.16-.73-3.43-2.07-6.3-3.76-8.25-4.84-22-13-31.84-19.89C145.43,270.68,143.51,262.65,143.08,251.16Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-248",
    d: "M179,184.74c9.2,0,12.32,5.41,13.13,10.45C193.07,201,194,215,194,215l13.2,10.69-8.08,10.73s-10.17-5.28-14.21-7.69c-4.94-2.94-4.72-5-5.25-13S178.53,189.3,179,184.74Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,261.75c.22-2.24-.61-23.11,1.46-40.35.66-5.52,3.08-28.32,4.53-32.44l11-2.85s9.5-1,21.24-1.33l3.46,0c.73.77,11.22,9.37,14.48,18.72,1.85,5.32,2.38,14.29-3.85,18.94,0,0-.93,9.32-.93,9.39s3.09,9.29,4,11.36c-1.44,9.19-9.8,16.93-25.41,20.18C148.6,267.23,138.5,262.45,137.35,261.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,261.75c.22-2.24-.61-23.11,1.46-40.35.66-5.52,3.08-28.32,4.53-32.44l11-2.85s9.5-1,21.24-1.33l3.46,0c.73.77,11.22,9.37,14.48,18.72,1.85,5.32,2.38,14.29-3.85,18.94,0,0-.93,9.32-.93,9.39s3.09,9.29,4,11.36c-1.44,9.19-9.8,16.93-25.41,20.18C148.6,267.23,138.5,262.45,137.35,261.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,227.42s-4.49,5.43-13.29,4.36a16.29,16.29,0,0,1-12.5-8.26s1.23,9.47,12.09,10.79A13.11,13.11,0,0,0,177.1,227.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.77,272.32l.07,1a3,3,0,0,0,1.63,2.46l29.1,14.31a3,3,0,0,0,1.49.29,2.86,2.86,0,0,0,1.45-.49L251,256.88a3,3,0,0,0,1.31-2.64l0-.72-52.33,34.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.27,253.52,220.62,237.9a1.74,1.74,0,0,0-1.75.12L168,272a.39.39,0,0,0,0,.68l31.95,15.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.49 285.89 182.42 277.48 228.71 246.57 245.86 254.93 199.49 285.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.68 260.03 189.99 260.18 198.36 264.31 212.16 255.1 212.45 254.91 203.77 250.62 189.68 260.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.99 260.18 198.36 264.31 212.16 255.1 203.79 250.97 189.99 260.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.94,288.46l.12,2a2.86,2.86,0,0,0,1.45-.49L251,256.88a3,3,0,0,0,1.31-2.64l0-.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.94,288.46l.12,2a2.86,2.86,0,0,0,1.45-.49L251,256.88a3,3,0,0,0,1.31-2.64l0-.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.18,247.42c-1.6-2.32-3.59-4.39-5-6.81a40.05,40.05,0,0,0-4.71-4.3c-4.84-3.58-6.1-3.51-12.24-5.57a26.59,26.59,0,0,1-9-5.05l-8.08,10.73q1.35.79,2.61,1.59c1.37.88,3.13,4,6.25,5.24,4.14,1.64,9.05.64,9.5,1.85a8.51,8.51,0,0,0,.28,2.27,7.74,7.74,0,0,0-2.43-.67c-.76,0-1.87.86-1.66,1.4s.69.75,1.24,1.19c.37.31,1.65,1.38,1.82,1.5a7.46,7.46,0,0,0,3.89.67,1.7,1.7,0,0,0,1.29-1.09,6.47,6.47,0,0,0,.89.33,2.32,2.32,0,0,0,1.7-.08,1.39,1.39,0,0,0,.56-.8,6.82,6.82,0,0,0,2-.38c.93-.5,1-1.64,1.14-2.55a11.4,11.4,0,0,0,.18-3.45c2.76,1.75,4.87,4.95,8.24,5.6C237.92,249.22,239.48,248.79,238.18,247.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.68,236.71c1.44-13.43,2.84-25.59,4.94-35.43,1.16-5.43,5-11.23,12.72-12.32,7.52,4.64,5.42,20.3,4.66,24.11l-4.17,23.66s4.69,3.62,11.55,8c5.79,3.69,9.59,6.68,16.17,7s9.21-.05,12.71,1.21c1.87.67,6.12,2.22,7.58,2.84s4.15,3,6.6,4.57-.36,2.76-2.11,2.37a22.28,22.28,0,0,1-5.29-2.14,29.71,29.71,0,0,0-4.51-1.4,26.42,26.42,0,0,1,1.27,5.08c.07.94.35,2.06-.42,2.8a7.23,7.23,0,0,1-1.91.94,1.44,1.44,0,0,1-.33.94,2.41,2.41,0,0,1-1.64.54,8.45,8.45,0,0,1-1-.08,1.72,1.72,0,0,1-1,1.42,7.5,7.5,0,0,1-4,.4c-.2-.06-1.74-.77-2.19-1a3.94,3.94,0,0,1-1.54-.83c-.36-.47.48-1.66,1.24-1.83a7.83,7.83,0,0,1,2.56,0,8.85,8.85,0,0,1-.89-2.14c-.77-1.07-5.7.4-10.21-.08-3.4-.36-6-3.39-7.59-4-10-3.72-15.7-5.21-25.87-10.45C123.8,246.17,124.93,243.69,125.68,236.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,259.44c-.6-1.24-1.49-2.7-2.48-3a11.63,11.63,0,0,1,1.6,2.73Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.47,268a10.72,10.72,0,0,0-.1-2.77,25.15,25.15,0,0,0-.54-2.72,12.39,12.39,0,0,0-.93-2.64,5.11,5.11,0,0,0-1.8-2.1,3.94,3.94,0,0,1,.83,1.07,8.51,8.51,0,0,1,.6,1.21,18.08,18.08,0,0,1,.78,2.59c.24.89.44,1.78.66,2.66A25.11,25.11,0,0,1,185.47,268Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.53,269.41a12.41,12.41,0,0,0-.18-2.72,21.72,21.72,0,0,0-.58-2.66,18.43,18.43,0,0,0-.92-2.58,5.19,5.19,0,0,0-1.54-2.24,3.7,3.7,0,0,1,.69,1.14c.18.41.33.83.47,1.25.28.85.55,1.71.79,2.57C181.74,265.9,182.2,267.63,182.53,269.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,267.61a4.64,4.64,0,0,1,1.14.08c.36.06.63.23,1.1.35l-.21-.29a1.27,1.27,0,0,0,.11.54,1.64,1.64,0,0,0,.29.4,1.62,1.62,0,0,0,.79.45,4.65,4.65,0,0,1-.5-.67,3.19,3.19,0,0,1-.14-.35.9.9,0,0,1,0-.31v-.21l-.22-.07a3.28,3.28,0,0,0-1.07-.15A2.25,2.25,0,0,0,175.08,267.61Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.79,288.84a3.49,3.49,0,0,0,3-.42l49.29-32.91A3.52,3.52,0,0,0,254.6,253l3.43-33.8a3.62,3.62,0,0,0,0-.57,3.48,3.48,0,0,0-1.19-2.41l-51.22,34.2a2.6,2.6,0,0,0-1.14,1.88Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.79,288.84a3.49,3.49,0,0,0,3-.42l49.29-32.91A3.52,3.52,0,0,0,254.6,253l3.43-33.8a3.62,3.62,0,0,0,0-.57,3.48,3.48,0,0,0-1.19-2.41l-51.22,34.2a2.6,2.6,0,0,0-1.14,1.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.94,288.47l.36.17a3,3,0,0,0,.49.2l3.7-36.58a2.6,2.6,0,0,1,1.14-1.88l51.22-34.2a3.5,3.5,0,0,0-.75-.5L204.78,250a2.6,2.6,0,0,0-1.14,1.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.62,256.1c.23-2.27,2.35-5.39,4.73-7s4.13-1.05,3.9,1.22-2.35,5.38-4.73,7S227.4,258.36,227.62,256.1Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,146.42c-.06.26-1.53,1-1.8,1.26a7.93,7.93,0,0,0-1.39,1.56,11.5,11.5,0,0,0-1.6,4.19c-.5,2.51-.44,5.07-.7,7.6a48.77,48.77,0,0,1-1.47,7.25,24.73,24.73,0,0,0-1,6.42,8.33,8.33,0,0,0,2.28,5.93,14,14,0,0,1,.16-6.5,13.14,13.14,0,0,0,.72,4,9.4,9.4,0,0,0,4.33,4.56,24,24,0,0,0,6,2.1A43.63,43.63,0,0,0,165,186a63,63,0,0,0,6.44-.36,18.45,18.45,0,0,0,8-2.27c2.36-1.47,4.17-4.1,4-6.87a8.07,8.07,0,0,1,1,4.46,8.78,8.78,0,0,0,2.25-6.13,15.31,15.31,0,0,0-1.66-6.44,31.21,31.21,0,0,1-1.77-3.86,5.49,5.49,0,0,1-.07-3.79c.39-.78,1-1.49,1.44-2.3a14.17,14.17,0,0,0,1.79-7.08c-.25-5.09-3.09-11.8-12.32-14.09C166.27,135.38,151.38,136.43,149.05,146.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.62,172.66a5.82,5.82,0,0,1-5.13-2.17c-2.63-3.09-2.75-6.12-1.39-8.08,1.13-1.61,3.77-2.55,5.54-1.36s1.91,2.26,2.59,3.64,2.61.41,2.21-5.05c3.85-1.58,3.51-7.82,5.66-10.27,3.36-3.83,8.58-2.57,10.25-1.56a7,7,0,0,1,7.19-.15c2.48,1.45,4.05,4.33,4.53,14,.49,9.88-1.52,16.36-3.92,18.35-1.66,1.37-4.66,2.21-8.17,1.86l-.14,3.71s9.73,10.86-3.21,9.36a20.48,20.48,0,0,1-14.36-8.82l.56-14.92S154.57,172.39,152.62,172.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,171.84a2.91,2.91,0,0,1-3.5,2.09,2.87,2.87,0,0,1-2.14-3.45Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.32,171.41a2.85,2.85,0,0,0,2.19,2.52,2.93,2.93,0,0,0,1,0A2.93,2.93,0,0,0,168.32,171.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,155.39,177.85,154a1.92,1.92,0,0,1,2.49-1.17A2,2,0,0,1,181.54,155.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,153.71,164,155.53a2,2,0,0,1,.9-2.76A2.25,2.25,0,0,1,167.76,153.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.23,156.61l-.74-.09a22.63,22.63,0,0,0-7.38.24c-2.34.68-3.15,1.44-4.45,1.45s-2.3-.77-4.83-1.45a25.91,25.91,0,0,0-7.89-.22l-.79.08a1.17,1.17,0,0,0-.85,1.25,2.94,2.94,0,0,0,.79,1.46,1.74,1.74,0,0,1,.28.58,24.33,24.33,0,0,0,1.06,4,5.32,5.32,0,0,0,1,1.44,4.33,4.33,0,0,0,.53.43l.3.19a5.79,5.79,0,0,0,.9.4l.15,0,.23.07.25.06a6,6,0,0,0,.79.11c.1,0,.22,0,.33,0h.42c3.24,0,4.56-1.46,5.32-3s.51-3.67,2-3.66h.14l.13,0c1.11.25,1,2.22,1.76,3.64a6.15,6.15,0,0,0,1.09,1.55l.26.24.14.11.14.11.13.09.14.09.12.07.07,0a5.18,5.18,0,0,0,1.31.5l.12,0a6.9,6.9,0,0,0,1.58.15,4.41,4.41,0,0,0,4.51-2.78,25.29,25.29,0,0,0,.82-4,1.11,1.11,0,0,1,.27-.53,2.65,2.65,0,0,0,.64-1.48A1.26,1.26,0,0,0,186.23,156.61Zm-15.41,5.68a4.29,4.29,0,0,1-1.07,2.12h0a4.6,4.6,0,0,1-3.5,1.21,4.17,4.17,0,0,1-3.44-1.55l-.11-.15-.1-.15-.09-.14s0-.08-.07-.13a.31.31,0,0,1-.05-.1.41.41,0,0,1,0-.09,1,1,0,0,1-.07-.15h0c-.07-.16-.13-.3-.18-.45h0l-.09-.26c-.05-.16-.09-.31-.12-.43s0-.06,0-.09l0-.07c-.28-1.07-.63-3.15-.08-3.62s2-1,4.42-.74l.26,0a10.68,10.68,0,0,1,1.11.18l.43.1a10.52,10.52,0,0,1,1.08.34l.33.13a3,3,0,0,1,.36.16l.07,0,.13.07a2.36,2.36,0,0,1,.74.56C171.18,159.73,171.07,161.11,170.82,162.29Zm14.06-.46a4.41,4.41,0,0,1-2.2,3.4,4.78,4.78,0,0,1-5.43-1.21v0l-.07-.09-.07-.12,0-.06-.1-.16-.1-.2a1,1,0,0,1,0-.1l0-.05,0-.08,0-.06a7.71,7.71,0,0,1-.25-.79c-.27-1.18-.44-2.56,0-3.21s2.2-1.37,3.91-1.58a11,11,0,0,1,1.1-.07h.8l.18,0a2.53,2.53,0,0,1,.3,0c.2,0,.39.06.56.09l.14,0h0l.09,0,.13,0,.16,0,.27.1,0,0a2.62,2.62,0,0,1,.6.36C185.33,158.68,185.09,160.77,184.88,161.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,167.08l-5.6,2.09-.87-7c.25-1,.49-2.08,1.4-2.13Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,157.43l-8.65,3.62a8.93,8.93,0,0,1,1.26,1.09l7.53-3Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,160.89c.28.87-.34,1.14-1.18,1.4s-1.59.41-1.86-.46a1.59,1.59,0,1,1,3-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,160.07a4.12,4.12,0,0,1,1.2-.39,3.45,3.45,0,0,1,1.24,0,4,4,0,0,1,1.24.41s.06.11,0,.1c-.34,0-.64-.11-1.12-.14a5.41,5.41,0,0,0-1.39.12,5.54,5.54,0,0,0-1.58.53l-.52.26c-.05,0-.08-.09-.06-.13A2.74,2.74,0,0,1,178.5,160.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.25,160.77c-.23.88.39,1.12,1.24,1.34s1.61.33,1.84-.55a1.59,1.59,0,1,0-3.08-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,159.81a4.31,4.31,0,0,0-1.23-.33,3.19,3.19,0,0,0-1.23,0,3.8,3.8,0,0,0-1.22.47s-.05.11,0,.1a8.74,8.74,0,0,1,1.11-.2,5.89,5.89,0,0,1,1.39.05,5.78,5.78,0,0,1,1.61.45l.53.24c.05,0,.08-.1.05-.13A2.84,2.84,0,0,0,168,159.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172,181.88c-5.07-.41-11.8-2.47-13.49-5.77.87,3.51,4.37,5.46,7.19,6.37a30,30,0,0,0,6.17,1.33Z",
    style: {
      fill: "#f28f8f"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagemoneyAmico);
export default __webpack_public_path__ + "static/media/Manage money-amico.6c9d93be6535d3d9bc1c889f64c289dc.svg";
export { ForwardRef as ReactComponent };